import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: any; output: any; }
  CustomData: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: any; output: any; }
  IntType: { input: any; output: any; }
  ItemId: { input: any; output: any; }
  JsonField: { input: any; output: any; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

export type AboutUsBlockModelAboutUsContentField = {
  __typename?: 'AboutUsBlockModelAboutUsContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type AboutUsBlockModelAboutUsDescriptionField = {
  __typename?: 'AboutUsBlockModelAboutUsDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type AboutUsBlockModelAboutUsTitleField = {
  __typename?: 'AboutUsBlockModelAboutUsTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type About us block (about_us_block) */
export type AboutUsBlockRecord = RecordInterface & {
  __typename?: 'AboutUsBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  aboutUsButton: ButtonRecord;
  aboutUsContent: AboutUsBlockModelAboutUsContentField;
  aboutUsDescription: AboutUsBlockModelAboutUsDescriptionField;
  aboutUsIcons: Array<IconLinkRecord>;
  aboutUsImage: FileField;
  aboutUsTitle: AboutUsBlockModelAboutUsTitleField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type About us block (about_us_block) */
export type AboutUsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum AcademyChapterModelFieldsReferencingAcademySectionModel {
  AcademyChapter_section = 'academyChapter_section'
}

export type AcademyChapterModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademyChapterModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademyChapterModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  banner?: InputMaybe<FileFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  section?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AcademyChapterModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type AcademyChapterPartModelDescriptionField = {
  __typename?: 'AcademyChapterPartModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Linking fields */
export enum AcademyChapterPartModelFieldsReferencingAcademyChapterModel {
  AcademyChapterPart_chapter = 'academyChapterPart_chapter'
}

export type AcademyChapterPartModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademyChapterPartModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademyChapterPartModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  chapter?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  descriptionDeprecated?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AcademyChapterPartModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  DescriptionDeprecated_ASC = 'descriptionDeprecated_ASC',
  DescriptionDeprecated_DESC = 'descriptionDeprecated_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Academy chapter part (academy_chapter_part) */
export type AcademyChapterPartRecord = RecordInterface & {
  __typename?: 'AcademyChapterPartRecord';
  _allReferencingAcademyResources: Array<AcademyResourceRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingAcademyResourcesMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  chapter?: Maybe<AcademyChapterRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<AcademyChapterPartModelDescriptionField>;
  descriptionDeprecated?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Academy chapter part (academy_chapter_part) */
export type AcademyChapterPartRecord_AllReferencingAcademyResourcesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyResourceModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAcademyResourceAndAcademyChapterPart>;
};


/** Record of type Academy chapter part (academy_chapter_part) */
export type AcademyChapterPartRecord_AllReferencingAcademyResourcesMetaArgs = {
  filter?: InputMaybe<AcademyResourceModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAcademyResourceAndAcademyChapterPart>;
};


/** Record of type Academy chapter part (academy_chapter_part) */
export type AcademyChapterPartRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Academy chapter (academy_chapter) */
export type AcademyChapterRecord = RecordInterface & {
  __typename?: 'AcademyChapterRecord';
  _allReferencingAcademyChapterParts: Array<AcademyChapterPartRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingAcademyChapterPartsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  banner?: Maybe<FileField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  section?: Maybe<AcademySectionRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Academy chapter (academy_chapter) */
export type AcademyChapterRecord_AllReferencingAcademyChapterPartsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterPartModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyChapterPartModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAcademyChapterPartAndAcademyChapter>;
};


/** Record of type Academy chapter (academy_chapter) */
export type AcademyChapterRecord_AllReferencingAcademyChapterPartsMetaArgs = {
  filter?: InputMaybe<AcademyChapterPartModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAcademyChapterPartAndAcademyChapter>;
};


/** Record of type Academy chapter (academy_chapter) */
export type AcademyChapterRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AcademyHomepageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademyHomepageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademyHomepageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  bannerDescription?: InputMaybe<StringFilter>;
  bannerImage?: InputMaybe<FileFilter>;
  bannerTitle?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  buttonLink?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  icon?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  showBanner?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<TextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AcademyHomepageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  BannerDescription_ASC = 'bannerDescription_ASC',
  BannerDescription_DESC = 'bannerDescription_DESC',
  BannerTitle_ASC = 'bannerTitle_ASC',
  BannerTitle_DESC = 'bannerTitle_DESC',
  ButtonLabel_ASC = 'buttonLabel_ASC',
  ButtonLabel_DESC = 'buttonLabel_DESC',
  ButtonLink_ASC = 'buttonLink_ASC',
  ButtonLink_DESC = 'buttonLink_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  ShowBanner_ASC = 'showBanner_ASC',
  ShowBanner_DESC = 'showBanner_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Academy homepage (academy_homepage) */
export type AcademyHomepageRecord = RecordInterface & {
  __typename?: 'AcademyHomepageRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bannerDescription?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<FileField>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  showBanner?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Academy homepage (academy_homepage) */
export type AcademyHomepageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Academy homepage (academy_homepage) */
export type AcademyHomepageRecordTitleArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Linking fields */
export enum AcademyResourceModelFieldsReferencingAcademyChapterPartModel {
  AcademyResource_subChapter = 'academyResource_subChapter'
}

export type AcademyResourceModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademyResourceModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademyResourceModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  modalEmbed?: InputMaybe<TextFilter>;
  position?: InputMaybe<PositionFilter>;
  resourceType?: InputMaybe<LinkFilter>;
  subChapter?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  video?: InputMaybe<VideoFilter>;
};

export enum AcademyResourceModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Academy resource (academy_resource) */
export type AcademyResourceRecord = RecordInterface & {
  __typename?: 'AcademyResourceRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  modalEmbed?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  resourceType: AcademyResourceTypeRecord;
  subChapter?: Maybe<AcademyChapterPartRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<VideoField>;
};


/** Record of type Academy resource (academy_resource) */
export type AcademyResourceRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Academy resource (academy_resource) */
export type AcademyResourceRecordModalEmbedArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AcademyResourceTypeModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademyResourceTypeModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademyResourceTypeModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AcademyResourceTypeModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Academy resource type (academy_resource_type) */
export type AcademyResourceTypeRecord = RecordInterface & {
  __typename?: 'AcademyResourceTypeRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Academy resource type (academy_resource_type) */
export type AcademyResourceTypeRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AcademySectionModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AcademySectionModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AcademySectionModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  sectionImage?: InputMaybe<FileFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AcademySectionModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Academy section (academy_section) */
export type AcademySectionRecord = RecordInterface & {
  __typename?: 'AcademySectionRecord';
  _allReferencingAcademyChapters: Array<AcademyChapterRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingAcademyChaptersMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  sectionImage?: Maybe<FileField>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Academy section (academy_section) */
export type AcademySectionRecord_AllReferencingAcademyChaptersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyChapterModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAcademyChapterAndAcademySection>;
};


/** Record of type Academy section (academy_section) */
export type AcademySectionRecord_AllReferencingAcademyChaptersMetaArgs = {
  filter?: InputMaybe<AcademyChapterModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAcademyChapterAndAcademySection>;
};


/** Record of type Academy section (academy_section) */
export type AcademySectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AccordionItemModelAccordionContentField = {
  __typename?: 'AccordionItemModelAccordionContentField';
  blocks: Array<CaptionRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Accordion item (accordion_item) */
export type AccordionItemRecord = RecordInterface & {
  __typename?: 'AccordionItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  accordionContent: AccordionItemModelAccordionContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Accordion item (accordion_item) */
export type AccordionItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Accordion (accordion) */
export type AccordionRecord = RecordInterface & {
  __typename?: 'AccordionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  accordionItems: Array<AccordionItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Accordion (accordion) */
export type AccordionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Achievement block (achievement_block) */
export type AchievementBlockRecord = RecordInterface & {
  __typename?: 'AchievementBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  achievement: Array<AchievementRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Achievement block (achievement_block) */
export type AchievementBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AchievementModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AchievementModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AchievementModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
};

export enum AchievementModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Url_ASC = 'url_ASC',
  Url_DESC = 'url_DESC'
}

/** Record of type Achievements (achievement) */
export type AchievementRecord = RecordInterface & {
  __typename?: 'AchievementRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** Record of type Achievements (achievement) */
export type AchievementRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type All integrations block (all_integrations_block) */
export type AllIntegrationsBlockRecord = RecordInterface & {
  __typename?: 'AllIntegrationsBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type All integrations block (all_integrations_block) */
export type AllIntegrationsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AnnouncementModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AnnouncementModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AnnouncementModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  active?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  emoji?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AnnouncementModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Active_ASC = 'active_ASC',
  Active_DESC = 'active_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Emoji_ASC = 'emoji_ASC',
  Emoji_DESC = 'emoji_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Announcement (announcement) */
export type AnnouncementRecord = RecordInterface & {
  __typename?: 'AnnouncementRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  active?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Announcement (announcement) */
export type AnnouncementRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AppAnnouncementModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppAnnouncementModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppAnnouncementModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  active?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  emoji?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AppAnnouncementModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Active_ASC = 'active_ASC',
  Active_DESC = 'active_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Emoji_ASC = 'emoji_ASC',
  Emoji_DESC = 'emoji_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type App announcement (app_announcement) */
export type AppAnnouncementRecord = RecordInterface & {
  __typename?: 'AppAnnouncementRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  active?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type App announcement (app_announcement) */
export type AppAnnouncementRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AppIntegrationCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppIntegrationCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppIntegrationCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AppIntegrationCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type App integration category (app_integration_category) */
export type AppIntegrationCategoryRecord = RecordInterface & {
  __typename?: 'AppIntegrationCategoryRecord';
  _allReferencingAppIntegrations: Array<AppIntegrationRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingAppIntegrationsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type App integration category (app_integration_category) */
export type AppIntegrationCategoryRecord_AllReferencingAppIntegrationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppIntegrationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAppIntegrationAndAppIntegrationCategory>;
};


/** Record of type App integration category (app_integration_category) */
export type AppIntegrationCategoryRecord_AllReferencingAppIntegrationsMetaArgs = {
  filter?: InputMaybe<AppIntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenAppIntegrationAndAppIntegrationCategory>;
};


/** Record of type App integration category (app_integration_category) */
export type AppIntegrationCategoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum AppIntegrationModelFieldsReferencingAppIntegrationCategoryModel {
  AppIntegration_category = 'appIntegration_category'
}

export type AppIntegrationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppIntegrationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppIntegrationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  category?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  featureLock?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  integrationType?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  tenantType?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AppIntegrationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  FeatureLock_ASC = 'featureLock_ASC',
  FeatureLock_DESC = 'featureLock_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  IntegrationType_ASC = 'integrationType_ASC',
  IntegrationType_DESC = 'integrationType_DESC',
  Link_ASC = 'link_ASC',
  Link_DESC = 'link_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  TenantType_ASC = 'tenantType_ASC',
  TenantType_DESC = 'tenantType_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type App integration (app_integration) */
export type AppIntegrationRecord = RecordInterface & {
  __typename?: 'AppIntegrationRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  category: AppIntegrationCategoryRecord;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featureLock: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  integrationType: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  tenantType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type App integration (app_integration) */
export type AppIntegrationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AuthorModelAboutField = {
  __typename?: 'AuthorModelAboutField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type AuthorModelDescriptionField = {
  __typename?: 'AuthorModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type AuthorModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AuthorModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AuthorModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  about?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  email?: InputMaybe<StringFilter>;
  facebook?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  linkedin?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  twitter?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  web?: InputMaybe<StringFilter>;
};

export enum AuthorModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Email_ASC = 'email_ASC',
  Email_DESC = 'email_DESC',
  Facebook_ASC = 'facebook_ASC',
  Facebook_DESC = 'facebook_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Linkedin_ASC = 'linkedin_ASC',
  Linkedin_DESC = 'linkedin_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  Twitter_ASC = 'twitter_ASC',
  Twitter_DESC = 'twitter_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Web_ASC = 'web_ASC',
  Web_DESC = 'web_DESC'
}

/** Record of type Author (author) */
export type AuthorRecord = RecordInterface & {
  __typename?: 'AuthorRecord';
  _allReferencingBlogPosts: Array<BlogPostRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingBlogPostsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  about?: Maybe<AuthorModelAboutField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<AuthorModelDescriptionField>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  web?: Maybe<Scalars['String']['output']>;
};


/** Record of type Author (author) */
export type AuthorRecord_AllReferencingBlogPostsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogPostModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogPostModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenBlogPostAndAuthor>;
};


/** Record of type Author (author) */
export type AuthorRecord_AllReferencingBlogPostsMetaArgs = {
  filter?: InputMaybe<BlogPostModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenBlogPostAndAuthor>;
};


/** Record of type Author (author) */
export type AuthorRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type AutoIntegrationModelDescriptionField = {
  __typename?: 'AutoIntegrationModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type AutoIntegrationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AutoIntegrationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AutoIntegrationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  category?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  hidden?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  logo?: InputMaybe<FileFilter>;
  manual?: InputMaybe<StructuredTextFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type AutoIntegrationModelManualField = {
  __typename?: 'AutoIntegrationModelManualField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export enum AutoIntegrationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Category_ASC = 'category_ASC',
  Category_DESC = 'category_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Hidden_ASC = 'hidden_ASC',
  Hidden_DESC = 'hidden_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Auto integration (auto_integration) */
export type AutoIntegrationRecord = RecordInterface & {
  __typename?: 'AutoIntegrationRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<AutoIntegrationModelDescriptionField>;
  hidden?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  logo?: Maybe<FileField>;
  manual?: Maybe<AutoIntegrationModelManualField>;
  name?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Auto integration (auto_integration) */
export type AutoIntegrationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Banner (banner) */
export type BannerRecord = RecordInterface & {
  __typename?: 'BannerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  button: Scalars['String']['output'];
  content: Array<ButtonRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  href: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Banner (banner) */
export type BannerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type BlogBannerModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogBannerModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogBannerModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  targetBlank?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
  variant?: InputMaybe<StringFilter>;
};

export enum BlogBannerModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  TargetBlank_ASC = 'targetBlank_ASC',
  TargetBlank_DESC = 'targetBlank_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Url_ASC = 'url_ASC',
  Url_DESC = 'url_DESC',
  Variant_ASC = 'variant_ASC',
  Variant_DESC = 'variant_DESC'
}

/** Record of type Blog banner (blog_banner) */
export type BlogBannerRecord = RecordInterface & {
  __typename?: 'BlogBannerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  targetBlank?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};


/** Record of type Blog banner (blog_banner) */
export type BlogBannerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type Blog carousel (blog_carousel) */
export type BlogCarouselRecord = RecordInterface & {
  __typename?: 'BlogCarouselRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  posts: Array<BlogPostRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Blog carousel (blog_carousel) */
export type BlogCarouselRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum BlogPostModelFieldsReferencingAuthorModel {
  BlogPost_author = 'blogPost_author'
}

/** Linking fields */
export enum BlogPostModelFieldsReferencingBlogTagModel {
  BlogPost_tags = 'blogPost_tags'
}

export type BlogPostModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogPostModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogPostModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  featureImage?: InputMaybe<FileFilter>;
  html?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<StringFilter>;
  redirect?: InputMaybe<LinkFilter>;
  redirectUrl?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<StringFilter>;
  tags?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum BlogPostModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Image_ASC = 'image_ASC',
  Image_DESC = 'image_DESC',
  RedirectUrl_ASC = 'redirectUrl_ASC',
  RedirectUrl_DESC = 'redirectUrl_DESC',
  Slug_ASC = 'slug_ASC',
  Slug_DESC = 'slug_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Blog post (blog_post) */
export type BlogPostRecord = RecordInterface & {
  __typename?: 'BlogPostRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  author: AuthorRecord;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  featureImage: FileField;
  html: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<BlogPostRecord>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<SeoField>;
  slug: Scalars['String']['output'];
  tags: Array<BlogTagRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Blog post (blog_post) */
export type BlogPostRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Blog post (blog_post) */
export type BlogPostRecordHtmlArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Blog section (blog_section) */
export type BlogSectionRecord = RecordInterface & {
  __typename?: 'BlogSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  posts: Array<BlogPostRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Blog section (blog_section) */
export type BlogSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type BlogTagModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogTagModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogTagModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum BlogTagModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Slug_ASC = 'slug_ASC',
  Slug_DESC = 'slug_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Blog tag (blog_tag) */
export type BlogTagRecord = RecordInterface & {
  __typename?: 'BlogTagRecord';
  _allReferencingBlogPosts: Array<BlogPostRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingBlogPostsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Blog tag (blog_tag) */
export type BlogTagRecord_AllReferencingBlogPostsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogPostModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogPostModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenBlogPostAndBlogTag>;
};


/** Record of type Blog tag (blog_tag) */
export type BlogTagRecord_AllReferencingBlogPostsMetaArgs = {
  filter?: InputMaybe<BlogPostModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenBlogPostAndBlogTag>;
};


/** Record of type Blog tag (blog_tag) */
export type BlogTagRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type BoxModelBoxContentBlocksField = ImageRecord | TextRecord;

export type BoxModelBoxContentField = {
  __typename?: 'BoxModelBoxContentField';
  blocks: Array<BoxModelBoxContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Box (box) */
export type BoxRecord = RecordInterface & {
  __typename?: 'BoxRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  boxContent?: Maybe<BoxModelBoxContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Box (box) */
export type BoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Bullet list (bullet_list) */
export type BulletListRecord = RecordInterface & {
  __typename?: 'BulletListRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bulletListContent: Array<ContentItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  multipleCols?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Bullet list (bullet_list) */
export type BulletListRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ButtonModelContentField = {
  __typename?: 'ButtonModelContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Button (button) */
export type ButtonRecord = RecordInterface & {
  __typename?: 'ButtonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  arrow?: Maybe<Scalars['BooleanType']['output']>;
  buttonVariant?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<ButtonModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  cta?: Maybe<Scalars['BooleanType']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  inverseCaption?: Maybe<Scalars['BooleanType']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  noScroll?: Maybe<Scalars['BooleanType']['output']>;
  small?: Maybe<Scalars['BooleanType']['output']>;
  smallMarginTop?: Maybe<Scalars['BooleanType']['output']>;
  targetBlank?: Maybe<Scalars['BooleanType']['output']>;
  transparent?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Button (button) */
export type ButtonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Buttons group (buttons_group) */
export type ButtonsGroupRecord = RecordInterface & {
  __typename?: 'ButtonsGroupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  buttons: Array<ButtonRecord>;
  createdAt: Scalars['DateTime']['output'];
  horizontal?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Buttons group (buttons_group) */
export type ButtonsGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CaptionModelCaptionContentField = {
  __typename?: 'CaptionModelCaptionContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Caption (caption) */
export type CaptionRecord = RecordInterface & {
  __typename?: 'CaptionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  captionContent: CaptionModelCaptionContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Caption (caption) */
export type CaptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Carousel block (carousel_block) */
export type CarouselBlockRecord = RecordInterface & {
  __typename?: 'CarouselBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  carouselFeedback: Array<FeedbackRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Carousel block (carousel_block) */
export type CarouselBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Carousel (carousel) */
export type CarouselRecord = RecordInterface & {
  __typename?: 'CarouselRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  images: Array<FileField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Carousel (carousel) */
export type CarouselRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  categoryName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CategoryName_ASC = 'categoryName_ASC',
  CategoryName_DESC = 'categoryName_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Category (category) */
export type CategoryRecord = RecordInterface & {
  __typename?: 'CategoryRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  categoryName: Scalars['String']['output'];
  children: Array<CategoryRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  parent?: Maybe<CategoryRecord>;
  position?: Maybe<Scalars['IntType']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Category (category) */
export type CategoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  count: Scalars['IntType']['output'];
};

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export type ColorField = {
  __typename?: 'ColorField';
  alpha: Scalars['IntType']['output'];
  blue: Scalars['IntType']['output'];
  cssRgb: Scalars['String']['output'];
  green: Scalars['IntType']['output'];
  hex: Scalars['String']['output'];
  red: Scalars['IntType']['output'];
};

/** Specifies how to filter Color fields */
export type ColorFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Combo CTA (combo_cta) */
export type ComboCtaRecord = RecordInterface & {
  __typename?: 'ComboCtaRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bullets: Array<BulletListRecord>;
  buttons: Array<ButtonRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Combo CTA (combo_cta) */
export type ComboCtaRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Company block (company_block) */
export type CompanyBlockRecord = RecordInterface & {
  __typename?: 'CompanyBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  companyContent: Array<CompanyRecord>;
  createdAt: Scalars['DateTime']['output'];
  disableLinks?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Company block (company_block) */
export type CompanyBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompanyModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CompanyModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CompanyModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  caseStudyUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  logo?: InputMaybe<FileFilter>;
  testimonial?: InputMaybe<StructuredTextFilter>;
  testimonialAuthorDetails?: InputMaybe<StringFilter>;
  testimonialAuthorImage?: InputMaybe<FileFilter>;
  testimonialAuthorName?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
};

export enum CompanyModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CaseStudyUrl_ASC = 'caseStudyUrl_ASC',
  CaseStudyUrl_DESC = 'caseStudyUrl_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  TestimonialAuthorDetails_ASC = 'testimonialAuthorDetails_ASC',
  TestimonialAuthorDetails_DESC = 'testimonialAuthorDetails_DESC',
  TestimonialAuthorName_ASC = 'testimonialAuthorName_ASC',
  TestimonialAuthorName_DESC = 'testimonialAuthorName_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Url_ASC = 'url_ASC',
  Url_DESC = 'url_DESC'
}

export type CompanyModelTestimonialField = {
  __typename?: 'CompanyModelTestimonialField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Company (company) */
export type CompanyRecord = RecordInterface & {
  __typename?: 'CompanyRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  caseStudyUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  logo?: Maybe<FileField>;
  testimonial?: Maybe<CompanyModelTestimonialField>;
  testimonialAuthorDetails?: Maybe<Scalars['String']['output']>;
  testimonialAuthorImage?: Maybe<FileField>;
  testimonialAuthorName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** Record of type Company (company) */
export type CompanyRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Compare box (compare_box) */
export type CompareBoxRecord = RecordInterface & {
  __typename?: 'CompareBoxRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  compareContent: Array<CompareItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** Block of type Compare box (compare_box) */
export type CompareBoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompareFeatureItemModelTooltipField = {
  __typename?: 'CompareFeatureItemModelTooltipField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Compare feature item (compare_feature_item) */
export type CompareFeatureItemRecord = RecordInterface & {
  __typename?: 'CompareFeatureItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  feature?: Maybe<FeatureRecord>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  tooltip?: Maybe<CompareFeatureItemModelTooltipField>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};


/** Block of type Compare feature item (compare_feature_item) */
export type CompareFeatureItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Compare feature (compare_feature) */
export type CompareFeatureRecord = RecordInterface & {
  __typename?: 'CompareFeatureRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  compareTable?: Maybe<CompareTableRecord>;
  competitor: Array<CompetitorRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<FeatureRecord>;
  id: Scalars['ItemId']['output'];
  pricingPackage: Scalars['String']['output'];
  pricingPlans: Array<PricingPlanRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Compare feature (compare_feature) */
export type CompareFeatureRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompareItemModelAdvantageField = {
  __typename?: 'CompareItemModelAdvantageField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type CompareItemModelDisadvantageField = {
  __typename?: 'CompareItemModelDisadvantageField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Compare item (compare_item) */
export type CompareItemRecord = RecordInterface & {
  __typename?: 'CompareItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  advantage?: Maybe<CompareItemModelAdvantageField>;
  createdAt: Scalars['DateTime']['output'];
  disadvantage?: Maybe<CompareItemModelDisadvantageField>;
  id: Scalars['ItemId']['output'];
  logo?: Maybe<FileField>;
  page?: Maybe<PageRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Compare item (compare_item) */
export type CompareItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompareProductItemModelDescriptionField = {
  __typename?: 'CompareProductItemModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type CompareProductItemModelTitleField = {
  __typename?: 'CompareProductItemModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Compare product item (compare_product_item) */
export type CompareProductItemRecord = RecordInterface & {
  __typename?: 'CompareProductItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  buttons: Array<ButtonRecord>;
  createdAt: Scalars['DateTime']['output'];
  description: CompareProductItemModelDescriptionField;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  media: VideoFileField;
  title: CompareProductItemModelTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Compare product item (compare_product_item) */
export type CompareProductItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompareProductModelCompareProductDescriptionField = {
  __typename?: 'CompareProductModelCompareProductDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type CompareProductModelCompareProductTitleField = {
  __typename?: 'CompareProductModelCompareProductTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Compare product (compare_product) */
export type CompareProductRecord = RecordInterface & {
  __typename?: 'CompareProductRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  compareProductDescription: CompareProductModelCompareProductDescriptionField;
  compareProductImage: FileField;
  compareProductProducts: Array<CompareProductItemRecord>;
  compareProductTitle: CompareProductModelCompareProductTitleField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Compare product (compare_product) */
export type CompareProductRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompareTableModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CompareTableModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CompareTableModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<TextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CompareTableModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Compare table (compare_table) */
export type CompareTableRecord = RecordInterface & {
  __typename?: 'CompareTableRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Compare table (compare_table) */
export type CompareTableRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Compare table (compare_table) */
export type CompareTableRecordContentArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComparisonModelComparisonCompareTitleField = {
  __typename?: 'ComparisonModelComparisonCompareTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ComparisonModelComparisonDescriptionField = {
  __typename?: 'ComparisonModelComparisonDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ComparisonModelComparisonTheirTitleField = {
  __typename?: 'ComparisonModelComparisonTheirTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ComparisonModelComparisonTitleField = {
  __typename?: 'ComparisonModelComparisonTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Comparison (comparison) */
export type ComparisonRecord = RecordInterface & {
  __typename?: 'ComparisonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  comparisonButtonHref?: Maybe<Scalars['String']['output']>;
  comparisonButtonHrefNetwork?: Maybe<Scalars['String']['output']>;
  comparisonButtonLabel?: Maybe<Scalars['String']['output']>;
  comparisonButtonLabelNetwork?: Maybe<Scalars['String']['output']>;
  comparisonCompareTitle: ComparisonModelComparisonCompareTitleField;
  comparisonCompetitors: Array<CompetitorRecord>;
  comparisonCompetitorsNetwork: Array<CompetitorRecord>;
  comparisonDescription: ComparisonModelComparisonDescriptionField;
  comparisonImage: FileField;
  comparisonImageMobile: FileField;
  comparisonOurFeatures: ListRecord;
  comparisonOurImage?: Maybe<FileField>;
  comparisonTheirFeatures: ListRecord;
  comparisonTheirImage?: Maybe<FileField>;
  comparisonTheirTitle: ComparisonModelComparisonTheirTitleField;
  comparisonTitle: ComparisonModelComparisonTitleField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Comparison (comparison) */
export type ComparisonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ComparisonTableModelComparisonTableDescriptionField = {
  __typename?: 'ComparisonTableModelComparisonTableDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ComparisonTableModelComparisonTableLastUpdatedField = {
  __typename?: 'ComparisonTableModelComparisonTableLastUpdatedField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ComparisonTableModelComparisonTableTitleField = {
  __typename?: 'ComparisonTableModelComparisonTableTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Comparison table (comparison_table) */
export type ComparisonTableRecord = RecordInterface & {
  __typename?: 'ComparisonTableRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  comparisonTableContent: Array<TableRowRecord>;
  comparisonTableDescription?: Maybe<ComparisonTableModelComparisonTableDescriptionField>;
  comparisonTableLastUpdated?: Maybe<ComparisonTableModelComparisonTableLastUpdatedField>;
  comparisonTableTitle?: Maybe<ComparisonTableModelComparisonTableTitleField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Comparison table (comparison_table) */
export type ComparisonTableRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Competitor block (competitor_block) */
export type CompetitorBlockRecord = RecordInterface & {
  __typename?: 'CompetitorBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  competitors: Array<CompetitorRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Competitor block (competitor_block) */
export type CompetitorBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type CompetitorModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CompetitorModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CompetitorModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  features?: InputMaybe<LinksFilter>;
  id?: InputMaybe<ItemIdFilter>;
  logo?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  noFreePlan?: InputMaybe<BooleanFilter>;
  page?: InputMaybe<LinkFilter>;
  planName?: InputMaybe<StringFilter>;
  price?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CompetitorModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  NoFreePlan_ASC = 'noFreePlan_ASC',
  NoFreePlan_DESC = 'noFreePlan_DESC',
  PlanName_ASC = 'planName_ASC',
  PlanName_DESC = 'planName_DESC',
  Price_ASC = 'price_ASC',
  Price_DESC = 'price_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Competitor (competitor) */
export type CompetitorRecord = RecordInterface & {
  __typename?: 'CompetitorRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featureOverride: Array<CompareFeatureItemRecord>;
  features: Array<FeatureRecord>;
  id: Scalars['ItemId']['output'];
  logo?: Maybe<FileField>;
  name?: Maybe<Scalars['String']['output']>;
  noFreePlan?: Maybe<Scalars['BooleanType']['output']>;
  page?: Maybe<PageRecord>;
  planName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Competitor (competitor) */
export type CompetitorRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Composite image (composite_image) */
export type CompositeImageRecord = RecordInterface & {
  __typename?: 'CompositeImageRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  images: Array<FileField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Composite image (composite_image) */
export type CompositeImageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Content image section (content_image_section) */
export type ContentImageSectionRecord = RecordInterface & {
  __typename?: 'ContentImageSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<ContentItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Content image section (content_image_section) */
export type ContentImageSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ContentItemModelDescriptionBlocksField = BulletListRecord | ButtonRecord | ButtonsGroupRecord | CarouselBlockRecord | CompositeImageRecord | IntegrationBlockRecord;

export type ContentItemModelDescriptionField = {
  __typename?: 'ContentItemModelDescriptionField';
  blocks: Array<ContentItemModelDescriptionBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ContentItemModelTitleFormattedField = {
  __typename?: 'ContentItemModelTitleFormattedField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Content item (content_item) */
export type ContentItemRecord = RecordInterface & {
  __typename?: 'ContentItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  badge?: Maybe<Scalars['String']['output']>;
  biggerHeadline?: Maybe<Scalars['BooleanType']['output']>;
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<ContentItemModelDescriptionField>;
  highlight?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  label?: Maybe<Scalars['String']['output']>;
  secondaryImage?: Maybe<FileField>;
  title?: Maybe<Scalars['String']['output']>;
  titleFormatted?: Maybe<ContentItemModelTitleFormattedField>;
  togglePosition?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Content item (content_item) */
export type ContentItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Content Item v2 (content_item_v2) */
export type ContentItemV2Record = RecordInterface & {
  __typename?: 'ContentItemV2Record';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hoverEffect?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  layout: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Content Item v2 (content_item_v2) */
export type ContentItemV2Record_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Content Item v2 (content_item_v2) */
export type ContentItemV2RecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Block of type Content Item v2 (content_item_v2) */
export type ContentItemV2RecordTitleArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSectionModelSectionDescriptionBlocksField = ButtonRecord | ButtonsGroupRecord | ComboCtaRecord | FlexRecord | FullFeatureBlockRecord | IntegrationBlockRecord | LinkBoxRecord | ReviewsBlockRecord | SpacerRecord | TestimonialRecord | UsersBlockRecord;

export type ContentSectionModelSectionDescriptionField = {
  __typename?: 'ContentSectionModelSectionDescriptionField';
  blocks: Array<ContentSectionModelSectionDescriptionBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ContentSectionModelSectionExtraContentBlocksField = AchievementBlockRecord | AllIntegrationsBlockRecord | BulletListRecord | ButtonRecord | ButtonsGroupRecord | CompareBoxRecord | CompetitorBlockRecord | ContentToggleRecord | FeaturesSectionRecord | GridContentRecord | IntegrationBlockRecord | SpacerRecord | TableRecord | TestimonialRecord | TrackdeskBlockRecord;

export type ContentSectionModelSectionExtraContentField = {
  __typename?: 'ContentSectionModelSectionExtraContentField';
  blocks: Array<ContentSectionModelSectionExtraContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ContentSectionModelTitleFormattedField = {
  __typename?: 'ContentSectionModelTitleFormattedField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Content section (content_section) */
export type ContentSectionRecord = RecordInterface & {
  __typename?: 'ContentSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  center?: Maybe<Scalars['BooleanType']['output']>;
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  extraImage?: Maybe<FileField>;
  hiddenMobile?: Maybe<Scalars['BooleanType']['output']>;
  hiddenTitle?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  itemsEnd?: Maybe<Scalars['BooleanType']['output']>;
  reverse?: Maybe<Scalars['BooleanType']['output']>;
  sectionContent: Array<ContentItemRecord>;
  sectionDescription?: Maybe<ContentSectionModelSectionDescriptionField>;
  sectionExtraContent?: Maybe<ContentSectionModelSectionExtraContentField>;
  title?: Maybe<Scalars['String']['output']>;
  titleFormatted?: Maybe<ContentSectionModelTitleFormattedField>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};


/** Block of type Content section (content_section) */
export type ContentSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ContentSectionV2ModelDescriptionExtraContentField = ButtonRecord | ButtonsGroupRecord | LineRecord | LinkBoxRecord | SpacerRecord;

/** Block of type Content Section v2 (content_section_v2) */
export type ContentSectionV2Record = RecordInterface & {
  __typename?: 'ContentSectionV2Record';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundColor?: Maybe<ColorField>;
  contentItems: Array<ContentItemV2Record>;
  contentItemsPerRow: Scalars['IntType']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionExtraContent: Array<ContentSectionV2ModelDescriptionExtraContentField>;
  hiddenMobile?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  layout: Scalars['String']['output'];
  preTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trimContentItems?: Maybe<Scalars['BooleanType']['output']>;
  trimmedContentItemsButtonLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Content Section v2 (content_section_v2) */
export type ContentSectionV2Record_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Content Section v2 (content_section_v2) */
export type ContentSectionV2RecordDescriptionArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Block of type Content Section v2 (content_section_v2) */
export type ContentSectionV2RecordPreTitleArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Block of type Content Section v2 (content_section_v2) */
export type ContentSectionV2RecordTitleArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentToggleModelContentAField = {
  __typename?: 'ContentToggleModelContentAField';
  blocks: Array<TableRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ContentToggleModelContentBField = {
  __typename?: 'ContentToggleModelContentBField';
  blocks: Array<TableRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Content toggle (content_toggle) */
export type ContentToggleRecord = RecordInterface & {
  __typename?: 'ContentToggleRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contentA: ContentToggleModelContentAField;
  contentB: ContentToggleModelContentBField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  optionA: Scalars['String']['output'];
  optionB: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Content toggle (content_toggle) */
export type ContentToggleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Conversion type (conversion_type) */
export type ConversionTypeRecord = RecordInterface & {
  __typename?: 'ConversionTypeRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  conversionCountLimit?: Maybe<Scalars['IntType']['output']>;
  conversionTypeCode?: Maybe<Scalars['String']['output']>;
  conversionValueType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultPayout?: Maybe<Scalars['String']['output']>;
  defaultRevenue?: Maybe<Scalars['String']['output']>;
  editablePayout?: Maybe<Scalars['BooleanType']['output']>;
  editableRecurrence?: Maybe<Scalars['BooleanType']['output']>;
  editableRevenue?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  showRecurringConversionSetup?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Conversion type (conversion_type) */
export type ConversionTypeRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Linking fields */
export enum CustomTenantTranslationModelFieldsReferencingTranslationModel {
  CustomTenantTranslation_locale = 'customTenantTranslation_locale'
}

export type CustomTenantTranslationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CustomTenantTranslationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CustomTenantTranslationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  locale?: InputMaybe<LinkFilter>;
  tenantId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CustomTenantTranslationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Disabled_ASC = 'disabled_ASC',
  Disabled_DESC = 'disabled_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  TenantId_ASC = 'tenantId_ASC',
  TenantId_DESC = 'tenantId_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Custom tenant translation (custom_tenant_translation) */
export type CustomTenantTranslationRecord = RecordInterface & {
  __typename?: 'CustomTenantTranslationRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Scalars['JsonField']['output'];
  createdAt: Scalars['DateTime']['output'];
  disabled?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  locale: TranslationRecord;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Custom tenant translation (custom_tenant_translation) */
export type CustomTenantTranslationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type DashboardArticleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<DashboardArticleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DashboardArticleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  buttonIcon?: InputMaybe<StringFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  buttonVariant?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  position?: InputMaybe<PositionFilter>;
  showToFreemiumUsers?: InputMaybe<BooleanFilter>;
  targetBlank?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum DashboardArticleModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  ButtonIcon_ASC = 'buttonIcon_ASC',
  ButtonIcon_DESC = 'buttonIcon_DESC',
  ButtonLabel_ASC = 'buttonLabel_ASC',
  ButtonLabel_DESC = 'buttonLabel_DESC',
  ButtonVariant_ASC = 'buttonVariant_ASC',
  ButtonVariant_DESC = 'buttonVariant_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  ShowToFreemiumUsers_ASC = 'showToFreemiumUsers_ASC',
  ShowToFreemiumUsers_DESC = 'showToFreemiumUsers_DESC',
  TargetBlank_ASC = 'targetBlank_ASC',
  TargetBlank_DESC = 'targetBlank_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Dashboard article (dashboard_article) */
export type DashboardArticleRecord = RecordInterface & {
  __typename?: 'DashboardArticleRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  buttonIcon?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonVariant?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  href: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  position?: Maybe<Scalars['IntType']['output']>;
  showToFreemiumUsers?: Maybe<Scalars['BooleanType']['output']>;
  targetBlank?: Maybe<Scalars['BooleanType']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Dashboard article (dashboard_article) */
export type DashboardArticleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Date fields */
export type DateFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['Date']['input']>;
};

export type DynamicMegablockItemModelDescriptionField = {
  __typename?: 'DynamicMegablockItemModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type DynamicMegablockItemModelTitleField = {
  __typename?: 'DynamicMegablockItemModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Dynamic megablock item (dynamic_megablock_item) */
export type DynamicMegablockItemRecord = RecordInterface & {
  __typename?: 'DynamicMegablockItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: DynamicMegablockItemModelDescriptionField;
  id: Scalars['ItemId']['output'];
  media: FileField;
  title: DynamicMegablockItemModelTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Dynamic megablock item (dynamic_megablock_item) */
export type DynamicMegablockItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Dynamic megablock (dynamic_megablock) */
export type DynamicMegablockRecord = RecordInterface & {
  __typename?: 'DynamicMegablockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  autoplay?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cta: ButtonsGroupRecord;
  id: Scalars['ItemId']['output'];
  items: Array<DynamicMegablockItemRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Dynamic megablock (dynamic_megablock) */
export type DynamicMegablockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FaqItemModelAnswerField = {
  __typename?: 'FaqItemModelAnswerField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type FAQ item (faq_item) */
export type FaqItemRecord = RecordInterface & {
  __typename?: 'FaqItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  answer: FaqItemModelAnswerField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type FAQ item (faq_item) */
export type FaqItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FaqModelFaqContentField = {
  __typename?: 'FaqModelFaqContentField';
  blocks: Array<ButtonRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type FAQ (faq) */
export type FaqRecord = RecordInterface & {
  __typename?: 'FaqRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  faqContent?: Maybe<FaqModelFaqContentField>;
  faqList: Array<FaqItemRecord>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type FAQ (faq) */
export type FaqRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication'
}

export type FeatureModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeatureModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeatureModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  comingSoon?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  invisible?: InputMaybe<BooleanFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  pricingPlan?: InputMaybe<LinksFilter>;
  pricingValue?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  tooltip?: InputMaybe<StringFilter>;
  tooltipContent?: InputMaybe<StructuredTextFilter>;
  unsupported?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FeatureModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  ComingSoon_ASC = 'comingSoon_ASC',
  ComingSoon_DESC = 'comingSoon_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Invisible_ASC = 'invisible_ASC',
  Invisible_DESC = 'invisible_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PricingValue_ASC = 'pricingValue_ASC',
  PricingValue_DESC = 'pricingValue_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  Tooltip_ASC = 'tooltip_ASC',
  Tooltip_DESC = 'tooltip_DESC',
  Unsupported_ASC = 'unsupported_ASC',
  Unsupported_DESC = 'unsupported_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type FeatureModelTooltipContentField = {
  __typename?: 'FeatureModelTooltipContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Features (feature) */
export type FeatureRecord = RecordInterface & {
  __typename?: 'FeatureRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  children: Array<FeatureRecord>;
  comingSoon?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  invisible?: Maybe<Scalars['BooleanType']['output']>;
  parent?: Maybe<FeatureRecord>;
  position?: Maybe<Scalars['IntType']['output']>;
  pricingPlan: Array<PricingPlanRecord>;
  pricingValue?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
  tooltipContent?: Maybe<FeatureModelTooltipContentField>;
  unsupported?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Features (feature) */
export type FeatureRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Features block (features_block) */
export type FeaturesBlockRecord = RecordInterface & {
  __typename?: 'FeaturesBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Features block (features_block) */
export type FeaturesBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Features section (features_section) */
export type FeaturesSectionRecord = RecordInterface & {
  __typename?: 'FeaturesSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  featuresList: Array<FeatureRecord>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Features section (features_section) */
export type FeaturesSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FeedbackModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeedbackModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeedbackModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  logo?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  photo?: InputMaybe<FileFilter>;
  text?: InputMaybe<TextFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
};

export enum FeedbackModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Company_ASC = 'company_ASC',
  Company_DESC = 'company_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Url_ASC = 'url_ASC',
  Url_DESC = 'url_DESC'
}

/** Record of type Hones Feedback (feedback) */
export type FeedbackRecord = RecordInterface & {
  __typename?: 'FeedbackRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  company: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  logo?: Maybe<FileField>;
  name: Scalars['String']['output'];
  photo: FileField;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** Record of type Hones Feedback (feedback) */
export type FeedbackRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Hones Feedback (feedback) */
export type FeedbackRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileField = FileFieldInterface & {
  __typename?: 'FileField';
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height?: Maybe<Scalars['IntType']['output']>;
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']['output']>;
};


export type FileFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type FileFieldCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type FileFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

export type FileFieldInterface = {
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height?: Maybe<Scalars['IntType']['output']>;
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video?: Maybe<UploadVideoField>;
  width?: Maybe<Scalars['IntType']['output']>;
};


export type FileFieldInterfaceAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type FileFieldInterfaceCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type FileFieldInterfaceTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

export type FlexModelContentBlocksField = BulletListRecord | ButtonRecord | FlexRecord;

export type FlexModelContentField = {
  __typename?: 'FlexModelContentField';
  blocks: Array<FlexModelContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Flex (flex) */
export type FlexRecord = RecordInterface & {
  __typename?: 'FlexRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content?: Maybe<FlexModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  flexCol?: Maybe<Scalars['BooleanType']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Flex (flex) */
export type FlexRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FooterExtraModelContentField = {
  __typename?: 'FooterExtraModelContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Footer extra (footer_extra) */
export type FooterExtraRecord = RecordInterface & {
  __typename?: 'FooterExtraRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: FooterExtraModelContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Footer extra (footer_extra) */
export type FooterExtraRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FooterLinkModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterLinkModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterLinkModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  newTab?: InputMaybe<BooleanFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FooterLinkModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NewTab_ASC = 'newTab_ASC',
  NewTab_DESC = 'newTab_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Footer link (footer_link) */
export type FooterLinkRecord = RecordInterface & {
  __typename?: 'FooterLinkRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  children: Array<FooterLinkRecord>;
  createdAt: Scalars['DateTime']['output'];
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  newTab?: Maybe<Scalars['BooleanType']['output']>;
  parent?: Maybe<FooterLinkRecord>;
  position?: Maybe<Scalars['IntType']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Footer link (footer_link) */
export type FooterLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FooterMenuModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterMenuModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterMenuModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  newTab?: InputMaybe<BooleanFilter>;
  position?: InputMaybe<PositionFilter>;
  slug?: InputMaybe<SlugFilter>;
  text?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FooterMenuModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NewTab_ASC = 'newTab_ASC',
  NewTab_DESC = 'newTab_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Text_ASC = 'text_ASC',
  Text_DESC = 'text_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Footer menu (footer_menu) */
export type FooterMenuRecord = RecordInterface & {
  __typename?: 'FooterMenuRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  newTab?: Maybe<Scalars['BooleanType']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  slug: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Footer menu (footer_menu) */
export type FooterMenuRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FormBoxModelFormBoxContentField = {
  __typename?: 'FormBoxModelFormBoxContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Form box (form_box) */
export type FormBoxRecord = RecordInterface & {
  __typename?: 'FormBoxRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  form?: Maybe<HubspotFormRecord>;
  formBoxContent?: Maybe<FormBoxModelFormBoxContentField>;
  id: Scalars['ItemId']['output'];
  testimonal?: Maybe<FeedbackRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Form box (form_box) */
export type FormBoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FullComparisonModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FullComparisonModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FullComparisonModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pricingGroup?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FullComparisonModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Full comparison (full_comparison) */
export type FullComparisonRecord = RecordInterface & {
  __typename?: 'FullComparisonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<FullComparisonSectionRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  pricingGroup: PricingGroupRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Full comparison (full_comparison) */
export type FullComparisonRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Full comparison section (full_comparison_section) */
export type FullComparisonSectionRecord = RecordInterface & {
  __typename?: 'FullComparisonSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  features: Array<FeatureRecord>;
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Full comparison section (full_comparison_section) */
export type FullComparisonSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FullFeatureBlockModelFullComparisonTitleField = {
  __typename?: 'FullFeatureBlockModelFullComparisonTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Full feature block (full_feature_block) */
export type FullFeatureBlockRecord = RecordInterface & {
  __typename?: 'FullFeatureBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  fullComparisonContent?: Maybe<FullComparisonRecord>;
  fullComparisonTitle: FullFeatureBlockModelFullComparisonTitleField;
  fullComparisonTitleImage?: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  pricingPlans: Array<PricingPlanRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Full feature block (full_feature_block) */
export type FullFeatureBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Full feature section (full_feature_section) */
export type FullFeatureSectionRecord = RecordInterface & {
  __typename?: 'FullFeatureSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  features: Array<FeatureRecord>;
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Full feature section (full_feature_section) */
export type FullFeatureSectionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type GlobalSeoField = {
  __typename?: 'GlobalSeoField';
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  fallbackSeo?: Maybe<SeoField>;
  siteName?: Maybe<Scalars['String']['output']>;
  titleSuffix?: Maybe<Scalars['String']['output']>;
  twitterAccount?: Maybe<Scalars['String']['output']>;
};

export type GridContentModelGridContentField = ButtonRecord | CompareItemRecord;

/** Block of type Grid content (grid_content) */
export type GridContentRecord = RecordInterface & {
  __typename?: 'GridContentRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  gridCols?: Maybe<Scalars['IntType']['output']>;
  gridContent: Array<GridContentModelGridContentField>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Grid content (grid_content) */
export type GridContentRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Grid (grid) */
export type GridRecord = RecordInterface & {
  __typename?: 'GridRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<LinkRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Grid (grid) */
export type GridRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Headline (headline) */
export type HeadlineRecord = RecordInterface & {
  __typename?: 'HeadlineRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  level?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['BooleanType']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Headline (headline) */
export type HeadlineRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type HelpModelHelpTooltipTextField = {
  __typename?: 'HelpModelHelpTooltipTextField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Help (help) */
export type HelpRecord = RecordInterface & {
  __typename?: 'HelpRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  helpText: Scalars['String']['output'];
  helpTooltipText?: Maybe<HelpModelHelpTooltipTextField>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Help (help) */
export type HelpRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Highlighted box (highlighted_box) */
export type HighlightedBoxRecord = RecordInterface & {
  __typename?: 'HighlightedBoxRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bottomImage?: Maybe<Scalars['BooleanType']['output']>;
  bullets?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  highlightedBoxContent: Array<ContentItemRecord>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wide?: Maybe<Scalars['BooleanType']['output']>;
};


/** Block of type Highlighted box (highlighted_box) */
export type HighlightedBoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type HubspotFormModelDescriptionField = {
  __typename?: 'HubspotFormModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type HubspotFormModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<HubspotFormModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HubspotFormModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  formId?: InputMaybe<StringFilter>;
  headline?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  portalId?: InputMaybe<StringFilter>;
  region?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type HubspotFormModelHeadlineField = {
  __typename?: 'HubspotFormModelHeadlineField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export enum HubspotFormModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  FormId_ASC = 'formId_ASC',
  FormId_DESC = 'formId_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  PortalId_ASC = 'portalId_ASC',
  PortalId_DESC = 'portalId_DESC',
  Region_ASC = 'region_ASC',
  Region_DESC = 'region_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Hubspot form (hubspot_form) */
export type HubspotFormRecord = RecordInterface & {
  __typename?: 'HubspotFormRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<HubspotFormModelDescriptionField>;
  formId?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<HubspotFormModelHeadlineField>;
  id: Scalars['ItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  portalId?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Hubspot form (hubspot_form) */
export type HubspotFormRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Hubspot (hubspot) */
export type HubspotRecord = RecordInterface & {
  __typename?: 'HubspotRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  portalId?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Hubspot (hubspot) */
export type HubspotRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Icon block (icon_block) */
export type IconBlockRecord = RecordInterface & {
  __typename?: 'IconBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: IconRecord;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Icon block (icon_block) */
export type IconBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type IconGroupModelDescriptionBlocksField = HelpRecord | ListRecord;

export type IconGroupModelDescriptionField = {
  __typename?: 'IconGroupModelDescriptionField';
  blocks: Array<IconGroupModelDescriptionBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Icon group (icon_group) */
export type IconGroupRecord = RecordInterface & {
  __typename?: 'IconGroupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  center?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<IconGroupModelDescriptionField>;
  icon?: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  large?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Icon group (icon_group) */
export type IconGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type IconImageBoxModelDescriptionField = {
  __typename?: 'IconImageBoxModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type IconImageBoxModelHeadlineField = {
  __typename?: 'IconImageBoxModelHeadlineField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Icon image box (icon_image_box) */
export type IconImageBoxRecord = RecordInterface & {
  __typename?: 'IconImageBoxRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: IconImageBoxModelDescriptionField;
  headline: IconImageBoxModelHeadlineField;
  headlineIcon: IconRecord;
  id: Scalars['ItemId']['output'];
  image: FileField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Icon image box (icon_image_box) */
export type IconImageBoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Icon link (icon_link) */
export type IconLinkRecord = RecordInterface & {
  __typename?: 'IconLinkRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  href: Scalars['String']['output'];
  icon: FileField;
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Icon link (icon_link) */
export type IconLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type IconModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<IconModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IconModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum IconModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Icon (icon) */
export type IconRecord = RecordInterface & {
  __typename?: 'IconRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Icon (icon) */
export type IconRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Image (image) */
export type ImageRecord = RecordInterface & {
  __typename?: 'ImageRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Image (image) */
export type ImageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye'
}

export enum ImgixParamsBgRemoveFgType {
  Auto = 'auto',
  Car = 'car'
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit'
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width'
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Origin = 'origin',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial'
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale'
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v'
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp'
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block'
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsMarkTile {
  Grid = 'grid'
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json'
}

export enum ImgixParamsRotType {
  Pivot = 'pivot',
  Straighten = 'straighten'
}

export enum ImgixParamsTransparency {
  Grid = 'grid'
}

export enum ImgixParamsTrim {
  Alpha = 'alpha',
  Auto = 'auto',
  Color = 'color'
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export enum ImgixParamsTxtFit {
  Max = 'max'
}

export type ImplementationBannerModelContentField = {
  __typename?: 'ImplementationBannerModelContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Implementation banner (implementation_banner) */
export type ImplementationBannerRecord = RecordInterface & {
  __typename?: 'ImplementationBannerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content?: Maybe<ImplementationBannerModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Implementation banner (implementation_banner) */
export type ImplementationBannerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type In-app pricing FAQ (in_app_pricing_faq) */
export type InAppPricingFaqRecord = RecordInterface & {
  __typename?: 'InAppPricingFaqRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<FaqItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type In-app pricing FAQ (in_app_pricing_faq) */
export type InAppPricingFaqRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Integer fields */
export type IntegerFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Block of type Integration block (integration_block) */
export type IntegrationBlockRecord = RecordInterface & {
  __typename?: 'IntegrationBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  integrations: Array<IntegrationRecord>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Integration block (integration_block) */
export type IntegrationBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Integration carousel (integration_carousel) */
export type IntegrationCarouselRecord = RecordInterface & {
  __typename?: 'IntegrationCarouselRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  carouselButton?: Maybe<ButtonRecord>;
  createdAt: Scalars['DateTime']['output'];
  firstRow: Array<FileField>;
  id: Scalars['ItemId']['output'];
  secondRow: Array<FileField>;
  thirdRow: Array<FileField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Integration carousel (integration_carousel) */
export type IntegrationCarouselRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Integration group (integration_group) */
export type IntegrationGroupRecord = RecordInterface & {
  __typename?: 'IntegrationGroupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  trackingMethods: Array<TrackingMethodRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Integration group (integration_group) */
export type IntegrationGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type IntegrationListModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<IntegrationListModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IntegrationListModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  tenantType?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum IntegrationListModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  TenantType_ASC = 'tenantType_ASC',
  TenantType_DESC = 'tenantType_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Integration list (integration_list) */
export type IntegrationListRecord = RecordInterface & {
  __typename?: 'IntegrationListRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  integrationGroups: Array<IntegrationGroupRecord>;
  tenantType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Integration list (integration_list) */
export type IntegrationListRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type IntegrationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<IntegrationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IntegrationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  imageDark?: InputMaybe<FileFilter>;
  imageSquare?: InputMaybe<FileFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum IntegrationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Integration (integration) */
export type IntegrationRecord = RecordInterface & {
  __typename?: 'IntegrationRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  imageDark?: Maybe<FileField>;
  imageSquare?: Maybe<FileField>;
  position?: Maybe<Scalars['IntType']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Integration (integration) */
export type IntegrationRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Integration (integration) */
export type IntegrationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Integration (integration) */
export type IntegrationRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type IntercomOpenModelTextField = {
  __typename?: 'IntercomOpenModelTextField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Intercom open (intercom_open) */
export type IntercomOpenRecord = RecordInterface & {
  __typename?: 'IntercomOpenRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text?: Maybe<IntercomOpenModelTextField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Intercom open (intercom_open) */
export type IntercomOpenRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Internal video (internal_video) */
export type InternalVideoRecord = RecordInterface & {
  __typename?: 'InternalVideoRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  video: VideoFileField;
};


/** Block of type Internal video (internal_video) */
export type InternalVideoRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenAcademyChapterAndAcademySection = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<AcademyChapterModelFieldsReferencingAcademySectionModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<AcademyChapterModelFieldsReferencingAcademySectionModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenAcademyChapterPartAndAcademyChapter = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<AcademyChapterPartModelFieldsReferencingAcademyChapterModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<AcademyChapterPartModelFieldsReferencingAcademyChapterModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenAcademyResourceAndAcademyChapterPart = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<AcademyResourceModelFieldsReferencingAcademyChapterPartModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<AcademyResourceModelFieldsReferencingAcademyChapterPartModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenAppIntegrationAndAppIntegrationCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<AppIntegrationModelFieldsReferencingAppIntegrationCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<AppIntegrationModelFieldsReferencingAppIntegrationCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenBlogPostAndAuthor = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<BlogPostModelFieldsReferencingAuthorModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<BlogPostModelFieldsReferencingAuthorModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenBlogPostAndBlogTag = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<BlogPostModelFieldsReferencingBlogTagModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<BlogPostModelFieldsReferencingBlogTagModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenCustomTenantTranslationAndTranslation = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<CustomTenantTranslationModelFieldsReferencingTranslationModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<CustomTenantTranslationModelFieldsReferencingTranslationModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenOfferTemplateAndOfferTemplateCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<OfferTemplateModelFieldsReferencingOfferTemplateCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<OfferTemplateModelFieldsReferencingOfferTemplateCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenTrackingMethodAndTrackingMethodCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<TrackingMethodModelFieldsReferencingTrackingMethodCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<TrackingMethodModelFieldsReferencingTrackingMethodCategoryModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenWalnutDemoAndWalnutDemoCategory = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<WalnutDemoModelFieldsReferencingWalnutDemoCategoryModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<WalnutDemoModelFieldsReferencingWalnutDemoCategoryModel>>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenAcademyChapterAndAcademySection = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenAcademyChapterAndAcademySection>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenAcademyChapterPartAndAcademyChapter = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenAcademyChapterPartAndAcademyChapter>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenAcademyResourceAndAcademyChapterPart = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenAcademyResourceAndAcademyChapterPart>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenAppIntegrationAndAppIntegrationCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenAppIntegrationAndAppIntegrationCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenBlogPostAndAuthor = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenBlogPostAndAuthor>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenBlogPostAndBlogTag = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenBlogPostAndBlogTag>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenCustomTenantTranslationAndTranslation = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenCustomTenantTranslationAndTranslation>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenOfferTemplateAndOfferTemplateCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenOfferTemplateAndOfferTemplateCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenTrackingMethodAndTrackingMethodCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenTrackingMethodAndTrackingMethodCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenWalnutDemoAndWalnutDemoCategory = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenWalnutDemoAndWalnutDemoCategory>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated'
}

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Line (line) */
export type LineRecord = RecordInterface & {
  __typename?: 'LineRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Line (line) */
export type LineRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Link box (link_box) */
export type LinkBoxRecord = RecordInterface & {
  __typename?: 'LinkBoxRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  links: Array<LinkRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Link box (link_box) */
export type LinkBoxRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export type LinkModelDescriptionField = {
  __typename?: 'LinkModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Link (link) */
export type LinkRecord = RecordInterface & {
  __typename?: 'LinkRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<LinkModelDescriptionField>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  page?: Maybe<PageRecord>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Link (link) */
export type LinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking locales */
export enum LinkingLocale {
  _nonLocalized = '_nonLocalized',
  En = 'en'
}

/** Specifies how to filter by linking locales */
export type LinkingLocalesFilter = {
  /** Filter linking records that link to current record in at least one of the specified locales */
  anyIn?: InputMaybe<Array<LinkingLocale>>;
  /** Filter linking records that do not link to current record in any of the specified locales */
  notIn?: InputMaybe<Array<LinkingLocale>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export type ListItemModelTextField = {
  __typename?: 'ListItemModelTextField';
  blocks: Array<HelpRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ListItemModelTooltipField = {
  __typename?: 'ListItemModelTooltipField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type List item (list_item) */
export type ListItemRecord = RecordInterface & {
  __typename?: 'ListItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  emojiIcon?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<FileField>;
  iconLink?: Maybe<IconRecord>;
  id: Scalars['ItemId']['output'];
  shopifyHidden?: Maybe<Scalars['BooleanType']['output']>;
  text: ListItemModelTextField;
  tooltip?: Maybe<ListItemModelTooltipField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type List item (list_item) */
export type ListItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type List (list) */
export type ListRecord = RecordInterface & {
  __typename?: 'ListRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<ListItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type List (list) */
export type ListRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

/** Block of type Logo header (logo_header) */
export type LogoHeaderRecord = RecordInterface & {
  __typename?: 'LogoHeaderRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  buttonHref?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Logo header (logo_header) */
export type LogoHeaderRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MembershipBillingCycleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MembershipBillingCycleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MembershipBillingCycleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MembershipBillingCycleModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Membership billing cycle (membership_billing_cycle) */
export type MembershipBillingCycleRecord = RecordInterface & {
  __typename?: 'MembershipBillingCycleRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Membership billing cycle (membership_billing_cycle) */
export type MembershipBillingCycleRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MembershipCurrencyModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MembershipCurrencyModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MembershipCurrencyModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MembershipCurrencyModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Membership currency (membership_currency) */
export type MembershipCurrencyRecord = RecordInterface & {
  __typename?: 'MembershipCurrencyRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Membership currency (membership_currency) */
export type MembershipCurrencyRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type MenuItemModelContentField = SubmenuGroupFullRecord | SubmenuGroupRecord | VerticalMenuLineRecord;

export type MenuItemModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuItemModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuItemModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  variant?: InputMaybe<StringFilter>;
};

export enum MenuItemModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Variant_ASC = 'variant_ASC',
  Variant_DESC = 'variant_DESC'
}

/** Record of type Menu item (menu_item) */
export type MenuItemRecord = RecordInterface & {
  __typename?: 'MenuItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<MenuItemModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Record of type Menu item (menu_item) */
export type MenuItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ModalModelContentField = {
  __typename?: 'ModalModelContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ModalModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ModalModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ModalModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ModalModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Slug_ASC = 'slug_ASC',
  Slug_DESC = 'slug_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type ModalModelTitleField = {
  __typename?: 'ModalModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Modal (modal) */
export type ModalRecord = RecordInterface & {
  __typename?: 'ModalRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: ModalModelContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  slug: Scalars['String']['output'];
  title: ModalModelTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Modal (modal) */
export type ModalRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png'
}

export type OfferTemplateCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<OfferTemplateCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OfferTemplateCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  color?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum OfferTemplateCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecord = RecordInterface & {
  __typename?: 'OfferTemplateCategoryRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allReferencingOfferTemplates: Array<OfferTemplateRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingOfferTemplatesMeta: CollectionMetadata;
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  children: Array<OfferTemplateCategoryRecord>;
  color?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  parent?: Maybe<OfferTemplateCategoryRecord>;
  position?: Maybe<Scalars['IntType']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecord_AllReferencingOfferTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenOfferTemplateAndOfferTemplateCategory>;
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecord_AllReferencingOfferTemplatesMetaArgs = {
  filter?: InputMaybe<OfferTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenOfferTemplateAndOfferTemplateCategory>;
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Offer template category (offer_template_category) */
export type OfferTemplateCategoryRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type OfferTemplateItemModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<OfferTemplateItemModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OfferTemplateItemModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum OfferTemplateItemModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Offer template item (offer_template_item) */
export type OfferTemplateItemRecord = RecordInterface & {
  __typename?: 'OfferTemplateItemRecord';
  _allDescriptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Offer template item (offer_template_item) */
export type OfferTemplateItemRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Offer template item (offer_template_item) */
export type OfferTemplateItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Offer template item (offer_template_item) */
export type OfferTemplateItemRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum OfferTemplateModelFieldsReferencingOfferTemplateCategoryModel {
  OfferTemplate_tags = 'offerTemplate_tags'
}

export type OfferTemplateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<OfferTemplateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OfferTemplateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  color?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  position?: InputMaybe<PositionFilter>;
  slug?: InputMaybe<SlugFilter>;
  tags?: InputMaybe<LinksFilter>;
  title?: InputMaybe<StringFilter>;
  trackingMethod?: InputMaybe<StringFilter>;
  trackingType?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum OfferTemplateModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  TrackingMethod_ASC = 'trackingMethod_ASC',
  TrackingMethod_DESC = 'trackingMethod_DESC',
  TrackingType_ASC = 'trackingType_ASC',
  TrackingType_DESC = 'trackingType_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Offer template (offer_template) */
export type OfferTemplateRecord = RecordInterface & {
  __typename?: 'OfferTemplateRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  color?: Maybe<ColorField>;
  conversionTypeSettings: Array<ConversionTypeRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  position?: Maybe<Scalars['IntType']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  steps: Array<OfferTemplatesStepRecord>;
  tags: Array<OfferTemplateCategoryRecord>;
  title?: Maybe<Scalars['String']['output']>;
  trackingMethod?: Maybe<Scalars['String']['output']>;
  trackingType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Offer template (offer_template) */
export type OfferTemplateRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Offer templates step item (offer_templates_step_item) */
export type OfferTemplatesStepItemRecord = RecordInterface & {
  __typename?: 'OfferTemplatesStepItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  stepItem?: Maybe<OfferTemplateItemRecord>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};


/** Block of type Offer templates step item (offer_templates_step_item) */
export type OfferTemplatesStepItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Offer templates step (offer_templates_step) */
export type OfferTemplatesStepRecord = RecordInterface & {
  __typename?: 'OfferTemplatesStepRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<OfferTemplatesStepItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Offer templates step (offer_templates_step) */
export type OfferTemplatesStepRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

export type PageHeaderModelHeaderDescriptionField = {
  __typename?: 'PageHeaderModelHeaderDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Page header (page_header) */
export type PageHeaderRecord = RecordInterface & {
  __typename?: 'PageHeaderRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  headerDescription?: Maybe<PageHeaderModelHeaderDescriptionField>;
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Page header (page_header) */
export type PageHeaderRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PageHeroModelAlternativeContentBlocksField = AchievementBlockRecord | BulletListRecord | ButtonRecord | CompanyBlockRecord | CompetitorBlockRecord | ContentSectionRecord | GridContentRecord | HeadlineRecord | HubspotRecord | SpacerRecord | UsersBlockRecord | VideoRecord;

export type PageHeroModelAlternativeContentField = {
  __typename?: 'PageHeroModelAlternativeContentField';
  blocks: Array<PageHeroModelAlternativeContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PageHeroModelCustomContentBlocksField = AchievementBlockRecord | BulletListRecord | ButtonRecord | CompanyBlockRecord | CompetitorBlockRecord | ContentSectionRecord | GridContentRecord | HeadlineRecord | HubspotRecord | SpacerRecord | UsersBlockRecord | VideoRecord;

export type PageHeroModelCustomContentField = {
  __typename?: 'PageHeroModelCustomContentField';
  blocks: Array<PageHeroModelCustomContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PageHeroModelCustomTitleField = {
  __typename?: 'PageHeroModelCustomTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PageHeroModelExtraContentBlocksField = AchievementBlockRecord | BulletListRecord | ButtonRecord | CompanyBlockRecord | CompetitorBlockRecord | ContentSectionRecord | GridContentRecord | HeadlineRecord | HubspotRecord | SpacerRecord | UsersBlockRecord | VideoRecord;

export type PageHeroModelExtraContentField = {
  __typename?: 'PageHeroModelExtraContentField';
  blocks: Array<PageHeroModelExtraContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PageHeroModelHeroDescriptionField = {
  __typename?: 'PageHeroModelHeroDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Page hero (page_hero) */
export type PageHeroRecord = RecordInterface & {
  __typename?: 'PageHeroRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alternativeContent?: Maybe<PageHeroModelAlternativeContentField>;
  badge?: Maybe<FileField>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customContent?: Maybe<PageHeroModelCustomContentField>;
  customTitle?: Maybe<PageHeroModelCustomTitleField>;
  extraContent?: Maybe<PageHeroModelExtraContentField>;
  full?: Maybe<Scalars['BooleanType']['output']>;
  heroDescription?: Maybe<PageHeroModelHeroDescriptionField>;
  id: Scalars['ItemId']['output'];
  pageHeroContent: Array<BulletListRecord>;
  transparent?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Page hero (page_hero) */
export type PageHeroRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PageModelContentField = AboutUsBlockRecord | AchievementBlockRecord | BannerRecord | BlogSectionRecord | BoxRecord | ButtonRecord | ButtonsGroupRecord | CarouselRecord | CompareFeatureRecord | CompareProductRecord | ComparisonRecord | ComparisonTableRecord | ContentImageSectionRecord | ContentSectionRecord | ContentSectionV2Record | DynamicMegablockRecord | FaqRecord | FeaturesBlockRecord | FeaturesSectionRecord | FormBoxRecord | GridContentRecord | GridRecord | HighlightedBoxRecord | IntegrationCarouselRecord | InternalVideoRecord | LineRecord | LogoHeaderRecord | PageHeaderRecord | PageHeroRecord | PhotoRecord | PricingBlockRecord | PricingPackageBlockRecord | RichTextRecord | SpacerRecord | TableBlockRecord | TeamBlockRecord | TestimonialRecord | TextRecord | VideoRecord;

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  breadcrumbTitle?: InputMaybe<StringFilter>;
  category?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  disableLogoLink?: InputMaybe<BooleanFilter>;
  disablePaddings?: InputMaybe<BooleanFilter>;
  extraImage?: InputMaybe<FileFilter>;
  hideFooter?: InputMaybe<BooleanFilter>;
  hideMenu?: InputMaybe<BooleanFilter>;
  hidePrimaryMenu?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  mobileImage?: InputMaybe<FileFilter>;
  parentPages?: InputMaybe<LinksFilter>;
  redirect?: InputMaybe<LinkFilter>;
  redirectUrl?: InputMaybe<StringFilter>;
  schemaMarkup?: InputMaybe<JsonFilter>;
  seo?: InputMaybe<SeoFilter>;
  sidebar?: InputMaybe<LinkFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum PageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  BreadcrumbTitle_ASC = 'breadcrumbTitle_ASC',
  BreadcrumbTitle_DESC = 'breadcrumbTitle_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  DisableLogoLink_ASC = 'disableLogoLink_ASC',
  DisableLogoLink_DESC = 'disableLogoLink_DESC',
  DisablePaddings_ASC = 'disablePaddings_ASC',
  DisablePaddings_DESC = 'disablePaddings_DESC',
  HideFooter_ASC = 'hideFooter_ASC',
  HideFooter_DESC = 'hideFooter_DESC',
  HideMenu_ASC = 'hideMenu_ASC',
  HideMenu_DESC = 'hideMenu_DESC',
  HidePrimaryMenu_ASC = 'hidePrimaryMenu_ASC',
  HidePrimaryMenu_DESC = 'hidePrimaryMenu_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  RedirectUrl_ASC = 'redirectUrl_ASC',
  RedirectUrl_DESC = 'redirectUrl_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type PageModelSidebarField = HubspotFormRecord | WebBannerRecord;

/** Record of type Page (page) */
export type PageRecord = RecordInterface & {
  __typename?: 'PageRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  breadcrumbTitle?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CategoryRecord>;
  content: Array<PageModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disableLogoLink?: Maybe<Scalars['BooleanType']['output']>;
  disablePaddings?: Maybe<Scalars['BooleanType']['output']>;
  extraImage?: Maybe<FileField>;
  hideFooter?: Maybe<Scalars['BooleanType']['output']>;
  hideMenu?: Maybe<Scalars['BooleanType']['output']>;
  hidePrimaryMenu?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  mobileImage?: Maybe<FileField>;
  parentPages: Array<PageRecord>;
  redirect?: Maybe<PageRecord>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  schemaMarkup?: Maybe<Scalars['JsonField']['output']>;
  seo?: Maybe<SeoField>;
  sidebar?: Maybe<PageModelSidebarField>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Page (page) */
export type PageRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Photo (photo) */
export type PhotoRecord = RecordInterface & {
  __typename?: 'PhotoRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  imageLink?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<FileField>;
  photoMobile?: Maybe<FileField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Photo (photo) */
export type PhotoRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export type PricingBlockModelPricingGroupDescriptionField = {
  __typename?: 'PricingBlockModelPricingGroupDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PricingBlockModelPricingGroupTitleField = {
  __typename?: 'PricingBlockModelPricingGroupTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Pricing block (pricing_block) */
export type PricingBlockRecord = RecordInterface & {
  __typename?: 'PricingBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  pricingGroup: PricingGroupRecord;
  pricingGroupCompanies: CompanyBlockRecord;
  pricingGroupCompareTable: FullFeatureBlockRecord;
  pricingGroupDescription: PricingBlockModelPricingGroupDescriptionField;
  pricingGroupTitle: PricingBlockModelPricingGroupTitleField;
  pricingGroups: Array<PricingGroupRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Pricing block (pricing_block) */
export type PricingBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Pricing boost (pricing_boost) */
export type PricingBoostRecord = RecordInterface & {
  __typename?: 'PricingBoostRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  membershipBillingCycle: MembershipBillingCycleRecord;
  title: HelpRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Pricing boost (pricing_boost) */
export type PricingBoostRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PricingGroupModelDescriptionField = {
  __typename?: 'PricingGroupModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PricingGroupModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PricingGroupModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingGroupModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  estimatePrice?: InputMaybe<JsonFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  pricingGroupPage?: InputMaybe<LinkFilter>;
  pricingPlans?: InputMaybe<LinksFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  variant?: InputMaybe<StringFilter>;
};

export enum PricingGroupModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Variant_ASC = 'variant_ASC',
  Variant_DESC = 'variant_DESC'
}

/** Record of type Pricing group (pricing_group) */
export type PricingGroupRecord = RecordInterface & {
  __typename?: 'PricingGroupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: PricingGroupModelDescriptionField;
  estimatePrice: Scalars['JsonField']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  pricingGroupPage: PageRecord;
  pricingPlans: Array<PricingPlanRecord>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Record of type Pricing group (pricing_group) */
export type PricingGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PricingPackageBlockModelClaimsField = {
  __typename?: 'PricingPackageBlockModelClaimsField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Pricing package block (pricing_package_block) */
export type PricingPackageBlockRecord = RecordInterface & {
  __typename?: 'PricingPackageBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  claims?: Maybe<PricingPackageBlockModelClaimsField>;
  content: Array<ButtonRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pricingPlan: PricingPlanRecord;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Pricing package block (pricing_package_block) */
export type PricingPackageBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PricingPlanModelContentField = {
  __typename?: 'PricingPlanModelContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type PricingPlanModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PricingPlanModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingPlanModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  content?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  ctaButtonHref?: InputMaybe<StringFilter>;
  ctaButtonHrefLogged?: InputMaybe<StringFilter>;
  ctaButtonLabel?: InputMaybe<StringFilter>;
  ctaButtonLabelLogged?: InputMaybe<StringFilter>;
  customPriceCaption?: InputMaybe<StringFilter>;
  customPriceTitle?: InputMaybe<StringFilter>;
  customPriceTitleEur?: InputMaybe<StringFilter>;
  hideFrom?: InputMaybe<BooleanFilter>;
  hubspotForm?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  membershipPlanId?: InputMaybe<StringFilter>;
  monthlyPrice?: InputMaybe<IntegerFilter>;
  monthlyPriceEur?: InputMaybe<IntegerFilter>;
  name?: InputMaybe<StringFilter>;
  nameFormatted?: InputMaybe<StructuredTextFilter>;
  position?: InputMaybe<PositionFilter>;
  pricingBlock?: InputMaybe<StructuredTextFilter>;
  revenueLimit?: InputMaybe<IntegerFilter>;
  selfService?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  yearlyPrice?: InputMaybe<IntegerFilter>;
  yearlyPriceEur?: InputMaybe<IntegerFilter>;
};

export type PricingPlanModelNameFormattedField = {
  __typename?: 'PricingPlanModelNameFormattedField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export enum PricingPlanModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  CtaButtonHrefLogged_ASC = 'ctaButtonHrefLogged_ASC',
  CtaButtonHrefLogged_DESC = 'ctaButtonHrefLogged_DESC',
  CtaButtonHref_ASC = 'ctaButtonHref_ASC',
  CtaButtonHref_DESC = 'ctaButtonHref_DESC',
  CtaButtonLabelLogged_ASC = 'ctaButtonLabelLogged_ASC',
  CtaButtonLabelLogged_DESC = 'ctaButtonLabelLogged_DESC',
  CtaButtonLabel_ASC = 'ctaButtonLabel_ASC',
  CtaButtonLabel_DESC = 'ctaButtonLabel_DESC',
  CustomPriceCaption_ASC = 'customPriceCaption_ASC',
  CustomPriceCaption_DESC = 'customPriceCaption_DESC',
  CustomPriceTitleEur_ASC = 'customPriceTitleEur_ASC',
  CustomPriceTitleEur_DESC = 'customPriceTitleEur_DESC',
  CustomPriceTitle_ASC = 'customPriceTitle_ASC',
  CustomPriceTitle_DESC = 'customPriceTitle_DESC',
  HideFrom_ASC = 'hideFrom_ASC',
  HideFrom_DESC = 'hideFrom_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MembershipPlanId_ASC = 'membershipPlanId_ASC',
  MembershipPlanId_DESC = 'membershipPlanId_DESC',
  MonthlyPriceEur_ASC = 'monthlyPriceEur_ASC',
  MonthlyPriceEur_DESC = 'monthlyPriceEur_DESC',
  MonthlyPrice_ASC = 'monthlyPrice_ASC',
  MonthlyPrice_DESC = 'monthlyPrice_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  RevenueLimit_ASC = 'revenueLimit_ASC',
  RevenueLimit_DESC = 'revenueLimit_DESC',
  SelfService_ASC = 'selfService_ASC',
  SelfService_DESC = 'selfService_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  YearlyPriceEur_ASC = 'yearlyPriceEur_ASC',
  YearlyPriceEur_DESC = 'yearlyPriceEur_DESC',
  YearlyPrice_ASC = 'yearlyPrice_ASC',
  YearlyPrice_DESC = 'yearlyPrice_DESC'
}

export type PricingPlanModelPricingBlockField = {
  __typename?: 'PricingPlanModelPricingBlockField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Pricing plan (pricing_plan) */
export type PricingPlanRecord = RecordInterface & {
  __typename?: 'PricingPlanRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: PricingPlanModelContentField;
  createdAt: Scalars['DateTime']['output'];
  ctaButtonHref?: Maybe<Scalars['String']['output']>;
  ctaButtonHrefLogged?: Maybe<Scalars['String']['output']>;
  ctaButtonLabel?: Maybe<Scalars['String']['output']>;
  ctaButtonLabelLogged?: Maybe<Scalars['String']['output']>;
  customPriceCaption?: Maybe<Scalars['String']['output']>;
  customPriceTitle?: Maybe<Scalars['String']['output']>;
  customPriceTitleEur?: Maybe<Scalars['String']['output']>;
  featureOverride: Array<CompareFeatureItemRecord>;
  hideFrom?: Maybe<Scalars['BooleanType']['output']>;
  hubspotForm?: Maybe<HubspotFormRecord>;
  id: Scalars['ItemId']['output'];
  membershipPlanId?: Maybe<Scalars['String']['output']>;
  monthlyPrice?: Maybe<Scalars['IntType']['output']>;
  monthlyPriceEur?: Maybe<Scalars['IntType']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameFormatted: PricingPlanModelNameFormattedField;
  position?: Maybe<Scalars['IntType']['output']>;
  pricingBlock?: Maybe<PricingPlanModelPricingBlockField>;
  revenueLimit?: Maybe<Scalars['IntType']['output']>;
  selfService?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  yearlyPrice?: Maybe<Scalars['IntType']['output']>;
  yearlyPriceEur?: Maybe<Scalars['IntType']['output']>;
};


/** Record of type Pricing plan (pricing_plan) */
export type PricingPlanRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PricingPriceModelTitleField = {
  __typename?: 'PricingPriceModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Pricing price (pricing_price) */
export type PricingPriceRecord = RecordInterface & {
  __typename?: 'PricingPriceRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  membershipBillingCycle: MembershipBillingCycleRecord;
  membershipCurrency: MembershipCurrencyRecord;
  title: PricingPriceModelTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Pricing price (pricing_price) */
export type PricingPriceRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type PricingTableModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PricingTableModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PricingTableModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pricingGroup?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum PricingTableModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Pricing table (pricing_table) */
export type PricingTableRecord = RecordInterface & {
  __typename?: 'PricingTableRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JsonField']['output']>;
  id: Scalars['ItemId']['output'];
  pricingGroup: PricingGroupRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Pricing table (pricing_table) */
export type PricingTableRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The query root for this schema */
export type Query = {
  __typename?: 'Query';
  /** Returns meta information regarding a record collection */
  _allAcademyChapterPartsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAcademyChaptersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAcademyHomepagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAcademyResourceTypesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAcademyResourcesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAcademySectionsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAchievementsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAnnouncementsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAppAnnouncementsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAppIntegrationCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAppIntegrationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAuthorsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allAutoIntegrationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBlogBannersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBlogPostsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBlogTagsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCompaniesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCompareTablesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCompetitorsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCustomTenantTranslationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allDashboardArticlesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFeaturesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFeedbacksMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFooterLinksMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFooterMenusMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFullComparisonsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allHubspotFormsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allIconsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allIntegrationListsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allIntegrationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allMembershipBillingCyclesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allMembershipCurrenciesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allMenuItemsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allModalsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allOfferTemplateCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allOfferTemplateItemsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allOfferTemplatesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPricingGroupsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPricingPlansMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPricingTablesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allQuickSetupsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allReviewsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSystemDescriptionOverridesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSystemDescriptionsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTeamMembersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTrackingMethodCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTrackingMethodsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTranslationItemsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTranslationsMeta: CollectionMetadata;
  /** Returns meta information regarding an assets collection */
  _allUploadsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allUsersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allWalnutDemoCategoriesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allWalnutDemosMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allWebBannersMeta: CollectionMetadata;
  /** Returns the single instance record */
  _site: Site;
  /** Returns a specific record */
  academyChapter?: Maybe<AcademyChapterRecord>;
  /** Returns a specific record */
  academyChapterPart?: Maybe<AcademyChapterPartRecord>;
  /** Returns a specific record */
  academyHomepage?: Maybe<AcademyHomepageRecord>;
  /** Returns a specific record */
  academyResource?: Maybe<AcademyResourceRecord>;
  /** Returns a specific record */
  academyResourceType?: Maybe<AcademyResourceTypeRecord>;
  /** Returns a specific record */
  academySection?: Maybe<AcademySectionRecord>;
  /** Returns a specific record */
  achievement?: Maybe<AchievementRecord>;
  /** Returns a collection of records */
  allAcademyChapterParts: Array<AcademyChapterPartRecord>;
  /** Returns a collection of records */
  allAcademyChapters: Array<AcademyChapterRecord>;
  /** Returns a collection of records */
  allAcademyHomepages: Array<AcademyHomepageRecord>;
  /** Returns a collection of records */
  allAcademyResourceTypes: Array<AcademyResourceTypeRecord>;
  /** Returns a collection of records */
  allAcademyResources: Array<AcademyResourceRecord>;
  /** Returns a collection of records */
  allAcademySections: Array<AcademySectionRecord>;
  /** Returns a collection of records */
  allAchievements: Array<AchievementRecord>;
  /** Returns a collection of records */
  allAnnouncements: Array<AnnouncementRecord>;
  /** Returns a collection of records */
  allAppAnnouncements: Array<AppAnnouncementRecord>;
  /** Returns a collection of records */
  allAppIntegrationCategories: Array<AppIntegrationCategoryRecord>;
  /** Returns a collection of records */
  allAppIntegrations: Array<AppIntegrationRecord>;
  /** Returns a collection of records */
  allAuthors: Array<AuthorRecord>;
  /** Returns a collection of records */
  allAutoIntegrations: Array<AutoIntegrationRecord>;
  /** Returns a collection of records */
  allBlogBanners: Array<BlogBannerRecord>;
  /** Returns a collection of records */
  allBlogPosts: Array<BlogPostRecord>;
  /** Returns a collection of records */
  allBlogTags: Array<BlogTagRecord>;
  /** Returns a collection of records */
  allCategories: Array<CategoryRecord>;
  /** Returns a collection of records */
  allCompanies: Array<CompanyRecord>;
  /** Returns a collection of records */
  allCompareTables: Array<CompareTableRecord>;
  /** Returns a collection of records */
  allCompetitors: Array<CompetitorRecord>;
  /** Returns a collection of records */
  allCustomTenantTranslations: Array<CustomTenantTranslationRecord>;
  /** Returns a collection of records */
  allDashboardArticles: Array<DashboardArticleRecord>;
  /** Returns a collection of records */
  allFeatures: Array<FeatureRecord>;
  /** Returns a collection of records */
  allFeedbacks: Array<FeedbackRecord>;
  /** Returns a collection of records */
  allFooterLinks: Array<FooterLinkRecord>;
  /** Returns a collection of records */
  allFooterMenus: Array<FooterMenuRecord>;
  /** Returns a collection of records */
  allFullComparisons: Array<FullComparisonRecord>;
  /** Returns a collection of records */
  allHubspotForms: Array<HubspotFormRecord>;
  /** Returns a collection of records */
  allIcons: Array<IconRecord>;
  /** Returns a collection of records */
  allIntegrationLists: Array<IntegrationListRecord>;
  /** Returns a collection of records */
  allIntegrations: Array<IntegrationRecord>;
  /** Returns a collection of records */
  allMembershipBillingCycles: Array<MembershipBillingCycleRecord>;
  /** Returns a collection of records */
  allMembershipCurrencies: Array<MembershipCurrencyRecord>;
  /** Returns a collection of records */
  allMenuItems: Array<MenuItemRecord>;
  /** Returns a collection of records */
  allModals: Array<ModalRecord>;
  /** Returns a collection of records */
  allOfferTemplateCategories: Array<OfferTemplateCategoryRecord>;
  /** Returns a collection of records */
  allOfferTemplateItems: Array<OfferTemplateItemRecord>;
  /** Returns a collection of records */
  allOfferTemplates: Array<OfferTemplateRecord>;
  /** Returns a collection of records */
  allPages: Array<PageRecord>;
  /** Returns a collection of records */
  allPricingGroups: Array<PricingGroupRecord>;
  /** Returns a collection of records */
  allPricingPlans: Array<PricingPlanRecord>;
  /** Returns a collection of records */
  allPricingTables: Array<PricingTableRecord>;
  /** Returns a collection of records */
  allQuickSetups: Array<QuickSetupRecord>;
  /** Returns a collection of records */
  allReviews: Array<ReviewRecord>;
  /** Returns a collection of records */
  allSystemDescriptionOverrides: Array<SystemDescriptionOverrideRecord>;
  /** Returns a collection of records */
  allSystemDescriptions: Array<SystemDescriptionRecord>;
  /** Returns a collection of records */
  allTeamMembers: Array<TeamMemberRecord>;
  /** Returns a collection of records */
  allTrackingMethodCategories: Array<TrackingMethodCategoryRecord>;
  /** Returns a collection of records */
  allTrackingMethods: Array<TrackingMethodRecord>;
  /** Returns a collection of records */
  allTranslationItems: Array<TranslationItemRecord>;
  /** Returns a collection of records */
  allTranslations: Array<TranslationRecord>;
  /** Returns a collection of assets */
  allUploads: Array<FileField>;
  /** Returns a collection of records */
  allUsers: Array<UserRecord>;
  /** Returns a collection of records */
  allWalnutDemoCategories: Array<WalnutDemoCategoryRecord>;
  /** Returns a collection of records */
  allWalnutDemos: Array<WalnutDemoRecord>;
  /** Returns a collection of records */
  allWebBanners: Array<WebBannerRecord>;
  /** Returns a specific record */
  announcement?: Maybe<AnnouncementRecord>;
  /** Returns a specific record */
  appAnnouncement?: Maybe<AppAnnouncementRecord>;
  /** Returns a specific record */
  appIntegration?: Maybe<AppIntegrationRecord>;
  /** Returns a specific record */
  appIntegrationCategory?: Maybe<AppIntegrationCategoryRecord>;
  /** Returns a specific record */
  author?: Maybe<AuthorRecord>;
  /** Returns a specific record */
  autoIntegration?: Maybe<AutoIntegrationRecord>;
  /** Returns a specific record */
  blogBanner?: Maybe<BlogBannerRecord>;
  /** Returns the single instance record */
  blogCarousel?: Maybe<BlogCarouselRecord>;
  /** Returns a specific record */
  blogPost?: Maybe<BlogPostRecord>;
  /** Returns a specific record */
  blogTag?: Maybe<BlogTagRecord>;
  /** Returns a specific record */
  category?: Maybe<CategoryRecord>;
  /** Returns a specific record */
  company?: Maybe<CompanyRecord>;
  /** Returns a specific record */
  compareTable?: Maybe<CompareTableRecord>;
  /** Returns a specific record */
  competitor?: Maybe<CompetitorRecord>;
  /** Returns a specific record */
  customTenantTranslation?: Maybe<CustomTenantTranslationRecord>;
  /** Returns a specific record */
  dashboardArticle?: Maybe<DashboardArticleRecord>;
  /** Returns a specific record */
  feature?: Maybe<FeatureRecord>;
  /** Returns a specific record */
  feedback?: Maybe<FeedbackRecord>;
  /** Returns the single instance record */
  footerExtra?: Maybe<FooterExtraRecord>;
  /** Returns a specific record */
  footerLink?: Maybe<FooterLinkRecord>;
  /** Returns a specific record */
  footerMenu?: Maybe<FooterMenuRecord>;
  /** Returns a specific record */
  fullComparison?: Maybe<FullComparisonRecord>;
  /** Returns a specific record */
  hubspotForm?: Maybe<HubspotFormRecord>;
  /** Returns a specific record */
  icon?: Maybe<IconRecord>;
  /** Returns the single instance record */
  implementationBanner?: Maybe<ImplementationBannerRecord>;
  /** Returns the single instance record */
  inAppPricingFaq?: Maybe<InAppPricingFaqRecord>;
  /** Returns a specific record */
  integration?: Maybe<IntegrationRecord>;
  /** Returns a specific record */
  integrationList?: Maybe<IntegrationListRecord>;
  /** Returns a specific record */
  membershipBillingCycle?: Maybe<MembershipBillingCycleRecord>;
  /** Returns a specific record */
  membershipCurrency?: Maybe<MembershipCurrencyRecord>;
  /** Returns a specific record */
  menuItem?: Maybe<MenuItemRecord>;
  /** Returns a specific record */
  modal?: Maybe<ModalRecord>;
  /** Returns a specific record */
  offerTemplate?: Maybe<OfferTemplateRecord>;
  /** Returns a specific record */
  offerTemplateCategory?: Maybe<OfferTemplateCategoryRecord>;
  /** Returns a specific record */
  offerTemplateItem?: Maybe<OfferTemplateItemRecord>;
  /** Returns a specific record */
  page?: Maybe<PageRecord>;
  /** Returns a specific record */
  pricingGroup?: Maybe<PricingGroupRecord>;
  /** Returns a specific record */
  pricingPlan?: Maybe<PricingPlanRecord>;
  /** Returns a specific record */
  pricingTable?: Maybe<PricingTableRecord>;
  /** Returns a specific record */
  quickSetup?: Maybe<QuickSetupRecord>;
  /** Returns the single instance record */
  referralProgram?: Maybe<ReferralProgramRecord>;
  /** Returns the single instance record */
  registration?: Maybe<RegistrationRecord>;
  /** Returns the single instance record */
  requestAssistance?: Maybe<RequestAssistanceRecord>;
  /** Returns a specific record */
  review?: Maybe<ReviewRecord>;
  /** Returns a specific record */
  systemDescription?: Maybe<SystemDescriptionRecord>;
  /** Returns a specific record */
  systemDescriptionOverride?: Maybe<SystemDescriptionOverrideRecord>;
  /** Returns a specific record */
  teamMember?: Maybe<TeamMemberRecord>;
  /** Returns a specific record */
  trackingMethod?: Maybe<TrackingMethodRecord>;
  /** Returns a specific record */
  trackingMethodCategory?: Maybe<TrackingMethodCategoryRecord>;
  /** Returns a specific record */
  translation?: Maybe<TranslationRecord>;
  /** Returns a specific record */
  translationItem?: Maybe<TranslationItemRecord>;
  /** Returns a specific asset */
  upload?: Maybe<FileField>;
  /** Returns a specific record */
  user?: Maybe<UserRecord>;
  /** Returns a specific record */
  walnutDemo?: Maybe<WalnutDemoRecord>;
  /** Returns a specific record */
  walnutDemoCategory?: Maybe<WalnutDemoCategoryRecord>;
  /** Returns a specific record */
  webBanner?: Maybe<WebBannerRecord>;
};


/** The query root for this schema */
export type Query_AllAcademyChapterPartsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterPartModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAcademyChaptersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAcademyHomepagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyHomepageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAcademyResourceTypesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceTypeModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAcademyResourcesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAcademySectionsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademySectionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAchievementsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AchievementModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAnnouncementsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AnnouncementModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAppAnnouncementsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppAnnouncementModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAppIntegrationCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAppIntegrationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAuthorsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AuthorModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllAutoIntegrationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AutoIntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBlogBannersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogBannerModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBlogPostsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogPostModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBlogTagsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogTagModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCompaniesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompanyModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCompareTablesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompareTableModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCompetitorsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompetitorModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCustomTenantTranslationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CustomTenantTranslationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllDashboardArticlesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DashboardArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFeaturesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeatureModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFeedbacksMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeedbackModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFooterLinksMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FooterLinkModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFooterMenusMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FooterMenuModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFullComparisonsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FullComparisonModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllHubspotFormsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HubspotFormModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllIconsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IconModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllIntegrationListsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IntegrationListModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllIntegrationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllMembershipBillingCyclesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MembershipBillingCycleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllMembershipCurrenciesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MembershipCurrencyModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllMenuItemsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MenuItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllModalsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ModalModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllOfferTemplateCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllOfferTemplateItemsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllOfferTemplatesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPagesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPricingGroupsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingGroupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPricingPlansMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingPlanModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPricingTablesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingTableModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllQuickSetupsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<QuickSetupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllReviewsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReviewModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSystemDescriptionOverridesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SystemDescriptionOverrideModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSystemDescriptionsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SystemDescriptionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllTeamMembersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TeamMemberModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllTrackingMethodCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllTrackingMethodsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllTranslationItemsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TranslationItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllTranslationsMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TranslationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllUploadsMetaArgs = {
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllUsersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UserModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllWalnutDemoCategoriesMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllWalnutDemosMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllWebBannersMetaArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WebBannerModelFilter>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_SiteArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryAcademyChapterArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyChapterModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAcademyChapterPartArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterPartModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyChapterPartModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAcademyHomepageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyHomepageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyHomepageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAcademyResourceArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyResourceModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAcademyResourceTypeArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceTypeModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyResourceTypeModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAcademySectionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademySectionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademySectionModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAchievementArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AchievementModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AchievementModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAllAcademyChapterPartsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterPartModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyChapterPartModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAcademyChaptersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyChapterModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyChapterModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAcademyHomepagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyHomepageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyHomepageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAcademyResourceTypesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceTypeModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyResourceTypeModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAcademyResourcesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademyResourceModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademyResourceModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAcademySectionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AcademySectionModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AcademySectionModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAchievementsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AchievementModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AchievementModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAnnouncementsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AnnouncementModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AnnouncementModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAppAnnouncementsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppAnnouncementModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppAnnouncementModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAppIntegrationCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationCategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppIntegrationCategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAppIntegrationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppIntegrationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAuthorsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AuthorModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AuthorModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllAutoIntegrationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AutoIntegrationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AutoIntegrationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllBlogBannersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogBannerModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogBannerModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllBlogPostsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogPostModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogPostModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllBlogTagsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogTagModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogTagModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllCompaniesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompanyModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CompanyModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllCompareTablesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompareTableModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CompareTableModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllCompetitorsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompetitorModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CompetitorModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllCustomTenantTranslationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CustomTenantTranslationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CustomTenantTranslationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllDashboardArticlesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DashboardArticleModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<DashboardArticleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllFeaturesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeatureModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeatureModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllFeedbacksArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeedbackModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeedbackModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllFooterLinksArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FooterLinkModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FooterLinkModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllFooterMenusArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FooterMenuModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FooterMenuModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllFullComparisonsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FullComparisonModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FullComparisonModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllHubspotFormsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HubspotFormModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HubspotFormModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllIconsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IconModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IconModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllIntegrationListsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IntegrationListModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IntegrationListModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllIntegrationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IntegrationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IntegrationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllMembershipBillingCyclesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MembershipBillingCycleModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MembershipBillingCycleModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllMembershipCurrenciesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MembershipCurrencyModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MembershipCurrencyModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllMenuItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MenuItemModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MenuItemModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllModalsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ModalModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ModalModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllOfferTemplateCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateCategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateCategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllOfferTemplateItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateItemModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateItemModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllOfferTemplatesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllPagesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllPricingGroupsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingGroupModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PricingGroupModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllPricingPlansArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingPlanModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PricingPlanModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllPricingTablesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingTableModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PricingTableModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllQuickSetupsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<QuickSetupModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<QuickSetupModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllReviewsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReviewModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ReviewModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllSystemDescriptionOverridesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SystemDescriptionOverrideModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SystemDescriptionOverrideModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllSystemDescriptionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SystemDescriptionModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SystemDescriptionModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllTeamMembersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TeamMemberModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TeamMemberModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllTrackingMethodCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodCategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TrackingMethodCategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllTrackingMethodsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TrackingMethodModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllTranslationItemsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TranslationItemModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TranslationItemModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllTranslationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TranslationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TranslationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllUploadsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllUsersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UserModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UserModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllWalnutDemoCategoriesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoCategoryModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WalnutDemoCategoryModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllWalnutDemosArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WalnutDemoModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllWebBannersArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WebBannerModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WebBannerModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAnnouncementArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AnnouncementModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AnnouncementModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAppAnnouncementArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppAnnouncementModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppAnnouncementModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAppIntegrationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppIntegrationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAppIntegrationCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AppIntegrationCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AppIntegrationCategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAuthorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AuthorModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AuthorModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryAutoIntegrationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<AutoIntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AutoIntegrationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryBlogBannerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogBannerModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogBannerModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryBlogCarouselArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryBlogPostArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogPostModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogPostModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryBlogTagArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<BlogTagModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogTagModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCompanyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompanyModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CompanyModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCompareTableArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompareTableModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CompareTableModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCompetitorArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CompetitorModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CompetitorModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCustomTenantTranslationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CustomTenantTranslationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CustomTenantTranslationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryDashboardArticleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<DashboardArticleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<DashboardArticleModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFeatureArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeatureModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeatureModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFeedbackArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FeedbackModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FeedbackModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFooterExtraArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryFooterLinkArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FooterLinkModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FooterLinkModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFooterMenuArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FooterMenuModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FooterMenuModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFullComparisonArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<FullComparisonModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FullComparisonModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryHubspotFormArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<HubspotFormModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HubspotFormModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryIconArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IconModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IconModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryImplementationBannerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryInAppPricingFaqArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryIntegrationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IntegrationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IntegrationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryIntegrationListArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<IntegrationListModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IntegrationListModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryMembershipBillingCycleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MembershipBillingCycleModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MembershipBillingCycleModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryMembershipCurrencyArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MembershipCurrencyModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MembershipCurrencyModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryMenuItemArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<MenuItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<MenuItemModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryModalArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ModalModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ModalModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryOfferTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryOfferTemplateCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateCategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryOfferTemplateItemArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<OfferTemplateItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<OfferTemplateItemModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PageModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPricingGroupArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingGroupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PricingGroupModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPricingPlanArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingPlanModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PricingPlanModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPricingTableArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<PricingTableModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PricingTableModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryQuickSetupArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<QuickSetupModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<QuickSetupModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryReferralProgramArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryRegistrationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryRequestAssistanceArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryReviewArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<ReviewModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ReviewModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySystemDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SystemDescriptionModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SystemDescriptionModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySystemDescriptionOverrideArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<SystemDescriptionOverrideModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SystemDescriptionOverrideModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTeamMemberArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TeamMemberModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TeamMemberModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTrackingMethodArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TrackingMethodModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTrackingMethodCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TrackingMethodCategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTranslationArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TranslationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TranslationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTranslationItemArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TranslationItemModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TranslationItemModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryUploadArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UploadFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
};


/** The query root for this schema */
export type QueryUserArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<UserModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UserModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryWalnutDemoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WalnutDemoModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryWalnutDemoCategoryArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoCategoryModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WalnutDemoCategoryModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryWebBannerArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WebBannerModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WebBannerModelOrderBy>>>;
};

export type QuickSetupModelDescriptionField = {
  __typename?: 'QuickSetupModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type QuickSetupModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuickSetupModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuickSetupModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  caption?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  menuText?: InputMaybe<StringFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  video?: InputMaybe<VideoFilter>;
};

export enum QuickSetupModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Caption_ASC = 'caption_ASC',
  Caption_DESC = 'caption_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Icon_ASC = 'icon_ASC',
  Icon_DESC = 'icon_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MenuText_ASC = 'menuText_ASC',
  MenuText_DESC = 'menuText_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Quick setup (quick_setup) */
export type QuickSetupRecord = RecordInterface & {
  __typename?: 'QuickSetupRecord';
  _allTitleLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  children: Array<QuickSetupRecord>;
  content: Array<SystemDescriptionLinkRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<QuickSetupModelDescriptionField>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  menuText?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<QuickSetupRecord>;
  position?: Maybe<Scalars['IntType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<VideoField>;
};


/** Record of type Quick setup (quick_setup) */
export type QuickSetupRecord_AllTitleLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Quick setup (quick_setup) */
export type QuickSetupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Quick setup (quick_setup) */
export type QuickSetupRecordTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type RecordInterface = {
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
};


export type RecordInterface_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ReferralItemModelDescriptionField = {
  __typename?: 'ReferralItemModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ReferralItemModelHeadlineField = {
  __typename?: 'ReferralItemModelHeadlineField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Referral item (referral_item) */
export type ReferralItemRecord = RecordInterface & {
  __typename?: 'ReferralItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: ReferralItemModelDescriptionField;
  headline: ReferralItemModelHeadlineField;
  id: Scalars['ItemId']['output'];
  image: FileField;
  showOnlyForSignedUpUsers?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Referral item (referral_item) */
export type ReferralItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type ReferralProgramModelDescriptionField = {
  __typename?: 'ReferralProgramModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ReferralProgramModelHeadlineField = {
  __typename?: 'ReferralProgramModelHeadlineField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type ReferralProgramModelSignedupDescriptionField = {
  __typename?: 'ReferralProgramModelSignedupDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Referral program (referral_program) */
export type ReferralProgramRecord = RecordInterface & {
  __typename?: 'ReferralProgramRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<ReferralItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  description: ReferralProgramModelDescriptionField;
  headline: ReferralProgramModelHeadlineField;
  id: Scalars['ItemId']['output'];
  image: FileField;
  signedupDescription?: Maybe<ReferralProgramModelSignedupDescriptionField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Referral program (referral_program) */
export type ReferralProgramRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type RegistrationModelDescriptionField = {
  __typename?: 'RegistrationModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type RegistrationModelHeadlineField = {
  __typename?: 'RegistrationModelHeadlineField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type RegistrationModelHeadlineFieldMultiLocaleField = {
  __typename?: 'RegistrationModelHeadlineFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<RegistrationModelHeadlineField>;
};

export type RegistrationModelSidebarField = {
  __typename?: 'RegistrationModelSidebarField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Registration (registration) */
export type RegistrationRecord = RecordInterface & {
  __typename?: 'RegistrationRecord';
  _allHeadlineLocales?: Maybe<Array<RegistrationModelHeadlineFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<RegistrationModelDescriptionField>;
  headline?: Maybe<RegistrationModelHeadlineField>;
  id: Scalars['ItemId']['output'];
  sidebar?: Maybe<RegistrationModelSidebarField>;
  testimonial?: Maybe<FeedbackRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Registration (registration) */
export type RegistrationRecord_AllHeadlineLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Registration (registration) */
export type RegistrationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Registration (registration) */
export type RegistrationRecordHeadlineArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type RequestAssistanceModelModalContentField = {
  __typename?: 'RequestAssistanceModelModalContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Request assistance (request_assistance) */
export type RequestAssistanceRecord = RecordInterface & {
  __typename?: 'RequestAssistanceRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  modalContent?: Maybe<RequestAssistanceModelModalContentField>;
  modalTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Request assistance (request_assistance) */
export type RequestAssistanceRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export type ResponsiveImage = {
  __typename?: 'ResponsiveImage';
  alt?: Maybe<Scalars['String']['output']>;
  aspectRatio: Scalars['FloatType']['output'];
  base64?: Maybe<Scalars['String']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  height: Scalars['IntType']['output'];
  sizes: Scalars['String']['output'];
  src: Scalars['String']['output'];
  srcSet: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  webpSrcSet: Scalars['String']['output'];
  width: Scalars['IntType']['output'];
};

export type ReviewModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ReviewModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ReviewModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  rating?: InputMaybe<IntegerFilter>;
  text?: InputMaybe<TextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  url?: InputMaybe<StringFilter>;
};

export enum ReviewModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Date_ASC = 'date_ASC',
  Date_DESC = 'date_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Rating_ASC = 'rating_ASC',
  Rating_DESC = 'rating_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Url_ASC = 'url_ASC',
  Url_DESC = 'url_DESC'
}

/** Record of type Review (review) */
export type ReviewRecord = RecordInterface & {
  __typename?: 'ReviewRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ItemId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  rating?: Maybe<Scalars['IntType']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** Record of type Review (review) */
export type ReviewRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Review (review) */
export type ReviewRecordTextArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Reviews block (reviews_block) */
export type ReviewsBlockRecord = RecordInterface & {
  __typename?: 'ReviewsBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  reviews: Array<ReviewRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Reviews block (reviews_block) */
export type ReviewsBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Rich text (rich_text) */
export type RichTextRecord = RecordInterface & {
  __typename?: 'RichTextRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Rich text (rich_text) */
export type RichTextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Block of type Rich text (rich_text) */
export type RichTextRecordHtmlArgs = {
  markdown?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SeoField = {
  __typename?: 'SeoField';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FileField>;
  noIndex?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterCard?: Maybe<Scalars['String']['output']>;
};

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type Site = {
  __typename?: 'Site';
  favicon?: Maybe<FileField>;
  faviconMetaTags: Array<Tag>;
  globalSeo?: Maybe<GlobalSeoField>;
  locales: Array<SiteLocale>;
  noIndex?: Maybe<Scalars['BooleanType']['output']>;
};


export type SiteFaviconMetaTagsArgs = {
  variants?: InputMaybe<Array<InputMaybe<FaviconType>>>;
};


export type SiteGlobalSeoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export enum SiteLocale {
  En = 'en'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Block of type Spacer (spacer) */
export type SpacerRecord = RecordInterface & {
  __typename?: 'SpacerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  height?: Maybe<Scalars['IntType']['output']>;
  hiddenMobile?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Spacer (spacer) */
export type SpacerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type StringMultiLocaleField = {
  __typename?: 'StringMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type SubmenuGroupFullModelDescriptionField = {
  __typename?: 'SubmenuGroupFullModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Submenu group full (submenu_group_full) */
export type SubmenuGroupFullRecord = RecordInterface & {
  __typename?: 'SubmenuGroupFullRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  buttonHref?: Maybe<Scalars['String']['output']>;
  buttonHrefRight?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLabelRight?: Maybe<Scalars['String']['output']>;
  content: Array<SubmenuItemRecord>;
  contentRight: Array<SubmenuItemRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<SubmenuGroupFullModelDescriptionField>;
  id: Scalars['ItemId']['output'];
  image: FileField;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Submenu group full (submenu_group_full) */
export type SubmenuGroupFullRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SubmenuGroupModelContentField = SubmenuItemRecord | SubmenuSpacerRecord;

/** Block of type Submenu group (submenu_group) */
export type SubmenuGroupRecord = RecordInterface & {
  __typename?: 'SubmenuGroupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  borderRight?: Maybe<Scalars['BooleanType']['output']>;
  content: Array<SubmenuGroupModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Submenu group (submenu_group) */
export type SubmenuGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SubmenuItemModelTitleField = {
  __typename?: 'SubmenuItemModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Submenu item (submenu_item) */
export type SubmenuItemRecord = RecordInterface & {
  __typename?: 'SubmenuItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  background?: Maybe<FileField>;
  backgroundColor?: Maybe<ColorField>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  page?: Maybe<PageRecord>;
  title?: Maybe<SubmenuItemModelTitleField>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};


/** Block of type Submenu item (submenu_item) */
export type SubmenuItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Submenu spacer (submenu_spacer) */
export type SubmenuSpacerRecord = RecordInterface & {
  __typename?: 'SubmenuSpacerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Submenu spacer (submenu_spacer) */
export type SubmenuSpacerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type System description link (system_description_link) */
export type SystemDescriptionLinkRecord = RecordInterface & {
  __typename?: 'SystemDescriptionLinkRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  role?: Maybe<Scalars['String']['output']>;
  targetBlank?: Maybe<Scalars['BooleanType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<VideoField>;
};


/** Block of type System description link (system_description_link) */
export type SystemDescriptionLinkRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type SystemDescriptionLinkRecordListListNonNullMultiLocaleField = {
  __typename?: 'SystemDescriptionLinkRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<SystemDescriptionLinkRecord>;
};

export type SystemDescriptionModelDescriptionAdvertiserField = {
  __typename?: 'SystemDescriptionModelDescriptionAdvertiserField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type SystemDescriptionModelDescriptionAdvertiserFieldMultiLocaleField = {
  __typename?: 'SystemDescriptionModelDescriptionAdvertiserFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SystemDescriptionModelDescriptionAdvertiserField>;
};

export type SystemDescriptionModelDescriptionAffiliateField = {
  __typename?: 'SystemDescriptionModelDescriptionAffiliateField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type SystemDescriptionModelDescriptionAffiliateFieldMultiLocaleField = {
  __typename?: 'SystemDescriptionModelDescriptionAffiliateFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SystemDescriptionModelDescriptionAffiliateField>;
};

export type SystemDescriptionModelDescriptionField = {
  __typename?: 'SystemDescriptionModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type SystemDescriptionModelDescriptionFieldMultiLocaleField = {
  __typename?: 'SystemDescriptionModelDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<SystemDescriptionModelDescriptionField>;
};

export type SystemDescriptionModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SystemDescriptionModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SystemDescriptionModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  boxId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  demoLink?: InputMaybe<StringFilter>;
  demoLinkAdvertiser?: InputMaybe<StringFilter>;
  demoLinkAffiliate?: InputMaybe<StringFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  descriptionAdvertiser?: InputMaybe<StructuredTextFilter>;
  descriptionAffiliate?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  route?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SystemDescriptionModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  BoxId_ASC = 'boxId_ASC',
  BoxId_DESC = 'boxId_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  DemoLinkAdvertiser_ASC = 'demoLinkAdvertiser_ASC',
  DemoLinkAdvertiser_DESC = 'demoLinkAdvertiser_DESC',
  DemoLinkAffiliate_ASC = 'demoLinkAffiliate_ASC',
  DemoLinkAffiliate_DESC = 'demoLinkAffiliate_DESC',
  DemoLink_ASC = 'demoLink_ASC',
  DemoLink_DESC = 'demoLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Route_ASC = 'route_ASC',
  Route_DESC = 'route_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type SystemDescriptionOverrideModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SystemDescriptionOverrideModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SystemDescriptionOverrideModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  hideAdvertiserSystemDescriptions?: InputMaybe<BooleanFilter>;
  hideAffiliateSystemDescriptions?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  tenantId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SystemDescriptionOverrideModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  HideAdvertiserSystemDescriptions_ASC = 'hideAdvertiserSystemDescriptions_ASC',
  HideAdvertiserSystemDescriptions_DESC = 'hideAdvertiserSystemDescriptions_DESC',
  HideAffiliateSystemDescriptions_ASC = 'hideAffiliateSystemDescriptions_ASC',
  HideAffiliateSystemDescriptions_DESC = 'hideAffiliateSystemDescriptions_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  TenantId_ASC = 'tenantId_ASC',
  TenantId_DESC = 'tenantId_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type System description override (system_description_override) */
export type SystemDescriptionOverrideRecord = RecordInterface & {
  __typename?: 'SystemDescriptionOverrideRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  hideAdvertiserSystemDescriptions?: Maybe<Scalars['BooleanType']['output']>;
  hideAffiliateSystemDescriptions?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type System description override (system_description_override) */
export type SystemDescriptionOverrideRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Record of type System description (system_description) */
export type SystemDescriptionRecord = RecordInterface & {
  __typename?: 'SystemDescriptionRecord';
  _allContentLocales?: Maybe<Array<SystemDescriptionLinkRecordListListNonNullMultiLocaleField>>;
  _allDescriptionAdvertiserLocales?: Maybe<Array<SystemDescriptionModelDescriptionAdvertiserFieldMultiLocaleField>>;
  _allDescriptionAffiliateLocales?: Maybe<Array<SystemDescriptionModelDescriptionAffiliateFieldMultiLocaleField>>;
  _allDescriptionLocales?: Maybe<Array<SystemDescriptionModelDescriptionFieldMultiLocaleField>>;
  _allQuickActionsLocales?: Maybe<Array<SystemDescriptionLinkRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  boxId?: Maybe<Scalars['String']['output']>;
  content: Array<SystemDescriptionLinkRecord>;
  createdAt: Scalars['DateTime']['output'];
  demoLink?: Maybe<Scalars['String']['output']>;
  demoLinkAdvertiser?: Maybe<Scalars['String']['output']>;
  demoLinkAffiliate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<SystemDescriptionModelDescriptionField>;
  descriptionAdvertiser?: Maybe<SystemDescriptionModelDescriptionAdvertiserField>;
  descriptionAffiliate?: Maybe<SystemDescriptionModelDescriptionAffiliateField>;
  id: Scalars['ItemId']['output'];
  quickActions: Array<SystemDescriptionLinkRecord>;
  route?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecord_AllContentLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecord_AllDescriptionAdvertiserLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecord_AllDescriptionAffiliateLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecord_AllQuickActionsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecordContentArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecordDescriptionAdvertiserArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecordDescriptionAffiliateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type System description (system_description) */
export type SystemDescriptionRecordQuickActionsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type TableBlockModelTableDescriptionField = {
  __typename?: 'TableBlockModelTableDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type TableBlockModelTableTitleField = {
  __typename?: 'TableBlockModelTableTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Table block (table_block) */
export type TableBlockRecord = RecordInterface & {
  __typename?: 'TableBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  tableColumns: Array<TableColRecord>;
  tableContent: Array<TableGroupRecord>;
  tableDescription?: Maybe<TableBlockModelTableDescriptionField>;
  tableTitle: TableBlockModelTableTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table block (table_block) */
export type TableBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TableCellModelContentBlocksField = HelpRecord | IconBlockRecord;

export type TableCellModelContentField = {
  __typename?: 'TableCellModelContentField';
  blocks: Array<TableCellModelContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type TableCellModelDesktopContentBlocksField = HelpRecord | IconBlockRecord;

export type TableCellModelDesktopContentField = {
  __typename?: 'TableCellModelDesktopContentField';
  blocks: Array<TableCellModelDesktopContentBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Table cell (table_cell) */
export type TableCellRecord = RecordInterface & {
  __typename?: 'TableCellRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  checked?: Maybe<Scalars['BooleanType']['output']>;
  content?: Maybe<TableCellModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  desktopContent?: Maybe<TableCellModelDesktopContentField>;
  desktopRowspan?: Maybe<Scalars['IntType']['output']>;
  desktopSkip?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table cell (table_cell) */
export type TableCellRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TableColModelContentField = {
  __typename?: 'TableColModelContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type TableColModelTitleField = {
  __typename?: 'TableColModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Table col (table_col) */
export type TableColRecord = RecordInterface & {
  __typename?: 'TableColRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundColor?: Maybe<ColorField>;
  color?: Maybe<ColorField>;
  content?: Maybe<TableColModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<IconRecord>;
  id: Scalars['ItemId']['output'];
  title: TableColModelTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table col (table_col) */
export type TableColRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Table group (table_group) */
export type TableGroupRecord = RecordInterface & {
  __typename?: 'TableGroupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<TableRowRecord>;
  createdAt: Scalars['DateTime']['output'];
  header: TableHeaderRecord;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table group (table_group) */
export type TableGroupRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TableHeaderModelContentField = {
  __typename?: 'TableHeaderModelContentField';
  blocks: Array<HelpRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Table header (table_header) */
export type TableHeaderRecord = RecordInterface & {
  __typename?: 'TableHeaderRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: TableHeaderModelContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table header (table_header) */
export type TableHeaderRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Table (table) */
export type TableRecord = RecordInterface & {
  __typename?: 'TableRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  tableContent?: Maybe<Scalars['JsonField']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table (table) */
export type TableRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Table row (table_row) */
export type TableRowRecord = RecordInterface & {
  __typename?: 'TableRowRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: Array<TableCellRecord>;
  createdAt: Scalars['DateTime']['output'];
  header: TableHeaderRecord;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Table row (table_row) */
export type TableRowRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type Tag = {
  __typename?: 'Tag';
  attributes?: Maybe<Scalars['MetaTagAttributes']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
};

export type TeamBlockModelTeamBlockTitleField = {
  __typename?: 'TeamBlockModelTeamBlockTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Team block (team_block) */
export type TeamBlockRecord = RecordInterface & {
  __typename?: 'TeamBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  teamBlockMembers: Array<TeamMemberRecord>;
  teamBlockTitle: TeamBlockModelTeamBlockTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Team block (team_block) */
export type TeamBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TeamMemberModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeamMemberModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeamMemberModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  jobPosition?: InputMaybe<StringFilter>;
  linkedinProfileLink?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  teamMemberImage?: InputMaybe<FileFilter>;
  teamMemberImageHover?: InputMaybe<FileFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TeamMemberModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  JobPosition_ASC = 'jobPosition_ASC',
  JobPosition_DESC = 'jobPosition_DESC',
  LinkedinProfileLink_ASC = 'linkedinProfileLink_ASC',
  LinkedinProfileLink_DESC = 'linkedinProfileLink_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Team (team_member) */
export type TeamMemberRecord = RecordInterface & {
  __typename?: 'TeamMemberRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  jobPosition?: Maybe<Scalars['String']['output']>;
  linkedinProfileLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  teamMemberImage?: Maybe<FileField>;
  teamMemberImageHover?: Maybe<FileField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Team (team_member) */
export type TeamMemberRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Testimonial (testimonial) */
export type TestimonialRecord = RecordInterface & {
  __typename?: 'TestimonialRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  testimonial: FeedbackRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Testimonial (testimonial) */
export type TestimonialRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TextModelTextBlocksField = AccordionRecord | AchievementBlockRecord | AllIntegrationsBlockRecord | BulletListRecord | ButtonRecord | ButtonsGroupRecord | CaptionRecord | CarouselBlockRecord | ComboCtaRecord | CompanyBlockRecord | CompareBoxRecord | CompetitorBlockRecord | CompositeImageRecord | ContentSectionRecord | ContentToggleRecord | DynamicMegablockItemRecord | DynamicMegablockRecord | FeaturesSectionRecord | FlexRecord | FullFeatureBlockRecord | GridContentRecord | HeadlineRecord | HelpRecord | HubspotRecord | IconBlockRecord | IconGroupRecord | ImageRecord | IntegrationBlockRecord | LinkBoxRecord | ListItemRecord | ListRecord | PricingBlockRecord | ReviewsBlockRecord | SpacerRecord | TableRecord | TestimonialRecord | TrackdeskBlockRecord | UsersBlockRecord | VideoRecord;

export type TextModelTextField = {
  __typename?: 'TextModelTextField';
  blocks: Array<TextModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Text (text) */
export type TextRecord = RecordInterface & {
  __typename?: 'TextRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  showOutline?: Maybe<Scalars['BooleanType']['output']>;
  text: TextModelTextField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Text (text) */
export type TextRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Trackdesk block (trackdesk_block) */
export type TrackdeskBlockRecord = RecordInterface & {
  __typename?: 'TrackdeskBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  trackdeskContent: ListRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Trackdesk block (trackdesk_block) */
export type TrackdeskBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TrackingMethodCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TrackingMethodCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TrackingMethodCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TrackingMethodCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Tracking method category (tracking_method_category) */
export type TrackingMethodCategoryRecord = RecordInterface & {
  __typename?: 'TrackingMethodCategoryRecord';
  _allReferencingTrackingMethods: Array<TrackingMethodRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingTrackingMethodsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Tracking method category (tracking_method_category) */
export type TrackingMethodCategoryRecord_AllReferencingTrackingMethodsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<TrackingMethodModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TrackingMethodModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenTrackingMethodAndTrackingMethodCategory>;
};


/** Record of type Tracking method category (tracking_method_category) */
export type TrackingMethodCategoryRecord_AllReferencingTrackingMethodsMetaArgs = {
  filter?: InputMaybe<TrackingMethodModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenTrackingMethodAndTrackingMethodCategory>;
};


/** Record of type Tracking method category (tracking_method_category) */
export type TrackingMethodCategoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TrackingMethodModelDescriptionField = {
  __typename?: 'TrackingMethodModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type TrackingMethodModelDescriptionFieldMultiLocaleField = {
  __typename?: 'TrackingMethodModelDescriptionFieldMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value?: Maybe<TrackingMethodModelDescriptionField>;
};

/** Linking fields */
export enum TrackingMethodModelFieldsReferencingTrackingMethodCategoryModel {
  TrackingMethod_category = 'trackingMethod_category'
}

export type TrackingMethodModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TrackingMethodModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TrackingMethodModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  activatedSlug?: InputMaybe<SlugFilter>;
  caption?: InputMaybe<StringFilter>;
  category?: InputMaybe<LinkFilter>;
  comingSoon?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  info?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  slug?: InputMaybe<SlugFilter>;
  tenantType?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TrackingMethodModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Caption_ASC = 'caption_ASC',
  Caption_DESC = 'caption_DESC',
  ComingSoon_ASC = 'comingSoon_ASC',
  ComingSoon_DESC = 'comingSoon_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Info_ASC = 'info_ASC',
  Info_DESC = 'info_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord = RecordInterface & {
  __typename?: 'TrackingMethodRecord';
  _allCaptionLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allDescriptionLocales?: Maybe<Array<TrackingMethodModelDescriptionFieldMultiLocaleField>>;
  _allInfoLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allOptionalConversionTypesTemplateLocales?: Maybe<Array<TrackingMethodStepRecordListListNonNullMultiLocaleField>>;
  _allStepsLocales?: Maybe<Array<TrackingMethodStepRecordListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  activatedSlug?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  category?: Maybe<TrackingMethodCategoryRecord>;
  comingSoon?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<TrackingMethodModelDescriptionField>;
  id: Scalars['ItemId']['output'];
  info?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<FileField>;
  name?: Maybe<Scalars['String']['output']>;
  optionalConversionTypesTemplate: Array<TrackingMethodStepRecord>;
  position?: Maybe<Scalars['IntType']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  steps: Array<TrackingMethodStepRecord>;
  tenantType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord_AllCaptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord_AllDescriptionLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord_AllInfoLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord_AllOptionalConversionTypesTemplateLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord_AllStepsLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecordCaptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecordDescriptionArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecordInfoArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecordOptionalConversionTypesTemplateArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Tracking method (tracking_method) */
export type TrackingMethodRecordStepsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type TrackingMethodStepModelDescriptionBlocksField = AccordionRecord | CaptionRecord;

export type TrackingMethodStepModelDescriptionField = {
  __typename?: 'TrackingMethodStepModelDescriptionField';
  blocks: Array<TrackingMethodStepModelDescriptionBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type TrackingMethodStepModelManualField = {
  __typename?: 'TrackingMethodStepModelManualField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Tracking method step (tracking_method_step) */
export type TrackingMethodStepRecord = RecordInterface & {
  __typename?: 'TrackingMethodStepRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<TrackingMethodStepModelDescriptionField>;
  download?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  manual?: Maybe<TrackingMethodStepModelManualField>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Tracking method step (tracking_method_step) */
export type TrackingMethodStepRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type TrackingMethodStepRecordListListNonNullMultiLocaleField = {
  __typename?: 'TrackingMethodStepRecordListListNonNullMultiLocaleField';
  locale?: Maybe<SiteLocale>;
  value: Array<TrackingMethodStepRecord>;
};

export type TranslationItemModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TranslationItemModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TranslationItemModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  deepl?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  key?: InputMaybe<StringFilter>;
  manualEdit?: InputMaybe<BooleanFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  value?: InputMaybe<StringFilter>;
};

export enum TranslationItemModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Deepl_ASC = 'deepl_ASC',
  Deepl_DESC = 'deepl_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Key_ASC = 'key_ASC',
  Key_DESC = 'key_DESC',
  ManualEdit_ASC = 'manualEdit_ASC',
  ManualEdit_DESC = 'manualEdit_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC',
  Value_ASC = 'value_ASC',
  Value_DESC = 'value_DESC'
}

/** Record of type Translation item (translation_item) */
export type TranslationItemRecord = RecordInterface & {
  __typename?: 'TranslationItemRecord';
  _allDeeplLocales?: Maybe<Array<StringMultiLocaleField>>;
  _allValueLocales?: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deepl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  key?: Maybe<Scalars['String']['output']>;
  manualEdit?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};


/** Record of type Translation item (translation_item) */
export type TranslationItemRecord_AllDeeplLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Translation item (translation_item) */
export type TranslationItemRecord_AllValueLocalesArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Translation item (translation_item) */
export type TranslationItemRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Translation item (translation_item) */
export type TranslationItemRecordDeeplArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


/** Record of type Translation item (translation_item) */
export type TranslationItemRecordValueArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

export type TranslationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TranslationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TranslationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  beta?: InputMaybe<BooleanFilter>;
  code?: InputMaybe<StringFilter>;
  content?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<ItemIdFilter>;
  inDatocms?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TranslationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Beta_ASC = 'beta_ASC',
  Beta_DESC = 'beta_DESC',
  Code_ASC = 'code_ASC',
  Code_DESC = 'code_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Disabled_ASC = 'disabled_ASC',
  Disabled_DESC = 'disabled_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  InDatocms_ASC = 'inDatocms_ASC',
  InDatocms_DESC = 'inDatocms_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Translation (translation) */
export type TranslationRecord = RecordInterface & {
  __typename?: 'TranslationRecord';
  _allReferencingCustomTenantTranslations: Array<CustomTenantTranslationRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingCustomTenantTranslationsMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  beta?: Maybe<Scalars['BooleanType']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JsonField']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disabled?: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  inDatocms?: Maybe<Scalars['BooleanType']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['IntType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Translation (translation) */
export type TranslationRecord_AllReferencingCustomTenantTranslationsArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<CustomTenantTranslationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CustomTenantTranslationModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCustomTenantTranslationAndTranslation>;
};


/** Record of type Translation (translation) */
export type TranslationRecord_AllReferencingCustomTenantTranslationsMetaArgs = {
  filter?: InputMaybe<CustomTenantTranslationModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenCustomTenantTranslationAndTranslation>;
};


/** Record of type Translation (translation) */
export type TranslationRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Basename_ASC = 'basename_ASC',
  Basename_DESC = 'basename_DESC',
  Filename_ASC = 'filename_ASC',
  Filename_DESC = 'filename_DESC',
  Format_ASC = 'format_ASC',
  Format_DESC = 'format_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MimeType_ASC = 'mimeType_ASC',
  MimeType_DESC = 'mimeType_DESC',
  Resolution_ASC = 'resolution_ASC',
  Resolution_DESC = 'resolution_DESC',
  Size_ASC = 'size_ASC',
  Size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadVideoField = {
  __typename?: 'UploadVideoField';
  alt?: Maybe<Scalars['String']['output']>;
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  framerate?: Maybe<Scalars['Int']['output']>;
  height: Scalars['IntType']['output'];
  mp4Url?: Maybe<Scalars['String']['output']>;
  muxAssetId: Scalars['String']['output'];
  muxPlaybackId: Scalars['String']['output'];
  streamingUrl: Scalars['String']['output'];
  thumbhash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  width: Scalars['IntType']['output'];
};


export type UploadVideoFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type UploadVideoFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type UploadVideoFieldMp4UrlArgs = {
  exactRes?: InputMaybe<VideoMp4Res>;
  res?: InputMaybe<VideoMp4Res>;
};


export type UploadVideoFieldThumbnailUrlArgs = {
  format?: InputMaybe<MuxThumbnailFormatType>;
};


export type UploadVideoFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export type UserModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<UserModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UserModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  photo?: InputMaybe<FileFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum UserModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type User (user) */
export type UserRecord = RecordInterface & {
  __typename?: 'UserRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  photo: FileField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type User (user) */
export type UserRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Users block (users_block) */
export type UsersBlockRecord = RecordInterface & {
  __typename?: 'UsersBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<UserRecord>;
};


/** Block of type Users block (users_block) */
export type UsersBlockRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Block of type Vertical menu line (vertical_menu_line) */
export type VerticalMenuLineRecord = RecordInterface & {
  __typename?: 'VerticalMenuLineRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Vertical menu line (vertical_menu_line) */
export type VerticalMenuLineRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type VideoField = {
  __typename?: 'VideoField';
  height: Scalars['IntType']['output'];
  provider: Scalars['String']['output'];
  providerUid: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['IntType']['output'];
};

export type VideoFileField = FileFieldInterface & {
  __typename?: 'VideoFileField';
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb?: Maybe<Scalars['String']['output']>;
  blurhash?: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright?: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint?: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height: Scalars['IntType']['output'];
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  responsiveImage?: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video: UploadVideoField;
  width: Scalars['IntType']['output'];
};


export type VideoFileFieldAltArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type VideoFileFieldBlurUpThumbArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type VideoFileFieldCustomDataArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type VideoFileFieldFocalPointArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type VideoFileFieldResponsiveImageArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  imgixParams?: InputMaybe<ImgixParams>;
  locale?: InputMaybe<SiteLocale>;
  sizes?: InputMaybe<Scalars['String']['input']>;
};


export type VideoFileFieldTitleArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  locale?: InputMaybe<SiteLocale>;
};


export type VideoFileFieldUrlArgs = {
  imgixParams?: InputMaybe<ImgixParams>;
};

/** Specifies how to filter Video fields */
export type VideoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type VideoModelVideoEndField = {
  __typename?: 'VideoModelVideoEndField';
  blocks: Array<ButtonRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Block of type Video (video) */
export type VideoRecord = RecordInterface & {
  __typename?: 'VideoRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  autoplay?: Maybe<Scalars['BooleanType']['output']>;
  createdAt: Scalars['DateTime']['output'];
  external?: Maybe<VideoField>;
  file?: Maybe<VideoFileField>;
  id: Scalars['ItemId']['output'];
  poster?: Maybe<FileField>;
  preview?: Maybe<VideoFileField>;
  showPlayIcon?: Maybe<Scalars['BooleanType']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoEnd?: Maybe<VideoModelVideoEndField>;
};


/** Block of type Video (video) */
export type VideoRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type WalnutDemoCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<WalnutDemoCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WalnutDemoCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum WalnutDemoCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Walnut demo category (walnut_demo_category) */
export type WalnutDemoCategoryRecord = RecordInterface & {
  __typename?: 'WalnutDemoCategoryRecord';
  _allReferencingWalnutDemos: Array<WalnutDemoRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingWalnutDemosMeta: CollectionMetadata;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  position?: Maybe<Scalars['IntType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Walnut demo category (walnut_demo_category) */
export type WalnutDemoCategoryRecord_AllReferencingWalnutDemosArgs = {
  fallbackLocales?: InputMaybe<Array<SiteLocale>>;
  filter?: InputMaybe<WalnutDemoModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale?: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<WalnutDemoModelOrderBy>>>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  through?: InputMaybe<InverseRelationshipFilterBetweenWalnutDemoAndWalnutDemoCategory>;
};


/** Record of type Walnut demo category (walnut_demo_category) */
export type WalnutDemoCategoryRecord_AllReferencingWalnutDemosMetaArgs = {
  filter?: InputMaybe<WalnutDemoModelFilter>;
  locale?: InputMaybe<SiteLocale>;
  through?: InputMaybe<InverseRelationshipFilterBetweenWalnutDemoAndWalnutDemoCategory>;
};


/** Record of type Walnut demo category (walnut_demo_category) */
export type WalnutDemoCategoryRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum WalnutDemoModelFieldsReferencingWalnutDemoCategoryModel {
  WalnutDemo_category = 'walnutDemo_category'
}

export type WalnutDemoModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<WalnutDemoModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WalnutDemoModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  buttonLabel?: InputMaybe<StringFilter>;
  category?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum WalnutDemoModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  ButtonLabel_ASC = 'buttonLabel_ASC',
  ButtonLabel_DESC = 'buttonLabel_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Href_ASC = 'href_ASC',
  Href_DESC = 'href_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Walnut demo (walnut_demo) */
export type WalnutDemoRecord = RecordInterface & {
  __typename?: 'WalnutDemoRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  buttonLabel?: Maybe<Scalars['String']['output']>;
  category?: Maybe<WalnutDemoCategoryRecord>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image?: Maybe<FileField>;
  position?: Maybe<Scalars['IntType']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Walnut demo (walnut_demo) */
export type WalnutDemoRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type WebBannerModelDescriptionField = {
  __typename?: 'WebBannerModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type WebBannerModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<WebBannerModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<WebBannerModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  ctaHref?: InputMaybe<StringFilter>;
  ctaLabel?: InputMaybe<StringFilter>;
  description?: InputMaybe<StructuredTextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  title?: InputMaybe<StructuredTextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum WebBannerModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  CtaHref_ASC = 'ctaHref_ASC',
  CtaHref_DESC = 'ctaHref_DESC',
  CtaLabel_ASC = 'ctaLabel_ASC',
  CtaLabel_DESC = 'ctaLabel_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type WebBannerModelTitleField = {
  __typename?: 'WebBannerModelTitleField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Record of type Web banner (web_banner) */
export type WebBannerRecord = RecordInterface & {
  __typename?: 'WebBannerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl?: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctaHref: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  description: WebBannerModelDescriptionField;
  id: Scalars['ItemId']['output'];
  image: FileField;
  title: WebBannerModelTitleField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Web banner (web_banner) */
export type WebBannerRecord_SeoMetaTagsArgs = {
  locale?: InputMaybe<SiteLocale>;
};

export type FocalPoint = {
  __typename?: 'focalPoint';
  x: Scalars['FloatType']['output'];
  y: Scalars['FloatType']['output'];
};

export type AcademyChapterQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ItemId']['input']>;
}>;


export type AcademyChapterQuery = { __typename?: 'Query', academyChapter?: { __typename?: 'AcademyChapterRecord', id: string, title?: string | null, description?: string | null, section?: { __typename?: 'AcademySectionRecord', id: string, title?: string | null } | null, _allReferencingAcademyChapterParts: Array<{ __typename?: 'AcademyChapterPartRecord', id: string, title?: string | null, description?: { __typename?: 'AcademyChapterPartModelDescriptionField', value: unknown } | null, _allReferencingAcademyResources: Array<{ __typename?: 'AcademyResourceRecord', title?: string | null, description?: string | null, externalLink?: string | null, modalEmbed?: string | null, image?: { __typename?: 'FileField', url: string } | null, resourceType: { __typename?: 'AcademyResourceTypeRecord', title?: string | null }, video?: { __typename?: 'VideoField', url: string, thumbnailUrl: string } | null }> }> } | null };

export type AcademyHomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type AcademyHomepageQuery = { __typename?: 'Query', academyHomepage?: { __typename?: 'AcademyHomepageRecord', title?: string | null, description?: string | null, showBanner?: boolean | null, bannerTitle?: string | null, bannerDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, bannerImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } | null, allAcademySections: Array<{ __typename?: 'AcademySectionRecord', id: string, title?: string | null, description?: string | null, sectionImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> };

export type AcademySectionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ItemId']['input']>;
}>;


export type AcademySectionQuery = { __typename?: 'Query', academySection?: { __typename?: 'AcademySectionRecord', title?: string | null, description?: string | null, sectionImage?: { __typename?: 'FileField', url: string } | null, _allReferencingAcademyChapters: Array<{ __typename?: 'AcademyChapterRecord', id: string, title?: string | null, description?: string | null, banner?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | null };

export type AllActiveAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllActiveAnnouncementsQuery = { __typename?: 'Query', allAnnouncements: Array<{ __typename?: 'AnnouncementRecord', id: string, active?: boolean | null, title: string, emoji?: string | null, href?: string | null }> };

export type AllAppActiveAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAppActiveAnnouncementsQuery = { __typename?: 'Query', allAppAnnouncements: Array<{ __typename?: 'AppAnnouncementRecord', id: string, active?: boolean | null, title: string, emoji?: string | null, href?: string | null }> };

export type AllAppDataQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllAppDataQuery = { __typename?: 'Query', allPricingGroups: Array<{ __typename?: 'PricingGroupRecord', id: string, name: string, title: string, variant?: string | null, estimatePrice: unknown, description: { __typename?: 'PricingGroupModelDescriptionField', value: unknown }, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } }>, pricingGroupPage: { __typename?: 'PageRecord', slug: string } }>, allSystemDescriptions: Array<{ __typename?: 'SystemDescriptionRecord', route?: string | null, boxId?: string | null, demoLink?: string | null, demoLinkAffiliate?: string | null, demoLinkAdvertiser?: string | null, description?: { __typename?: 'SystemDescriptionModelDescriptionField', value: unknown } | null, descriptionAffiliate?: { __typename?: 'SystemDescriptionModelDescriptionAffiliateField', value: unknown } | null, descriptionAdvertiser?: { __typename?: 'SystemDescriptionModelDescriptionAdvertiserField', value: unknown } | null, content: Array<{ __typename?: 'SystemDescriptionLinkRecord', id: string, title?: string | null, icon?: string | null, url?: string | null, targetBlank?: boolean | null, role?: string | null, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null }>, quickActions: Array<{ __typename?: 'SystemDescriptionLinkRecord', id: string, title?: string | null, icon?: string | null, url?: string | null, targetBlank?: boolean | null, role?: string | null, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null }> }>, systemDescriptionOverride?: { __typename?: 'SystemDescriptionOverrideRecord', hideAffiliateSystemDescriptions?: boolean | null, hideAdvertiserSystemDescriptions?: boolean | null } | null };

export type AllAppIntegrationCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<AppIntegrationCategoryModelFilter>;
}>;


export type AllAppIntegrationCategoriesQuery = { __typename?: 'Query', allAppIntegrationCategories: Array<{ __typename?: 'AppIntegrationCategoryRecord', id: string, name?: string | null, description?: string | null, position?: number | null, _createdAt: string, _updatedAt: string, _allReferencingAppIntegrations: Array<{ __typename?: 'AppIntegrationRecord', id: string, name: string, description?: string | null, integrationType: string, tenantType: string, link?: string | null, position?: number | null, _createdAt: string, _updatedAt: string, image?: { __typename?: 'FileField', url: string, alt?: string | null, title?: string | null, width?: number | null, height?: number | null } | null }> }> };

export type AllBlogPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBlogPostsQuery = { __typename?: 'Query', allBlogPosts: Array<{ __typename?: 'BlogPostRecord', slug: string, title: string, description: string, html: string, _createdAt: string, featureImage: { __typename?: 'FileField', url: string }, tags: Array<{ __typename?: 'BlogTagRecord', slug: string, name: string }>, author: { __typename?: 'AuthorRecord', name: string, slug?: string | null, image?: { __typename?: 'FileField', url: string } | null } }>, _allBlogPostsMeta: { __typename?: 'CollectionMetadata', count: number } };

export type AllRelatedBlogPostsQueryVariables = Exact<{
  tags?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
}>;


export type AllRelatedBlogPostsQuery = { __typename?: 'Query', allBlogPosts: Array<{ __typename?: 'BlogPostRecord', slug: string, title: string, description: string, _createdAt: string, featureImage: { __typename?: 'FileField', url: string }, tags: Array<{ __typename?: 'BlogTagRecord', slug: string, name: string }>, author: { __typename?: 'AuthorRecord', name: string, slug?: string | null, image?: { __typename?: 'FileField', url: string } | null } }> };

export type AllBlogTagPostsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllBlogTagPostsQuery = { __typename?: 'Query', blogTag?: { __typename?: 'BlogTagRecord', name: string, _allReferencingBlogPostsMeta: { __typename?: 'CollectionMetadata', count: number }, _allReferencingBlogPosts: Array<{ __typename?: 'BlogPostRecord', slug: string, title: string, description: string, html: string, _createdAt: string, featureImage: { __typename?: 'FileField', url: string }, tags: Array<{ __typename?: 'BlogTagRecord', slug: string, name: string }>, author: { __typename?: 'AuthorRecord', name: string, slug?: string | null, image?: { __typename?: 'FileField', url: string } | null } }> } | null };

export type AllBlogTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBlogTagsQuery = { __typename?: 'Query', allBlogTags: Array<{ __typename?: 'BlogTagRecord', slug: string, name: string }> };

export type AllDashboardArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDashboardArticlesQuery = { __typename?: 'Query', allDashboardArticles: Array<{ __typename?: 'DashboardArticleRecord', title: string, description: string, href: string, targetBlank?: boolean | null, buttonLabel?: string | null, buttonVariant?: string | null, buttonIcon?: string | null, image?: { __typename?: 'FileField', url: string } | null }> };

export type AllFooterMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFooterMenusQuery = { __typename?: 'Query', allIntegrations: Array<{ __typename?: 'IntegrationRecord', title: string, description?: string | null, href?: string | null, image?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null, alt?: string | null } | null, imageDark?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null, alt?: string | null } | null, imageSquare?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null, alt?: string | null } | null }>, allFooterLinks: Array<{ __typename?: 'FooterLinkRecord', title: string, href?: string | null, newTab?: boolean | null, children: Array<{ __typename?: 'FooterLinkRecord', title: string, href?: string | null, newTab?: boolean | null }> }>, allFooterMenus: Array<{ __typename?: 'FooterMenuRecord', text: string, slug: string, newTab?: boolean | null }> };

export type FooterMenuItemFragment = { __typename?: 'FooterLinkRecord', title: string, href?: string | null, newTab?: boolean | null };

export type IntegrationImageAttrsFragment = { __typename?: 'FileField', url: string, width?: number | null, height?: number | null, alt?: string | null };

export type AllPublishedPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPublishedPagesQuery = { __typename?: 'Query', allPages: Array<{ __typename?: 'PageRecord', slug: string, _updatedAt: string, image?: { __typename?: 'FileField', url: string } | null }> };

export type AllQuickSetupItemsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type AllQuickSetupItemsQuery = { __typename?: 'Query', allQuickSetups: Array<{ __typename?: 'QuickSetupRecord', id: string, title?: string | null, icon?: string | null, caption?: string | null, menuText?: string | null, children: Array<{ __typename?: 'QuickSetupRecord', id: string, title?: string | null, icon?: string | null, caption?: string | null, menuText?: string | null, description?: { __typename?: 'QuickSetupModelDescriptionField', value: unknown } | null, content: Array<{ __typename?: 'SystemDescriptionLinkRecord', id: string, title?: string | null, icon?: string | null, url?: string | null, targetBlank?: boolean | null, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null }>, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null, image?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null } | null }>, description?: { __typename?: 'QuickSetupModelDescriptionField', value: unknown } | null, content: Array<{ __typename?: 'SystemDescriptionLinkRecord', id: string, title?: string | null, icon?: string | null, url?: string | null, targetBlank?: boolean | null, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null }>, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null, image?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null } | null }>, allWalnutDemoCategories: Array<{ __typename?: 'WalnutDemoCategoryRecord', id: string, title?: string | null, _allReferencingWalnutDemos: Array<{ __typename?: 'WalnutDemoRecord', id: string, title?: string | null, description?: string | null, href?: string | null, buttonLabel?: string | null }> }> };

export type QuickSetupItemFragment = { __typename?: 'QuickSetupRecord', id: string, title?: string | null, icon?: string | null, caption?: string | null, menuText?: string | null, description?: { __typename?: 'QuickSetupModelDescriptionField', value: unknown } | null, content: Array<{ __typename?: 'SystemDescriptionLinkRecord', id: string, title?: string | null, icon?: string | null, url?: string | null, targetBlank?: boolean | null, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null }>, video?: { __typename?: 'VideoField', title: string, url: string, thumbnailUrl: string, width: number, height: number } | null, image?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null } | null };

export type AllTrackingMethodsQueryVariables = Exact<{
  tenantType?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllTrackingMethodsQuery = { __typename?: 'Query', allIntegrationLists: Array<{ __typename?: 'IntegrationListRecord', integrationGroups: Array<{ __typename?: 'IntegrationGroupRecord', name: string, trackingMethods: Array<{ __typename?: 'TrackingMethodRecord', name?: string | null, slug?: string | null, activatedSlug?: string | null, caption?: string | null, comingSoon?: boolean | null, logo?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null } | null }> }> }> };

export type AllTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTranslationsQuery = { __typename?: 'Query', allTranslations: Array<{ __typename?: 'TranslationRecord', id: string, name?: string | null, code?: string | null, beta?: boolean | null, disabled?: boolean | null, inDatocms?: boolean | null }> };

export type AllWebDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AllWebDataQuery = { __typename?: 'Query', allAnnouncements: Array<{ __typename?: 'AnnouncementRecord', id: string, active?: boolean | null, title: string, emoji?: string | null, href?: string | null }>, allAchievements: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }>, allIntegrations: Array<{ __typename?: 'IntegrationRecord', id: string, title: string, description?: string | null, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, imageDark?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, imageSquare?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }>, allFooterLinks: Array<{ __typename?: 'FooterLinkRecord', title: string, href?: string | null, newTab?: boolean | null, children: Array<{ __typename?: 'FooterLinkRecord', title: string, href?: string | null, newTab?: boolean | null }> }>, allFooterMenus: Array<{ __typename?: 'FooterMenuRecord', text: string, slug: string, newTab?: boolean | null }>, allBlogBanners: Array<{ __typename?: 'BlogBannerRecord', variant: string, url: string, targetBlank?: boolean | null, _status: ItemStatus, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }>, allAutoIntegrations: Array<{ __typename?: 'AutoIntegrationRecord', name?: string | null, slug: string, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }>, allMenuItems: Array<{ __typename?: 'MenuItemRecord', title: string, href?: string | null, variant?: string | null, content: Array<{ __typename: 'SubmenuGroupFullRecord', title?: string | null, buttonLabel?: string | null, buttonHref?: string | null, buttonLabelRight?: string | null, buttonHrefRight?: string | null, description?: { __typename?: 'SubmenuGroupFullModelDescriptionField', value: unknown } | null, content: Array<{ __typename?: 'SubmenuItemRecord', href?: string | null, title?: { __typename?: 'SubmenuItemModelTitleField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }>, contentRight: Array<{ __typename?: 'SubmenuItemRecord', href?: string | null, title?: { __typename?: 'SubmenuItemModelTitleField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }>, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | { __typename: 'SubmenuGroupRecord', title?: string | null, borderRight?: boolean | null, content: Array<{ __typename: 'SubmenuItemRecord', description?: string | null, href?: string | null, variant?: string | null, title?: { __typename?: 'SubmenuItemModelTitleField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, background?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, backgroundColor?: { __typename?: 'ColorField', hex: string } | null } | { __typename: 'SubmenuSpacerRecord' }> } | { __typename?: 'VerticalMenuLineRecord' }> }>, footerExtra?: { __typename?: 'FooterExtraRecord', content: { __typename?: 'FooterExtraModelContentField', value: unknown, blocks: Array<string> } } | null };

export type AuthorQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorQuery = { __typename?: 'Query', author?: { __typename?: 'AuthorRecord', name: string, title?: string | null, facebook?: string | null, twitter?: string | null, email?: string | null, linkedin?: string | null, web?: string | null, image?: { __typename?: 'FileField', url: string } | null, description?: { __typename?: 'AuthorModelDescriptionField', value: unknown } | null, about?: { __typename?: 'AuthorModelAboutField', value: unknown } | null, _allReferencingBlogPosts: Array<{ __typename?: 'BlogPostRecord', title: string, slug: string, featureImage: { __typename?: 'FileField', url: string } }> } | null };

export type AutoIntegrationQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type AutoIntegrationQuery = { __typename?: 'Query', autoIntegration?: { __typename?: 'AutoIntegrationRecord', name?: string | null, description?: { __typename?: 'AutoIntegrationModelDescriptionField', value: unknown } | null, manual?: { __typename?: 'AutoIntegrationModelManualField', value: unknown } | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } | null };

export type BlogCarouselQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogCarouselQuery = { __typename?: 'Query', blogCarousel?: { __typename?: 'BlogCarouselRecord', posts: Array<{ __typename?: 'BlogPostRecord', slug: string, title: string, description: string, html: string, _createdAt: string, featureImage: { __typename?: 'FileField', url: string }, tags: Array<{ __typename?: 'BlogTagRecord', slug: string, name: string }>, author: { __typename?: 'AuthorRecord', name: string, slug?: string | null, image?: { __typename?: 'FileField', url: string } | null } }> } | null };

export type BlogPostQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlogPostQuery = { __typename?: 'Query', blogPost?: { __typename?: 'BlogPostRecord', title: string, slug: string, redirectUrl?: string | null, description: string, _createdAt: string, html: string, featureImage: { __typename?: 'FileField', url: string }, tags: Array<{ __typename?: 'BlogTagRecord', id: string, slug: string, name: string }>, author: { __typename?: 'AuthorRecord', name: string, slug?: string | null, description?: { __typename?: 'AuthorModelDescriptionField', value: unknown } | null, image?: { __typename?: 'FileField', url: string } | null }, _seoMetaTags: Array<{ __typename?: 'Tag', tag: string, content?: string | null, attributes?: Record<string, string> | null }>, redirect?: { __typename?: 'BlogPostRecord', slug: string } | null } | null };

export type ModalQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ModalQuery = { __typename?: 'Query', modal?: { __typename?: 'ModalRecord', title: { __typename?: 'ModalModelTitleField', value: unknown, blocks: Array<string> }, content: { __typename?: 'ModalModelContentField', value: unknown, blocks: Array<string> }, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null };

export type PageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'PageRecord', id: string, title: string, breadcrumbTitle?: string | null, slug: string, description?: string | null, hideMenu?: boolean | null, hidePrimaryMenu?: boolean | null, disableLogoLink?: boolean | null, hideFooter?: boolean | null, disablePaddings?: boolean | null, redirectUrl?: string | null, _status: ItemStatus, _firstPublishedAt: string, schemaMarkup?: unknown | null, parentPages: Array<{ __typename?: 'PageRecord', slug: string, title: string, breadcrumbTitle?: string | null }>, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, mobileImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, sidebar?: { __typename: 'HubspotFormRecord', portalId?: string | null, formId?: string | null } | { __typename: 'WebBannerRecord', ctaLabel: string, ctaHref: string, title: { __typename?: 'WebBannerModelTitleField', value: unknown, blocks: Array<string> }, description: { __typename?: 'WebBannerModelDescriptionField', value: unknown, blocks: Array<string> }, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, content: Array<{ __typename: 'AboutUsBlockRecord', id: string, aboutUsTitle: { __typename?: 'AboutUsBlockModelAboutUsTitleField', value: unknown }, aboutUsDescription: { __typename?: 'AboutUsBlockModelAboutUsDescriptionField', value: unknown }, aboutUsImage: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, aboutUsContent: { __typename?: 'AboutUsBlockModelAboutUsContentField', value: unknown }, aboutUsButton: { __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }, aboutUsIcons: Array<{ __typename?: 'IconLinkRecord', title: string, href: string, icon: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> } | { __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'BannerRecord', id: string, description?: string | null, button: string, href: string, bannerTitle: string, content: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'BlogSectionRecord', id: string, posts: Array<{ __typename?: 'BlogPostRecord', title: string, slug: string, description: string, tags: Array<{ __typename?: 'BlogTagRecord', slug: string, name: string }> }> } | { __typename: 'BoxRecord', id: string, variant?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, boxContent?: { __typename?: 'BoxModelBoxContentField', value: unknown } | null } | { __typename: 'ButtonRecord' } | { __typename: 'ButtonsGroupRecord' } | { __typename: 'CarouselRecord', id: string, images: Array<{ __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }> } | { __typename: 'CompareFeatureRecord', id: string, description?: string | null, compareFeatureTitle: string, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', name?: string | null, hideFrom?: boolean | null, monthlyPrice?: number | null, customPriceTitle?: string | null, featureOverride: Array<{ __typename?: 'CompareFeatureItemRecord', value?: string | null, feature?: { __typename?: 'FeatureRecord', title: string } | null }> }>, features: Array<{ __typename?: 'FeatureRecord', title: string, pricingPlan: Array<{ __typename?: 'PricingPlanRecord', name?: string | null }> }>, competitor: Array<{ __typename?: 'CompetitorRecord', name?: string | null, planName?: string | null, price?: string | null, noFreePlan?: boolean | null, features: Array<{ __typename?: 'FeatureRecord', title: string }>, featureOverride: Array<{ __typename?: 'CompareFeatureItemRecord', value?: string | null, feature?: { __typename?: 'FeatureRecord', title: string } | null }> }> } | { __typename: 'CompareProductRecord', id: string, compareProductTitle: { __typename?: 'CompareProductModelCompareProductTitleField', value: unknown }, compareProductDescription: { __typename?: 'CompareProductModelCompareProductDescriptionField', value: unknown }, compareProductProducts: Array<{ __typename?: 'CompareProductItemRecord', id: string, title: { __typename?: 'CompareProductItemModelTitleField', value: unknown }, description: { __typename?: 'CompareProductItemModelDescriptionField', value: unknown }, media: { __typename?: 'VideoFileField', video: { __typename?: 'UploadVideoField', width: number, height: number, muxPlaybackId: string, blurUpThumb?: string | null } }, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> }>, compareProductImage: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | { __typename: 'ComparisonRecord', id: string, comparisonButtonLabel?: string | null, comparisonButtonHref?: string | null, comparisonButtonLabelNetwork?: string | null, comparisonButtonHrefNetwork?: string | null, comparisonTitle: { __typename?: 'ComparisonModelComparisonTitleField', value: unknown }, comparisonDescription: { __typename?: 'ComparisonModelComparisonDescriptionField', value: unknown }, comparisonImage: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, comparisonImageMobile: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, comparisonOurImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, comparisonOurFeatures: { __typename: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> }, comparisonTheirImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, comparisonTheirTitle: { __typename?: 'ComparisonModelComparisonTheirTitleField', value: unknown }, comparisonTheirFeatures: { __typename: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> }, comparisonCompareTitle: { __typename?: 'ComparisonModelComparisonCompareTitleField', value: unknown }, comparisonCompetitors: Array<{ __typename?: 'CompetitorRecord', id: string, name?: string | null, page?: { __typename?: 'PageRecord', slug: string } | null }>, comparisonCompetitorsNetwork: Array<{ __typename?: 'CompetitorRecord', id: string, name?: string | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ComparisonTableRecord', id: string, comparisonTableTitle?: { __typename?: 'ComparisonTableModelComparisonTableTitleField', value: unknown } | null, comparisonTableDescription?: { __typename?: 'ComparisonTableModelComparisonTableDescriptionField', value: unknown } | null, comparisonTableLastUpdated?: { __typename?: 'ComparisonTableModelComparisonTableLastUpdatedField', value: unknown } | null, comparisonTableContent: Array<{ __typename?: 'TableRowRecord', id: string, header: { __typename?: 'TableHeaderRecord', content: { __typename?: 'TableHeaderModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> } }, content: Array<{ __typename?: 'TableCellRecord', id: string, checked?: boolean | null, desktopRowspan?: number | null, desktopSkip?: boolean | null, content?: { __typename?: 'TableCellModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null, desktopContent?: { __typename?: 'TableCellModelDesktopContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null }> }> } | { __typename: 'ContentImageSectionRecord', id: string, content: Array<{ __typename?: 'ContentItemRecord', label?: string | null, highlight?: boolean | null, togglePosition?: boolean | null, biggerHeadline?: boolean | null, contentTitle?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord' } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord' } | { __typename: 'CarouselBlockRecord' } | { __typename: 'CompositeImageRecord', id: string, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, images: Array<{ __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }> } | { __typename: 'IntegrationBlockRecord', id: string }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'ContentSectionRecord', id: string, title?: string | null, variant?: string | null, reverse?: boolean | null, itemsEnd?: boolean | null, width?: string | null, center?: boolean | null, anchorId?: string | null, hiddenMobile?: boolean | null, hiddenTitle?: boolean | null, titleFormatted?: { __typename?: 'ContentSectionModelTitleFormattedField', value: unknown } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, extraImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null, sectionDescription?: { __typename?: 'ContentSectionModelSectionDescriptionField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'ComboCtaRecord', id: string, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }>, bullets: Array<{ __typename?: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> }> } | { __typename: 'FlexRecord' } | { __typename: 'FullFeatureBlockRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', id: string, title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ReviewsBlockRecord', id: string, reviews: Array<{ __typename?: 'ReviewRecord', id: string, rating?: number | null, date?: string | null, text?: string | null, name?: string | null, url?: string | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', name: string, text: string, title?: string | null, company: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> }> } | null, sectionContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, url?: string | null, variant?: string | null, togglePosition?: boolean | null, badge?: string | null, titleFormatted?: { __typename?: 'ContentItemModelTitleFormattedField', value: unknown } | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CarouselBlockRecord', id: string, carouselFeedback: Array<{ __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompositeImageRecord' } | { __typename: 'IntegrationBlockRecord' }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, secondaryImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null }>, sectionExtraContent?: { __typename?: 'ContentSectionModelSectionExtraContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'AllIntegrationsBlockRecord', id: string } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CompareBoxRecord', id: string, url?: string | null, compareContent: Array<{ __typename?: 'CompareItemRecord', logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, disadvantage?: { __typename?: 'CompareItemModelDisadvantageField', value: unknown } | null, advantage?: { __typename?: 'CompareItemModelAdvantageField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentToggleRecord', id: string, title: string, optionA: string, optionB: string, contentA: { __typename?: 'ContentToggleModelContentAField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> }, contentB: { __typename?: 'ContentToggleModelContentBField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> } } | { __typename: 'FeaturesSectionRecord', id: string, featuresList: Array<{ __typename?: 'FeatureRecord', href?: string | null, title: string }> } | { __typename: 'GridContentRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TableRecord', id: string, tableContent?: unknown | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } } | { __typename: 'TrackdeskBlockRecord', id: string, trackdeskContent: { __typename?: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> } }> } | null } | { __typename: 'ContentSectionV2Record', id: string, title?: string | null, description?: string | null, hiddenMobile?: boolean | null, preTitle?: string | null, layout: string, contentItemsPerRow: number, trimContentItems?: boolean | null, trimmedContentItemsButtonLabel?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, backgroundColor?: { __typename?: 'ColorField', cssRgb: string } | null, descriptionExtraContent: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'LineRecord', id: string } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null }>, contentItems: Array<{ __typename?: 'ContentItemV2Record', id: string, title?: string | null, description?: string | null, layout: string, link?: string | null, hoverEffect?: boolean | null, backgroundColor?: { __typename?: 'ColorField', cssRgb: string } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'DynamicMegablockRecord', id: string, autoplay?: boolean | null, items: Array<{ __typename?: 'DynamicMegablockItemRecord', id: string, title: { __typename?: 'DynamicMegablockItemModelTitleField', value: unknown }, description: { __typename?: 'DynamicMegablockItemModelDescriptionField', value: unknown }, media: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, video?: { __typename?: 'UploadVideoField', mp4Url?: string | null, streamingUrl: string } | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }>, cta: { __typename?: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } } | { __typename: 'FaqRecord', id: string, variant?: string | null, faqList: Array<{ __typename?: 'FaqItemRecord', question: string, answer: { __typename?: 'FaqItemModelAnswerField', value: unknown } }>, faqContent?: { __typename?: 'FaqModelFaqContentField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | null } | { __typename: 'FeaturesBlockRecord' } | { __typename: 'FeaturesSectionRecord', id: string, featuresList: Array<{ __typename?: 'FeatureRecord', title: string, comingSoon?: boolean | null, tooltip?: string | null, href?: string | null }> } | { __typename: 'FormBoxRecord', id: string, description?: string | null, formBoxTitle: string, form?: { __typename?: 'HubspotFormRecord', formId?: string | null, portalId?: string | null, region?: string | null } | null, testimonal?: { __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } | null, formBoxContent?: { __typename?: 'FormBoxModelFormBoxContentField', value: unknown } | null } | { __typename: 'GridContentRecord' } | { __typename: 'GridRecord', id: string, content: Array<{ __typename: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null }> } | { __typename: 'HighlightedBoxRecord', id: string, bullets?: boolean | null, bottomImage?: boolean | null, wide?: boolean | null, highlightedBoxTitle: string, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, highlightedBoxContent: Array<{ __typename?: 'ContentItemRecord', highlightedBoxContentTitle?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord' } | { __typename: 'CarouselBlockRecord' } | { __typename: 'CompositeImageRecord' } | { __typename: 'IntegrationBlockRecord' }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'IntegrationCarouselRecord', id: string, firstRow: Array<{ __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }>, secondRow: Array<{ __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }>, thirdRow: Array<{ __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }>, carouselButton?: { __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | null } | { __typename: 'InternalVideoRecord', id: string, video: { __typename?: 'VideoFileField', video: { __typename?: 'UploadVideoField', muxPlaybackId: string, width: number, height: number, blurUpThumb?: string | null } } } | { __typename: 'LineRecord', id: string } | { __typename: 'LogoHeaderRecord', id: string, description?: string | null, buttonLabel?: string | null, buttonHref?: string | null, logoHeaderTitle: string, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } | { __typename: 'PageHeaderRecord', id: string, pageHeaderTitle: string, headerDescription?: { __typename?: 'PageHeaderModelHeaderDescriptionField', value: unknown } | null } | { __typename: 'PageHeroRecord', id: string, caption?: string | null, full?: boolean | null, transparent?: boolean | null, customTitle?: { __typename?: 'PageHeroModelCustomTitleField', value: unknown } | null, heroDescription?: { __typename?: 'PageHeroModelHeroDescriptionField', value: unknown, blocks: Array<string> } | null, alternativeContent?: { __typename?: 'PageHeroModelAlternativeContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'CompanyBlockRecord', id: string, disableLinks?: boolean | null, companyContent: Array<{ __typename?: 'CompanyRecord', url?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentSectionRecord', id: string, title?: string | null, variant?: string | null, reverse?: boolean | null, itemsEnd?: boolean | null, width?: string | null, center?: boolean | null, anchorId?: string | null, hiddenMobile?: boolean | null, hiddenTitle?: boolean | null, titleFormatted?: { __typename?: 'ContentSectionModelTitleFormattedField', value: unknown } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, extraImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null, sectionDescription?: { __typename?: 'ContentSectionModelSectionDescriptionField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'ComboCtaRecord', id: string, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }>, bullets: Array<{ __typename?: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> }> } | { __typename: 'FlexRecord' } | { __typename: 'FullFeatureBlockRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', id: string, title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ReviewsBlockRecord', id: string, reviews: Array<{ __typename?: 'ReviewRecord', id: string, rating?: number | null, date?: string | null, text?: string | null, name?: string | null, url?: string | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', name: string, text: string, title?: string | null, company: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> }> } | null, sectionContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, url?: string | null, variant?: string | null, togglePosition?: boolean | null, badge?: string | null, titleFormatted?: { __typename?: 'ContentItemModelTitleFormattedField', value: unknown } | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CarouselBlockRecord', id: string, carouselFeedback: Array<{ __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompositeImageRecord' } | { __typename: 'IntegrationBlockRecord' }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, secondaryImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null }>, sectionExtraContent?: { __typename?: 'ContentSectionModelSectionExtraContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'AllIntegrationsBlockRecord', id: string } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CompareBoxRecord', id: string, url?: string | null, compareContent: Array<{ __typename?: 'CompareItemRecord', logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, disadvantage?: { __typename?: 'CompareItemModelDisadvantageField', value: unknown } | null, advantage?: { __typename?: 'CompareItemModelAdvantageField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentToggleRecord', id: string, title: string, optionA: string, optionB: string, contentA: { __typename?: 'ContentToggleModelContentAField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> }, contentB: { __typename?: 'ContentToggleModelContentBField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> } } | { __typename: 'FeaturesSectionRecord', id: string, featuresList: Array<{ __typename?: 'FeatureRecord', href?: string | null, title: string }> } | { __typename: 'GridContentRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TableRecord', id: string, tableContent?: unknown | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } } | { __typename: 'TrackdeskBlockRecord', id: string, trackdeskContent: { __typename?: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> } }> } | null } | { __typename: 'GridContentRecord', id: string, gridCols?: number | null, gridContent: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'CompareItemRecord' }> } | { __typename: 'HeadlineRecord', id: string, title?: string | null, level?: string | null, tag?: string | null, section?: boolean | null } | { __typename: 'HubspotRecord', id: string, portalId?: string | null, formId?: string | null, region?: string | null } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> } | { __typename: 'VideoRecord', id: string, autoplay?: boolean | null, showPlayIcon?: boolean | null, file?: { __typename?: 'VideoFileField', url: string } | null, external?: { __typename?: 'VideoField', url: string, title: string, width: number, height: number, thumbnailUrl: string } | null, videoEnd?: { __typename?: 'VideoModelVideoEndField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | null, preview?: { __typename?: 'VideoFileField', url: string } | null, poster?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | null, customContent?: { __typename?: 'PageHeroModelCustomContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'CompanyBlockRecord', id: string, disableLinks?: boolean | null, companyContent: Array<{ __typename?: 'CompanyRecord', url?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentSectionRecord', id: string, title?: string | null, variant?: string | null, reverse?: boolean | null, itemsEnd?: boolean | null, width?: string | null, center?: boolean | null, anchorId?: string | null, hiddenMobile?: boolean | null, hiddenTitle?: boolean | null, titleFormatted?: { __typename?: 'ContentSectionModelTitleFormattedField', value: unknown } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, extraImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null, sectionDescription?: { __typename?: 'ContentSectionModelSectionDescriptionField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'ComboCtaRecord', id: string, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }>, bullets: Array<{ __typename?: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> }> } | { __typename: 'FlexRecord' } | { __typename: 'FullFeatureBlockRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', id: string, title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ReviewsBlockRecord', id: string, reviews: Array<{ __typename?: 'ReviewRecord', id: string, rating?: number | null, date?: string | null, text?: string | null, name?: string | null, url?: string | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', name: string, text: string, title?: string | null, company: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> }> } | null, sectionContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, url?: string | null, variant?: string | null, togglePosition?: boolean | null, badge?: string | null, titleFormatted?: { __typename?: 'ContentItemModelTitleFormattedField', value: unknown } | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CarouselBlockRecord', id: string, carouselFeedback: Array<{ __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompositeImageRecord' } | { __typename: 'IntegrationBlockRecord' }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, secondaryImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null }>, sectionExtraContent?: { __typename?: 'ContentSectionModelSectionExtraContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'AllIntegrationsBlockRecord', id: string } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CompareBoxRecord', id: string, url?: string | null, compareContent: Array<{ __typename?: 'CompareItemRecord', logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, disadvantage?: { __typename?: 'CompareItemModelDisadvantageField', value: unknown } | null, advantage?: { __typename?: 'CompareItemModelAdvantageField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentToggleRecord', id: string, title: string, optionA: string, optionB: string, contentA: { __typename?: 'ContentToggleModelContentAField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> }, contentB: { __typename?: 'ContentToggleModelContentBField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> } } | { __typename: 'FeaturesSectionRecord', id: string, featuresList: Array<{ __typename?: 'FeatureRecord', href?: string | null, title: string }> } | { __typename: 'GridContentRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TableRecord', id: string, tableContent?: unknown | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } } | { __typename: 'TrackdeskBlockRecord', id: string, trackdeskContent: { __typename?: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> } }> } | null } | { __typename: 'GridContentRecord', id: string, gridCols?: number | null, gridContent: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'CompareItemRecord' }> } | { __typename: 'HeadlineRecord', id: string, title?: string | null, level?: string | null, tag?: string | null, section?: boolean | null } | { __typename: 'HubspotRecord', id: string, portalId?: string | null, formId?: string | null, region?: string | null } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> } | { __typename: 'VideoRecord', id: string, autoplay?: boolean | null, showPlayIcon?: boolean | null, file?: { __typename?: 'VideoFileField', url: string } | null, external?: { __typename?: 'VideoField', url: string, title: string, width: number, height: number, thumbnailUrl: string } | null, videoEnd?: { __typename?: 'VideoModelVideoEndField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | null, preview?: { __typename?: 'VideoFileField', url: string } | null, poster?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | null, pageHeroContent: Array<{ __typename: 'BulletListRecord', multipleCols?: boolean | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> }>, extraContent?: { __typename?: 'PageHeroModelExtraContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'CompanyBlockRecord', id: string, disableLinks?: boolean | null, companyContent: Array<{ __typename?: 'CompanyRecord', url?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentSectionRecord', id: string, title?: string | null, variant?: string | null, reverse?: boolean | null, itemsEnd?: boolean | null, width?: string | null, center?: boolean | null, anchorId?: string | null, hiddenMobile?: boolean | null, hiddenTitle?: boolean | null, titleFormatted?: { __typename?: 'ContentSectionModelTitleFormattedField', value: unknown } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, extraImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null, sectionDescription?: { __typename?: 'ContentSectionModelSectionDescriptionField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'ComboCtaRecord', id: string, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }>, bullets: Array<{ __typename?: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> }> } | { __typename: 'FlexRecord' } | { __typename: 'FullFeatureBlockRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', id: string, title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ReviewsBlockRecord', id: string, reviews: Array<{ __typename?: 'ReviewRecord', id: string, rating?: number | null, date?: string | null, text?: string | null, name?: string | null, url?: string | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', name: string, text: string, title?: string | null, company: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> }> } | null, sectionContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, url?: string | null, variant?: string | null, togglePosition?: boolean | null, badge?: string | null, titleFormatted?: { __typename?: 'ContentItemModelTitleFormattedField', value: unknown } | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CarouselBlockRecord', id: string, carouselFeedback: Array<{ __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompositeImageRecord' } | { __typename: 'IntegrationBlockRecord' }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, secondaryImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null }>, sectionExtraContent?: { __typename?: 'ContentSectionModelSectionExtraContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'AllIntegrationsBlockRecord', id: string } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CompareBoxRecord', id: string, url?: string | null, compareContent: Array<{ __typename?: 'CompareItemRecord', logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, disadvantage?: { __typename?: 'CompareItemModelDisadvantageField', value: unknown } | null, advantage?: { __typename?: 'CompareItemModelAdvantageField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentToggleRecord', id: string, title: string, optionA: string, optionB: string, contentA: { __typename?: 'ContentToggleModelContentAField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> }, contentB: { __typename?: 'ContentToggleModelContentBField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> } } | { __typename: 'FeaturesSectionRecord', id: string, featuresList: Array<{ __typename?: 'FeatureRecord', href?: string | null, title: string }> } | { __typename: 'GridContentRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TableRecord', id: string, tableContent?: unknown | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } } | { __typename: 'TrackdeskBlockRecord', id: string, trackdeskContent: { __typename?: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> } }> } | null } | { __typename: 'GridContentRecord', id: string, gridCols?: number | null, gridContent: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'CompareItemRecord' }> } | { __typename: 'HeadlineRecord', id: string, title?: string | null, level?: string | null, tag?: string | null, section?: boolean | null } | { __typename: 'HubspotRecord', id: string, portalId?: string | null, formId?: string | null, region?: string | null } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> } | { __typename: 'VideoRecord', id: string, autoplay?: boolean | null, showPlayIcon?: boolean | null, file?: { __typename?: 'VideoFileField', url: string } | null, external?: { __typename?: 'VideoField', url: string, title: string, width: number, height: number, thumbnailUrl: string } | null, videoEnd?: { __typename?: 'VideoModelVideoEndField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | null, preview?: { __typename?: 'VideoFileField', url: string } | null, poster?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | null, badge?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } | { __typename: 'PhotoRecord', id: string, imageLink?: string | null, photo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, photoMobile?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } | { __typename: 'PricingBlockRecord', id: string, pricingGroupTitle: { __typename?: 'PricingBlockModelPricingGroupTitleField', value: unknown }, pricingGroupDescription: { __typename?: 'PricingBlockModelPricingGroupDescriptionField', value: unknown }, pricingGroups: Array<{ __typename?: 'PricingGroupRecord', id: string, name: string, title: string, variant?: string | null, description: { __typename?: 'PricingGroupModelDescriptionField', value: unknown }, pricingGroupPage: { __typename?: 'PageRecord', slug: string } }>, pricingGroup: { __typename?: 'PricingGroupRecord', id: string, name: string, title: string, variant?: string | null, estimatePrice: unknown, description: { __typename?: 'PricingGroupModelDescriptionField', value: unknown }, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } }>, pricingGroupPage: { __typename?: 'PageRecord', slug: string } }, pricingGroupCompanies: { __typename?: 'CompanyBlockRecord', id: string, disableLinks?: boolean | null, companyContent: Array<{ __typename?: 'CompanyRecord', id: string, url?: string | null, caseStudyUrl?: string | null, testimonialAuthorName?: string | null, testimonialAuthorDetails?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, testimonial?: { __typename?: 'CompanyModelTestimonialField', value: unknown } | null, testimonialAuthorImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> }, pricingGroupCompareTable: { __typename?: 'FullFeatureBlockRecord', id: string, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, featureOverride: Array<{ __typename?: 'CompareFeatureItemRecord', value?: string | null, href?: string | null, feature?: { __typename?: 'FeatureRecord', id: string } | null, tooltip?: { __typename?: 'CompareFeatureItemModelTooltipField', value: unknown } | null }>, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } }>, fullComparisonTitle: { __typename?: 'FullFeatureBlockModelFullComparisonTitleField', value: unknown }, fullComparisonTitleImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, fullComparisonContent?: { __typename?: 'FullComparisonRecord', id: string, content: Array<{ __typename?: 'FullComparisonSectionRecord', id: string, title: string, features: Array<{ __typename?: 'FeatureRecord', id: string, title: string, tooltip?: string | null, href?: string | null, comingSoon?: boolean | null, tooltipContent?: { __typename?: 'FeatureModelTooltipContentField', value: unknown } | null, pricingPlan: Array<{ __typename?: 'PricingPlanRecord', id: string }> }> }> } | null } } | { __typename: 'PricingPackageBlockRecord' } | { __typename: 'RichTextRecord', id: string, html?: string | null } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TableBlockRecord', id: string, tableTitle: { __typename?: 'TableBlockModelTableTitleField', value: unknown }, tableDescription?: { __typename?: 'TableBlockModelTableDescriptionField', value: unknown } | null, tableColumns: Array<{ __typename?: 'TableColRecord', id: string, title: { __typename?: 'TableColModelTitleField', value: unknown }, content?: { __typename?: 'TableColModelContentField', value: unknown } | null, color?: { __typename?: 'ColorField', hex: string } | null, backgroundColor?: { __typename?: 'ColorField', hex: string } | null, icon?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null }>, tableContent: Array<{ __typename?: 'TableGroupRecord', id: string, header: { __typename?: 'TableHeaderRecord', content: { __typename?: 'TableHeaderModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> } }, content: Array<{ __typename?: 'TableRowRecord', id: string, header: { __typename?: 'TableHeaderRecord', content: { __typename?: 'TableHeaderModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> } }, content: Array<{ __typename?: 'TableCellRecord', id: string, checked?: boolean | null, desktopRowspan?: number | null, desktopSkip?: boolean | null, content?: { __typename?: 'TableCellModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null, desktopContent?: { __typename?: 'TableCellModelDesktopContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null }> }> }> } | { __typename: 'TeamBlockRecord', id: string, teamBlockTitle: { __typename?: 'TeamBlockModelTeamBlockTitleField', value: unknown }, teamBlockMembers: Array<{ __typename?: 'TeamMemberRecord', name?: string | null, jobPosition?: string | null, linkedinProfileLink?: string | null, id: string, teamMemberImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, teamMemberImageHover?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } } | { __typename: 'TextRecord', id: string, showOutline?: boolean | null, text: { __typename?: 'TextModelTextField', value: unknown, blocks: Array<{ __typename: 'AccordionRecord' } | { __typename: 'AchievementBlockRecord' } | { __typename: 'AllIntegrationsBlockRecord' } | { __typename: 'BulletListRecord', id: string, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord' } | { __typename: 'ButtonsGroupRecord' } | { __typename: 'CaptionRecord' } | { __typename: 'CarouselBlockRecord' } | { __typename: 'ComboCtaRecord' } | { __typename: 'CompanyBlockRecord' } | { __typename: 'CompareBoxRecord' } | { __typename: 'CompetitorBlockRecord' } | { __typename: 'CompositeImageRecord' } | { __typename: 'ContentSectionRecord' } | { __typename: 'ContentToggleRecord' } | { __typename: 'DynamicMegablockItemRecord' } | { __typename: 'DynamicMegablockRecord' } | { __typename: 'FeaturesSectionRecord' } | { __typename: 'FlexRecord' } | { __typename: 'FullFeatureBlockRecord' } | { __typename: 'GridContentRecord' } | { __typename: 'HeadlineRecord', id: string, title?: string | null, level?: string | null, tag?: string | null, section?: boolean | null } | { __typename: 'HelpRecord' } | { __typename: 'HubspotRecord' } | { __typename: 'IconBlockRecord' } | { __typename: 'IconGroupRecord' } | { __typename: 'ImageRecord', id: string, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | { __typename: 'IntegrationBlockRecord' } | { __typename: 'LinkBoxRecord' } | { __typename: 'ListItemRecord' } | { __typename: 'ListRecord' } | { __typename: 'PricingBlockRecord' } | { __typename: 'ReviewsBlockRecord' } | { __typename: 'SpacerRecord' } | { __typename: 'TableRecord' } | { __typename: 'TestimonialRecord' } | { __typename: 'TrackdeskBlockRecord' } | { __typename: 'UsersBlockRecord' } | { __typename: 'VideoRecord' }> } } | { __typename: 'VideoRecord', id: string, autoplay?: boolean | null, showPlayIcon?: boolean | null, file?: { __typename?: 'VideoFileField', url: string } | null, external?: { __typename?: 'VideoField', url: string, title: string, width: number, height: number, thumbnailUrl: string } | null, videoEnd?: { __typename?: 'VideoModelVideoEndField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | null, preview?: { __typename?: 'VideoFileField', url: string } | null, poster?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }>, redirect?: { __typename?: 'PageRecord', slug: string } | null, _seoMetaTags: Array<{ __typename?: 'Tag', tag: string, content?: string | null, attributes?: Record<string, string> | null }> } | null };

export type ImageAttrsFragment = { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null };

export type ButtonBlockFragment = { __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null };

export type BulletListBlockFragment = { __typename?: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> };

export type HeadlineBlockFragment = { __typename?: 'HeadlineRecord', id: string, title?: string | null, level?: string | null, tag?: string | null, section?: boolean | null };

export type CompareBlockFragment = { __typename?: 'CompareBoxRecord', id: string, url?: string | null, compareContent: Array<{ __typename?: 'CompareItemRecord', logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, disadvantage?: { __typename?: 'CompareItemModelDisadvantageField', value: unknown } | null, advantage?: { __typename?: 'CompareItemModelAdvantageField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> };

export type FeedbackBlockFragment = { __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null };

export type TestimonialBlockFragment = { __typename?: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } };

export type ContentSectionFragment = { __typename?: 'ContentSectionRecord', id: string, title?: string | null, variant?: string | null, reverse?: boolean | null, itemsEnd?: boolean | null, width?: string | null, center?: boolean | null, anchorId?: string | null, hiddenMobile?: boolean | null, hiddenTitle?: boolean | null, titleFormatted?: { __typename?: 'ContentSectionModelTitleFormattedField', value: unknown } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, extraImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null, sectionDescription?: { __typename?: 'ContentSectionModelSectionDescriptionField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'ComboCtaRecord', id: string, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }>, bullets: Array<{ __typename?: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> }> } | { __typename: 'FlexRecord' } | { __typename: 'FullFeatureBlockRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', id: string, title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ReviewsBlockRecord', id: string, reviews: Array<{ __typename?: 'ReviewRecord', id: string, rating?: number | null, date?: string | null, text?: string | null, name?: string | null, url?: string | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', name: string, text: string, title?: string | null, company: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } } | { __typename: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> }> } | null, sectionContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, url?: string | null, variant?: string | null, togglePosition?: boolean | null, badge?: string | null, titleFormatted?: { __typename?: 'ContentItemModelTitleFormattedField', value: unknown } | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CarouselBlockRecord', id: string, carouselFeedback: Array<{ __typename?: 'FeedbackRecord', id: string, title?: string | null, name: string, text: string, company: string, url?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'CompositeImageRecord' } | { __typename: 'IntegrationBlockRecord' }> } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, secondaryImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, color?: { __typename?: 'ColorField', cssRgb: string } | null }>, sectionExtraContent?: { __typename?: 'ContentSectionModelSectionExtraContentField', value: unknown, blocks: Array<{ __typename: 'AchievementBlockRecord', id: string, achievement: Array<{ __typename?: 'AchievementRecord', id: string, name?: string | null, url?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'AllIntegrationsBlockRecord', id: string } | { __typename: 'BulletListRecord', id: string, multipleCols?: boolean | null, variant?: string | null, bulletListContent: Array<{ __typename?: 'ContentItemRecord', title?: string | null, description?: { __typename?: 'ContentItemModelDescriptionField', value: unknown } | null }> } | { __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'CompareBoxRecord', id: string, url?: string | null, compareContent: Array<{ __typename?: 'CompareItemRecord', logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, disadvantage?: { __typename?: 'CompareItemModelDisadvantageField', value: unknown } | null, advantage?: { __typename?: 'CompareItemModelAdvantageField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'ContentToggleRecord', id: string, title: string, optionA: string, optionB: string, contentA: { __typename?: 'ContentToggleModelContentAField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> }, contentB: { __typename?: 'ContentToggleModelContentBField', value: unknown, blocks: Array<{ __typename: 'TableRecord', id: string, tableContent?: unknown | null }> } } | { __typename: 'FeaturesSectionRecord', id: string, featuresList: Array<{ __typename?: 'FeatureRecord', href?: string | null, title: string }> } | { __typename: 'GridContentRecord' } | { __typename: 'IntegrationBlockRecord', id: string, variant?: string | null, integrations: Array<{ __typename?: 'IntegrationRecord', title: string, href?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null } | { __typename: 'TableRecord', id: string, tableContent?: unknown | null } | { __typename: 'TestimonialRecord', id: string, testimonial: { __typename?: 'FeedbackRecord', id: string, name: string, url?: string | null, company: string, text: string, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null } } | { __typename: 'TrackdeskBlockRecord', id: string, trackdeskContent: { __typename?: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> } }> } | null };

export type VideoBlockFragment = { __typename?: 'VideoRecord', id: string, autoplay?: boolean | null, showPlayIcon?: boolean | null, file?: { __typename?: 'VideoFileField', url: string } | null, external?: { __typename?: 'VideoField', url: string, title: string, width: number, height: number, thumbnailUrl: string } | null, videoEnd?: { __typename?: 'VideoModelVideoEndField', value: unknown, blocks: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | null, preview?: { __typename?: 'VideoFileField', url: string } | null, poster?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null };

export type PhotoBlockFragment = { __typename?: 'PhotoRecord', id: string, imageLink?: string | null, photo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, photoMobile?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null };

export type CompetitorBlockFragment = { __typename?: 'CompetitorBlockRecord', id: string, variant?: string | null, competitors: Array<{ __typename?: 'CompetitorRecord', name?: string | null, description?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> };

export type UsersBlockFragment = { __typename?: 'UsersBlockRecord', id: string, users: Array<{ __typename?: 'UserRecord', id: string, name: string, description: string, href?: string | null, photo: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> };

export type SpacerBlockFragment = { __typename?: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null };

export type PricingBlockFragment = { __typename?: 'PricingBlockRecord', id: string, pricingGroupTitle: { __typename?: 'PricingBlockModelPricingGroupTitleField', value: unknown }, pricingGroupDescription: { __typename?: 'PricingBlockModelPricingGroupDescriptionField', value: unknown }, pricingGroups: Array<{ __typename?: 'PricingGroupRecord', id: string, name: string, title: string, variant?: string | null, description: { __typename?: 'PricingGroupModelDescriptionField', value: unknown }, pricingGroupPage: { __typename?: 'PageRecord', slug: string } }>, pricingGroup: { __typename?: 'PricingGroupRecord', id: string, name: string, title: string, variant?: string | null, estimatePrice: unknown, description: { __typename?: 'PricingGroupModelDescriptionField', value: unknown }, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } }>, pricingGroupPage: { __typename?: 'PageRecord', slug: string } }, pricingGroupCompanies: { __typename?: 'CompanyBlockRecord', id: string, disableLinks?: boolean | null, companyContent: Array<{ __typename?: 'CompanyRecord', id: string, url?: string | null, caseStudyUrl?: string | null, testimonialAuthorName?: string | null, testimonialAuthorDetails?: string | null, logo?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, testimonial?: { __typename?: 'CompanyModelTestimonialField', value: unknown } | null, testimonialAuthorImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> }, pricingGroupCompareTable: { __typename?: 'FullFeatureBlockRecord', id: string, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, featureOverride: Array<{ __typename?: 'CompareFeatureItemRecord', value?: string | null, href?: string | null, feature?: { __typename?: 'FeatureRecord', id: string } | null, tooltip?: { __typename?: 'CompareFeatureItemModelTooltipField', value: unknown } | null }>, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } }>, fullComparisonTitle: { __typename?: 'FullFeatureBlockModelFullComparisonTitleField', value: unknown }, fullComparisonTitleImage?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, fullComparisonContent?: { __typename?: 'FullComparisonRecord', id: string, content: Array<{ __typename?: 'FullComparisonSectionRecord', id: string, title: string, features: Array<{ __typename?: 'FeatureRecord', id: string, title: string, tooltip?: string | null, href?: string | null, comingSoon?: boolean | null, tooltipContent?: { __typename?: 'FeatureModelTooltipContentField', value: unknown } | null, pricingPlan: Array<{ __typename?: 'PricingPlanRecord', id: string }> }> }> } | null } };

export type PricingGroupFragment = { __typename?: 'PricingGroupRecord', id: string, name: string, title: string, variant?: string | null, estimatePrice: unknown, description: { __typename?: 'PricingGroupModelDescriptionField', value: unknown }, pricingPlans: Array<{ __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } }>, pricingGroupPage: { __typename?: 'PageRecord', slug: string } };

export type PricingPlanFragment = { __typename?: 'PricingPlanRecord', id: string, membershipPlanId?: string | null, name?: string | null, selfService?: boolean | null, ctaButtonLabel?: string | null, ctaButtonLabelLogged?: string | null, ctaButtonHref?: string | null, ctaButtonHrefLogged?: string | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, customPriceTitle?: string | null, customPriceTitleEur?: string | null, hideFrom?: boolean | null, nameFormatted: { __typename?: 'PricingPlanModelNameFormattedField', value: unknown }, content: { __typename?: 'PricingPlanModelContentField', value: unknown } };

export type LinkBoxFragment = { __typename?: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> };

export type ListBlockFragment = { __typename?: 'ListRecord', id: string, content: Array<{ __typename?: 'ListItemRecord', id: string, emojiIcon?: string | null, shopifyHidden?: boolean | null, icon?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, iconLink?: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } | null, text: { __typename?: 'ListItemModelTextField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> }, tooltip?: { __typename?: 'ListItemModelTooltipField', value: unknown } | null }> };

export type ButtonsGroupBlockFragment = { __typename?: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> };

export type HelpRecordFragment = { __typename?: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null };

export type TableCellRecordFragment = { __typename?: 'TableCellRecord', id: string, checked?: boolean | null, desktopRowspan?: number | null, desktopSkip?: boolean | null, content?: { __typename?: 'TableCellModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null, desktopContent?: { __typename?: 'TableCellModelDesktopContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null };

export type TableRowRecordFragment = { __typename?: 'TableRowRecord', id: string, header: { __typename?: 'TableHeaderRecord', content: { __typename?: 'TableHeaderModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null }> } }, content: Array<{ __typename?: 'TableCellRecord', id: string, checked?: boolean | null, desktopRowspan?: number | null, desktopSkip?: boolean | null, content?: { __typename?: 'TableCellModelContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null, desktopContent?: { __typename?: 'TableCellModelDesktopContentField', value: unknown, blocks: Array<{ __typename: 'HelpRecord', id: string, helpText: string, helpTooltipText?: { __typename?: 'HelpModelHelpTooltipTextField', value: unknown, blocks: Array<string> } | null } | { __typename: 'IconBlockRecord', id: string, icon: { __typename?: 'IconRecord', image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } } }> } | null }> };

export type ContentSectionV2Fragment = { __typename?: 'ContentSectionV2Record', id: string, title?: string | null, description?: string | null, hiddenMobile?: boolean | null, preTitle?: string | null, layout: string, contentItemsPerRow: number, trimContentItems?: boolean | null, trimmedContentItemsButtonLabel?: string | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null, backgroundColor?: { __typename?: 'ColorField', cssRgb: string } | null, descriptionExtraContent: Array<{ __typename: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null } | { __typename: 'ButtonsGroupRecord', id: string, horizontal?: boolean | null, buttons: Array<{ __typename?: 'ButtonRecord', id: string, label?: string | null, href?: string | null, buttonVariant?: string | null, cta?: boolean | null, transparent?: boolean | null, arrow?: boolean | null, caption?: string | null, inverseCaption?: boolean | null, small?: boolean | null, targetBlank?: boolean | null, noScroll?: boolean | null, smallMarginTop?: boolean | null, buttonContent?: { __typename?: 'ButtonModelContentField', value: unknown, blocks: Array<string> } | null }> } | { __typename: 'LineRecord', id: string } | { __typename: 'LinkBoxRecord', id: string, links: Array<{ __typename?: 'LinkRecord', title?: string | null, href?: string | null, variant?: string | null, description?: { __typename?: 'LinkModelDescriptionField', value: unknown } | null, page?: { __typename?: 'PageRecord', slug: string } | null }> } | { __typename: 'SpacerRecord', id: string, height?: number | null, hiddenMobile?: boolean | null }>, contentItems: Array<{ __typename?: 'ContentItemV2Record', id: string, title?: string | null, description?: string | null, layout: string, link?: string | null, hoverEffect?: boolean | null, backgroundColor?: { __typename?: 'ColorField', cssRgb: string } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null }> };

export type ContentItemV2Fragment = { __typename?: 'ContentItemV2Record', id: string, title?: string | null, description?: string | null, layout: string, link?: string | null, hoverEffect?: boolean | null, backgroundColor?: { __typename?: 'ColorField', cssRgb: string } | null, image?: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } | null };

export type PricingPlanQueryVariables = Exact<{
  membershipPlanId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PricingPlanQuery = { __typename?: 'Query', pricingPlan?: { __typename?: 'PricingPlanRecord', id: string, name?: string | null, monthlyPrice?: number | null, monthlyPriceEur?: number | null, yearlyPrice?: number | null, yearlyPriceEur?: number | null } | null };

export type ReferralProgramQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralProgramQuery = { __typename?: 'Query', referralProgram?: { __typename?: 'ReferralProgramRecord', headline: { __typename?: 'ReferralProgramModelHeadlineField', value: unknown }, description: { __typename?: 'ReferralProgramModelDescriptionField', value: unknown }, signedupDescription?: { __typename?: 'ReferralProgramModelSignedupDescriptionField', value: unknown } | null, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null }, content: Array<{ __typename?: 'ReferralItemRecord', showOnlyForSignedUpUsers?: boolean | null, headline: { __typename?: 'ReferralItemModelHeadlineField', value: unknown }, description: { __typename?: 'ReferralItemModelDescriptionField', value: unknown }, image: { __typename?: 'FileField', id: string, format: string, url: string, width?: number | null, height?: number | null, alt?: string | null, responsiveImage?: { __typename?: 'ResponsiveImage', srcSet: string, webpSrcSet: string, src: string, width: number, height: number, aspectRatio: number, base64?: string | null, bgColor?: string | null } | null } }> } | null };

export type RegistrationQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationQuery = { __typename?: 'Query', registration?: { __typename?: 'RegistrationRecord', testimonial?: { __typename?: 'FeedbackRecord', name: string, url?: string | null, text: string, title?: string | null, company: string, logo?: { __typename?: 'FileField', url: string } | null, photo: { __typename?: 'FileField', url: string } } | null } | null };

export type RequestAssistanceQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestAssistanceQuery = { __typename?: 'Query', requestAssistance?: { __typename?: 'RequestAssistanceRecord', modalTitle?: string | null, modalContent?: { __typename?: 'RequestAssistanceModelModalContentField', value: unknown } | null } | null };

export type TrackingMethodQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackingMethodQuery = { __typename?: 'Query', trackingMethod?: { __typename?: 'TrackingMethodRecord', name?: string | null, slug?: string | null, activatedSlug?: string | null, info?: string | null, comingSoon?: boolean | null, description?: { __typename?: 'TrackingMethodModelDescriptionField', value: unknown } | null, logo?: { __typename?: 'FileField', url: string, width?: number | null, height?: number | null } | null, steps: Array<{ __typename?: 'TrackingMethodStepRecord', title?: string | null, download?: string | null, description?: { __typename?: 'TrackingMethodStepModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'AccordionRecord', id: string, accordionItems: Array<{ __typename?: 'AccordionItemRecord', title: string, accordionContent: { __typename?: 'AccordionItemModelAccordionContentField', value: unknown, blocks: Array<{ __typename: 'CaptionRecord', id: string, captionContent: { __typename?: 'CaptionModelCaptionContentField', value: unknown } }> } }> } | { __typename: 'CaptionRecord', id: string, captionContent: { __typename?: 'CaptionModelCaptionContentField', value: unknown } }> } | null, manual?: { __typename?: 'TrackingMethodStepModelManualField', value: unknown } | null }>, optionalConversionTypesTemplate: Array<{ __typename?: 'TrackingMethodStepRecord', title?: string | null, download?: string | null, description?: { __typename?: 'TrackingMethodStepModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'AccordionRecord', id: string, accordionItems: Array<{ __typename?: 'AccordionItemRecord', title: string, accordionContent: { __typename?: 'AccordionItemModelAccordionContentField', value: unknown, blocks: Array<{ __typename: 'CaptionRecord', id: string, captionContent: { __typename?: 'CaptionModelCaptionContentField', value: unknown } }> } }> } | { __typename: 'CaptionRecord', id: string, captionContent: { __typename?: 'CaptionModelCaptionContentField', value: unknown } }> } | null, manual?: { __typename?: 'TrackingMethodStepModelManualField', value: unknown } | null }> } | null };

export type StepsFragmentFragment = { __typename?: 'TrackingMethodStepRecord', title?: string | null, download?: string | null, description?: { __typename?: 'TrackingMethodStepModelDescriptionField', value: unknown, blocks: Array<{ __typename: 'AccordionRecord', id: string, accordionItems: Array<{ __typename?: 'AccordionItemRecord', title: string, accordionContent: { __typename?: 'AccordionItemModelAccordionContentField', value: unknown, blocks: Array<{ __typename: 'CaptionRecord', id: string, captionContent: { __typename?: 'CaptionModelCaptionContentField', value: unknown } }> } }> } | { __typename: 'CaptionRecord', id: string, captionContent: { __typename?: 'CaptionModelCaptionContentField', value: unknown } }> } | null, manual?: { __typename?: 'TrackingMethodStepModelManualField', value: unknown } | null };

export type TranslationQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TranslationQuery = { __typename?: 'Query', translation?: { __typename?: 'TranslationRecord', content?: unknown | null, _allReferencingCustomTenantTranslations: Array<{ __typename?: 'CustomTenantTranslationRecord', content: unknown }> } | null };

export const FooterMenuItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"footerMenuItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FooterLinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]} as unknown as DocumentNode<FooterMenuItemFragment, unknown>;
export const IntegrationImageAttrsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IntegrationImageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]} as unknown as DocumentNode<IntegrationImageAttrsFragment, unknown>;
export const QuickSetupItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"quickSetupItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuickSetupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"menuText"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]} as unknown as DocumentNode<QuickSetupItemFragment, unknown>;
export const HeadlineBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"headlineBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeadlineRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"section"}}]}}]} as unknown as DocumentNode<HeadlineBlockFragment, unknown>;
export const ImageAttrsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<ImageAttrsFragment, unknown>;
export const ButtonBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cta"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"arrow"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"inverseCaption"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","alias":{"kind":"Name","value":"buttonContent"},"name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"noScroll"}},{"kind":"Field","name":{"kind":"Name","value":"smallMarginTop"}}]}}]} as unknown as DocumentNode<ButtonBlockFragment, unknown>;
export const ButtonsGroupBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonsGroupBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonsGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"horizontal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cta"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"arrow"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"inverseCaption"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","alias":{"kind":"Name","value":"buttonContent"},"name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"noScroll"}},{"kind":"Field","name":{"kind":"Name","value":"smallMarginTop"}}]}}]} as unknown as DocumentNode<ButtonsGroupBlockFragment, unknown>;
export const LinkBoxFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"linkBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinkBoxFragment, unknown>;
export const BulletListBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"bulletListBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulletListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCols"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"bulletListContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BulletListBlockFragment, unknown>;
export const SpacerBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"spacerBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}}]}}]} as unknown as DocumentNode<SpacerBlockFragment, unknown>;
export const UsersBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usersBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsersBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<UsersBlockFragment, unknown>;
export const FeedbackBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"feedbackBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<FeedbackBlockFragment, unknown>;
export const CompareBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"compareBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompareBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"compareContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disadvantage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advantage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<CompareBlockFragment, unknown>;
export const TestimonialBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"testimonialBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestimonialRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<TestimonialBlockFragment, unknown>;
export const HelpRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"helpRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HelpRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTooltipText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}}]} as unknown as DocumentNode<HelpRecordFragment, unknown>;
export const ListBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"listBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emojiIcon"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shopifyHidden"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"helpRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HelpRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTooltipText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}}]} as unknown as DocumentNode<ListBlockFragment, unknown>;
export const CompetitorBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"competitorBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"competitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<CompetitorBlockFragment, unknown>;
export const ContentSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"reverse"}},{"kind":"Field","name":{"kind":"Name","value":"itemsEnd"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"center"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anchorId"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sectionDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"linkBox"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewsBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestimonialRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComboCtaRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bullets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usersBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CarouselBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carouselFeedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"feedbackBlock"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"togglePosition"}},{"kind":"Field","name":{"kind":"Name","value":"badge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionExtraContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"compareBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"testimonialBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackdeskBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackdeskContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"listBlock"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AchievementBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturesSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featuresList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllIntegrationsBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"competitorBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentToggleRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"optionA"}},{"kind":"Field","name":{"kind":"Name","value":"optionB"}},{"kind":"Field","name":{"kind":"Name","value":"contentA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentB"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cta"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"arrow"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"inverseCaption"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","alias":{"kind":"Name","value":"buttonContent"},"name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"noScroll"}},{"kind":"Field","name":{"kind":"Name","value":"smallMarginTop"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"helpRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HelpRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTooltipText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonsGroupBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonsGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"horizontal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"linkBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"bulletListBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulletListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCols"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"bulletListContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"spacerBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usersBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsersBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"feedbackBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"compareBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompareBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"compareContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disadvantage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advantage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"testimonialBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestimonialRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"listBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emojiIcon"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shopifyHidden"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"competitorBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"competitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContentSectionFragment, unknown>;
export const VideoBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"videoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoplay"}},{"kind":"Field","name":{"kind":"Name","value":"showPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoEnd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cta"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"arrow"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"inverseCaption"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","alias":{"kind":"Name","value":"buttonContent"},"name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"noScroll"}},{"kind":"Field","name":{"kind":"Name","value":"smallMarginTop"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<VideoBlockFragment, unknown>;
export const PhotoBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"photoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageLink"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<PhotoBlockFragment, unknown>;
export const PricingPlanFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabelLogged"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHref"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHrefLogged"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitleEur"}},{"kind":"Field","name":{"kind":"Name","value":"hideFrom"}}]}}]} as unknown as DocumentNode<PricingPlanFragment, unknown>;
export const PricingGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatePrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabelLogged"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHref"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHrefLogged"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitleEur"}},{"kind":"Field","name":{"kind":"Name","value":"hideFrom"}}]}}]} as unknown as DocumentNode<PricingGroupFragment, unknown>;
export const PricingBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disableLinks"}},{"kind":"Field","name":{"kind":"Name","value":"companyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caseStudyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonialAuthorImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonialAuthorName"}},{"kind":"Field","name":{"kind":"Name","value":"testimonialAuthorDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupCompareTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FullFeatureBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"featureOverride"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullComparisonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullComparisonTitleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullComparisonContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FullComparisonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"tooltipContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"comingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabelLogged"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHref"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHrefLogged"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitleEur"}},{"kind":"Field","name":{"kind":"Name","value":"hideFrom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatePrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<PricingBlockFragment, unknown>;
export const TableCellRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tableCellRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableCellRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checked"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopRowspan"}},{"kind":"Field","name":{"kind":"Name","value":"desktopSkip"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"helpRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HelpRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTooltipText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<TableCellRecordFragment, unknown>;
export const TableRowRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tableRowRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRowRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableHeaderRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableCellRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tableCellRecord"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"helpRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HelpRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTooltipText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tableCellRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableCellRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checked"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopRowspan"}},{"kind":"Field","name":{"kind":"Name","value":"desktopSkip"}}]}}]} as unknown as DocumentNode<TableRowRecordFragment, unknown>;
export const ContentItemV2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentItemV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentItemV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"hoverEffect"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<ContentItemV2Fragment, unknown>;
export const ContentSectionV2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentSectionV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}},{"kind":"Field","name":{"kind":"Name","value":"preTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentItemsPerRow"}},{"kind":"Field","name":{"kind":"Name","value":"trimContentItems"}},{"kind":"Field","name":{"kind":"Name","value":"trimmedContentItemsButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionExtraContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"linkBox"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentItemV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentItemV2"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cta"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"arrow"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"inverseCaption"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","alias":{"kind":"Name","value":"buttonContent"},"name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"noScroll"}},{"kind":"Field","name":{"kind":"Name","value":"smallMarginTop"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonsGroupBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonsGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"horizontal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"linkBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"spacerBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentItemV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentItemV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"hoverEffect"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]} as unknown as DocumentNode<ContentSectionV2Fragment, unknown>;
export const StepsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"stepsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackingMethodStepRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaptionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"captionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccordionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccordionItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accordionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaptionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"captionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"download"}},{"kind":"Field","name":{"kind":"Name","value":"manual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<StepsFragmentFragment, unknown>;
export const AcademyChapterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AcademyChapter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyChapter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingAcademyChapterParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingAcademyResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modalEmbed"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AcademyChapterQuery, AcademyChapterQueryVariables>;
export const AcademyHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AcademyHomepage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academyHomepage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"showBanner"}},{"kind":"Field","name":{"kind":"Name","value":"bannerImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bannerTitle"}},{"kind":"Field","name":{"kind":"Name","value":"bannerDescription"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAcademySections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<AcademyHomepageQuery, AcademyHomepageQueryVariables>;
export const AcademySectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AcademySection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"academySection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingAcademyChapters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"banner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<AcademySectionQuery, AcademySectionQueryVariables>;
export const AllActiveAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllActiveAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAnnouncements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]} as unknown as DocumentNode<AllActiveAnnouncementsQuery, AllActiveAnnouncementsQueryVariables>;
export const AllAppActiveAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAppActiveAnnouncements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAppAnnouncements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]} as unknown as DocumentNode<AllAppActiveAnnouncementsQuery, AllAppActiveAnnouncementsQueryVariables>;
export const AllAppDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAppData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteLocale"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPricingGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allSystemDescriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackLocales"},"value":{"kind":"EnumValue","value":"en"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"boxId"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAffiliate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionAdvertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"demoLink"}},{"kind":"Field","name":{"kind":"Name","value":"demoLinkAffiliate"}},{"kind":"Field","name":{"kind":"Name","value":"demoLinkAdvertiser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemDescriptionOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideAffiliateSystemDescriptions"}},{"kind":"Field","name":{"kind":"Name","value":"hideAdvertiserSystemDescriptions"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabelLogged"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHref"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHrefLogged"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitleEur"}},{"kind":"Field","name":{"kind":"Name","value":"hideFrom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatePrice"}}]}}]} as unknown as DocumentNode<AllAppDataQuery, AllAppDataQueryVariables>;
export const AllAppIntegrationCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllAppIntegrationCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AppIntegrationCategoryModelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAppIntegrationCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingAppIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"tenantType"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllAppIntegrationCategoriesQuery, AllAppIntegrationCategoriesQueryVariables>;
export const AllBlogPostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allBlogPosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBlogPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"createdAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_allBlogPostsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AllBlogPostsQuery, AllBlogPostsQueryVariables>;
export const AllRelatedBlogPostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allRelatedBlogPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBlogPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"createdAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"anyIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllRelatedBlogPostsQuery, AllRelatedBlogPostsQueryVariables>;
export const AllBlogTagPostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allBlogTagPosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingBlogPostsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingBlogPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"createdAt_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllBlogTagPostsQuery, AllBlogTagPostsQueryVariables>;
export const AllBlogTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allBlogTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBlogTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AllBlogTagsQuery, AllBlogTagsQueryVariables>;
export const AllDashboardArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allDashboardArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDashboardArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"buttonIcon"}}]}}]}}]} as unknown as DocumentNode<AllDashboardArticlesQuery, AllDashboardArticlesQueryVariables>;
export const AllFooterMenusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllFooterMenus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntegrationImageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntegrationImageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntegrationImageAttrs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allFooterLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"footerMenuItem"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"footerMenuItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allFooterMenus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IntegrationImageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"footerMenuItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FooterLinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]} as unknown as DocumentNode<AllFooterMenusQuery, AllFooterMenusQueryVariables>;
export const AllPublishedPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allPublishedPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"published"},{"kind":"EnumValue","value":"updated"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_updatedAt"}}]}}]}}]} as unknown as DocumentNode<AllPublishedPagesQuery, AllPublishedPagesQueryVariables>;
export const AllQuickSetupItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllQuickSetupItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteLocale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allQuickSetups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"fallbackLocales"},"value":{"kind":"EnumValue","value":"en"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"quickSetupItem"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"quickSetupItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allWalnutDemoCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingWalnutDemos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"quickSetupItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuickSetupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"menuText"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]} as unknown as DocumentNode<AllQuickSetupItemsQuery, AllQuickSetupItemsQueryVariables>;
export const AllTrackingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllTrackingMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allIntegrationLists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenantType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"tenantType"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trackingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"activatedSlug"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"comingSoon"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllTrackingMethodsQuery, AllTrackingMethodsQueryVariables>;
export const AllTranslationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allTranslations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"beta"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"inDatocms"}}]}}]}}]} as unknown as DocumentNode<AllTranslationsQuery, AllTranslationsQueryVariables>;
export const AllWebDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllWebData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAnnouncements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageDark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageSquare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allFooterLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"footerMenuItem"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"footerMenuItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allFooterMenus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allBlogBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"_status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAutoIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hidden"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"name_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allMenuItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmenuGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"borderRight"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmenuItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmenuSpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmenuGroupFullRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmenuItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentRight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubmenuItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"buttonHref"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabelRight"}},{"kind":"Field","name":{"kind":"Name","value":"buttonHrefRight"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"footerExtra"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"footerMenuItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FooterLinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]} as unknown as DocumentNode<AllWebDataQuery, AllWebDataQueryVariables>;
export const AuthorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Author"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"web"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_allReferencingBlogPosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorQuery, AuthorQueryVariables>;
export const AutoIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoIntegration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<AutoIntegrationQuery, AutoIntegrationQueryVariables>;
export const BlogCarouselDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BlogCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlogPostRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BlogCarouselQuery, BlogCarouselQueryVariables>;
export const BlogPostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BlogPost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"_createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_seoMetaTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redirect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<BlogPostQuery, BlogPostQueryVariables>;
export const ModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Modal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<ModalQuery, ModalQueryVariables>;
export const PageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Page"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"breadcrumbTitle"}},{"kind":"Field","name":{"kind":"Name","value":"parentPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"breadcrumbTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hideMenu"}},{"kind":"Field","name":{"kind":"Name","value":"hidePrimaryMenu"}},{"kind":"Field","name":{"kind":"Name","value":"disableLogoLink"}},{"kind":"Field","name":{"kind":"Name","value":"hideFooter"}},{"kind":"Field","name":{"kind":"Name","value":"disablePaddings"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mobileImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sidebar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebBannerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"ctaHref"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HubspotFormRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalId"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"testimonialBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamBlockTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamBlockMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobPosition"}},{"kind":"Field","name":{"kind":"Name","value":"linkedinProfileLink"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberImageHover"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AboutUsBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsIcons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconLinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompareProductRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compareProductTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compareProductDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"compareProductProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompareProductItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"blurUpThumb"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"compareProductImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComparisonTableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTableTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTableDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTableLastUpdated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTableContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tableRowRecord"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tableDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tableColumns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableColRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableHeaderRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tableRowRecord"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComparisonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonImageMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonOurImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonOurFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"listBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTheirImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTheirTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonTheirFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"listBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonCompareTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonCompetitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonCompetitorsNetwork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comparisonButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonButtonHref"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonButtonLabelNetwork"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonButtonHrefNetwork"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompareFeatureRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"compareFeatureTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hideFrom"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"featureOverride"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"noFreePlan"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureOverride"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AchievementBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"formBoxTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HubspotFormRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"portalId"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"feedbackBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formBoxContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlogSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"posts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlogPostRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturesSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featuresList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"comingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"boxContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogoHeaderRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"logoHeaderTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"buttonHref"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CarouselRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationCarouselRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thirdRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carouselButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageHeroRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"customTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"full"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentSection"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"headlineBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridContentRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gridCols"}},{"kind":"Field","name":{"kind":"Name","value":"gridContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HubspotRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portalId"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AchievementBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"videoBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disableLinks"}},{"kind":"Field","name":{"kind":"Name","value":"companyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"competitorBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usersBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"headlineBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridContentRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gridCols"}},{"kind":"Field","name":{"kind":"Name","value":"gridContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AchievementBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usersBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentSection"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HubspotRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portalId"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"videoBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disableLinks"}},{"kind":"Field","name":{"kind":"Name","value":"companyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"competitorBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageHeroContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCols"}},{"kind":"Field","name":{"kind":"Name","value":"bulletListContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentSection"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"headlineBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GridContentRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gridCols"}},{"kind":"Field","name":{"kind":"Name","value":"gridContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HubspotRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portalId"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AchievementBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"videoBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disableLinks"}},{"kind":"Field","name":{"kind":"Name","value":"companyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"competitorBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usersBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageHeaderRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pageHeaderTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"headerDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentImageSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contentTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompositeImageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"highlight"}},{"kind":"Field","name":{"kind":"Name","value":"togglePosition"}},{"kind":"Field","name":{"kind":"Name","value":"biggerHeadline"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentSection"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentSectionV2"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HighlightedBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"highlightedBoxTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bullets"}},{"kind":"Field","name":{"kind":"Name","value":"bottomImage"}},{"kind":"Field","name":{"kind":"Name","value":"wide"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"highlightedBoxContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"highlightedBoxContentTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RichTextRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"html"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TextRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showOutline"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"headlineBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulletListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"bulletListContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boxContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"faqList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaqItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"faqContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BannerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"bannerTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"button"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"videoBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"photoBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DynamicMegablockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoplay"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mp4Url"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalVideoRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"muxPlaybackId"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"blurUpThumb"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"redirect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"_status"}},{"kind":"Field","name":{"kind":"Name","value":"_firstPublishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_seoMetaTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schemaMarkup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"helpRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HelpRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"helpText"}},{"kind":"Field","name":{"kind":"Name","value":"helpTooltipText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tableCellRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableCellRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checked"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"desktopRowspan"}},{"kind":"Field","name":{"kind":"Name","value":"desktopSkip"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingPlanRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membershipPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfService"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonLabelLogged"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHref"}},{"kind":"Field","name":{"kind":"Name","value":"ctaButtonHrefLogged"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"customPriceTitleEur"}},{"kind":"Field","name":{"kind":"Name","value":"hideFrom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatePrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"buttonVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cta"}},{"kind":"Field","name":{"kind":"Name","value":"transparent"}},{"kind":"Field","name":{"kind":"Name","value":"arrow"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"inverseCaption"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","alias":{"kind":"Name","value":"buttonContent"},"name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBlank"}},{"kind":"Field","name":{"kind":"Name","value":"noScroll"}},{"kind":"Field","name":{"kind":"Name","value":"smallMarginTop"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"buttonsGroupBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ButtonsGroupRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"horizontal"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"linkBox"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"bulletListBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulletListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"multipleCols"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"bulletListContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"spacerBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"usersBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UsersBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"feedbackBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"compareBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompareBoxRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"compareContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disadvantage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advantage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"testimonialBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestimonialRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"listBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ListItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iconLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emojiIcon"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shopifyHidden"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"competitorBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"competitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompetitorRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentItemV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentItemV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"hoverEffect"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tableRowRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRowRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableHeaderRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"helpRecord"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableCellRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tableCellRecord"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"pricingBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricingBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupCompanies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"disableLinks"}},{"kind":"Field","name":{"kind":"Name","value":"companyContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caseStudyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonialAuthorImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonialAuthorName"}},{"kind":"Field","name":{"kind":"Name","value":"testimonialAuthorDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingGroupCompareTable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FullFeatureBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pricingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"featureOverride"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullComparisonTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullComparisonTitleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullComparisonContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FullComparisonRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tooltip"}},{"kind":"Field","name":{"kind":"Name","value":"tooltipContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"comingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"reverse"}},{"kind":"Field","name":{"kind":"Name","value":"itemsEnd"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"center"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extraImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anchorId"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sectionDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"linkBox"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewsBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TestimonialRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComboCtaRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bullets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"usersBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titleFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CarouselBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carouselFeedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"feedbackBlock"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"togglePosition"}},{"kind":"Field","name":{"kind":"Name","value":"badge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionExtraContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"bulletListBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"compareBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"testimonialBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackdeskBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackdeskContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"listBlock"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AchievementBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeaturesSectionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featuresList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AllIntegrationsBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"competitorBlock"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentToggleRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"optionA"}},{"kind":"Field","name":{"kind":"Name","value":"optionB"}},{"kind":"Field","name":{"kind":"Name","value":"contentA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentB"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tableContent"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationBlockRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegrationRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"headlineBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeadlineRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"section"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"videoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoplay"}},{"kind":"Field","name":{"kind":"Name","value":"showPlayIcon"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoEnd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentSectionV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentSectionV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiddenMobile"}},{"kind":"Field","name":{"kind":"Name","value":"preTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"BooleanValue","value":true}}]},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cssRgb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentItemsPerRow"}},{"kind":"Field","name":{"kind":"Name","value":"trimContentItems"}},{"kind":"Field","name":{"kind":"Name","value":"trimmedContentItemsButtonLabel"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionExtraContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"buttonsGroupBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"linkBox"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SpacerRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"spacerBlock"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContentItemV2Record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentItemV2"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"photoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoMobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageLink"}}]}}]} as unknown as DocumentNode<PageQuery, PageQueryVariables>;
export const PricingPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PricingPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipPlanId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricingPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"membershipPlanId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipPlanId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceEur"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceEur"}}]}}]}}]} as unknown as DocumentNode<PricingPlanQuery, PricingPlanQueryVariables>;
export const ReferralProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReferralProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralProgram"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signedupDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showOnlyForSignedUpUsers"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageAttrs"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageAttrs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"responsiveImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"srcSet"}},{"kind":"Field","name":{"kind":"Name","value":"webpSrcSet"}},{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"aspectRatio"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"bgColor"}}]}}]}}]} as unknown as DocumentNode<ReferralProgramQuery, ReferralProgramQueryVariables>;
export const RegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"company"}}]}}]}}]}}]} as unknown as DocumentNode<RegistrationQuery, RegistrationQueryVariables>;
export const RequestAssistanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RequestAssistance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestAssistance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modalTitle"}},{"kind":"Field","name":{"kind":"Name","value":"modalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<RequestAssistanceQuery, RequestAssistanceQueryVariables>;
export const TrackingMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrackingMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackingMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"activatedSlug"}},{"kind":"Field","name":{"kind":"Name","value":"info"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"stepsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"optionalConversionTypesTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"stepsFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"stepsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackingMethodStepRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaptionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"captionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccordionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccordionItemRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accordionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CaptionRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"captionContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"download"}},{"kind":"Field","name":{"kind":"Name","value":"manual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<TrackingMethodQuery, TrackingMethodQueryVariables>;
export const TranslationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Translation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_allReferencingCustomTenantTranslations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<TranslationQuery, TranslationQueryVariables>;